<template>
  <div id="app">
      <transition name="fade" mode="out-in">
            <router-view>
            </router-view>
      </transition>
  </div>
</template>

<script>
import { eventBus } from './main.js';

export default {
  name: 'app',
  components: {
  },

data: () => ({
    }),
created(){},
methods: {
            // preLoadMobile(){
            //       eventBus.$emit('eventBus'); 
            // },
      }
}
</script>

<style>
/* ALL SCREEN STYLING                      */
                  html, body {
                      margin:0px;
                      padding:0px;
                  }
                  @import url(https://fonts.googleapis.com/css?family=Fira+Sans);
                  #app{
                  font-family: Fira Sans, Arial;
                  font-weight: 300;
                  -webkit-font-smoothing: antialiased;
                  -moz-osx-font-smoothing: grayscale;
                  text-align: center;
                  text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.4);
                  margin:0px;
                  padding:0px;
                  }

                  body {
                    background-color: black;
                  }
                  #mattsDen{
                  margin-top: 800px;
                  background: white;
                  color:black;
                  }
                  .aboutHandle{
                  width: 1px;
                  height: 1px;      
                  }
                  .btn,
                  .btn:hover, 
                  .btn:focus, 
                  .btn:active, 
                  .btn:active, 
                  .btn:active:focus,
                  .btn:active:hover{
                  text-shadow: 0px 2px 2px rgba(0, 0, 0, 0.2);
                  border-radius: 6px;
                  outline:none !important;  
                  }
                  #masterTimingBadges{
                  text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.2);
                  border-radius: 6px;
                  }
                  #masterControlBadges{
                  text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.2);      
                  }
                  #ambienceBtns{
                  text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.2);           
                  }
                  #hornBtn{
                  border-radius: 20px;      
                  }
                  button:focus {outline:none !important;}
                  input:focus {outline:none !important;}
/* COLOR VARIABLES                         */
                  :root {
                  --main-v1-color: #73BAFC;
                  }
                  :root {
                  --main-v2-color: #1E9BFC;
                  }
                  :root {
                  --main-v3-color: #0E70DA;
                  }
                  :root {
                  --main-v4-color: #0D58F0;
                  }
                  :root {
                  --main-sun-color: #F3EFEE;
                  }
                  :root {
                  --main-time-color: white;
                  }
                  :root {
                  --main-heading-color: #F0CB50;
                  }
                  :root {
                  --main-heading2-color: #78B5D9;
                  }
                  :root {
                  --main-start-color: #3FE72A;
                  }
                  :root {
                  --main-stop-color: #FF5C4A;
                  }
                  :root {
                  --main-guide-color: transparent;
                  }
                  :root {
                  --main-border-color: 4px solid transparent;
                  }
/** STYLINGS FOR VERY SMALL SCREENS < 350px */
      @media (min-width: 0px)  and (max-width: 349px) {
                  #mainDiv{
                  padding-right: 0px;
                  padding-left: 0px;
                  max-width: 2000px;   
                  }
                  #hornBtn{
                  width: 170px; 
                  height: 30px;
                  margin-top: 0px;
                  }
                  #hornBtnPrompt{
                  margin-top: 0px;
                  color: white;
                  font-size: 11px;
                  }
            /* PROMPT                      */
                  #promptText{
                  margin: auto;
                  max-width: 250px;
                  margin-top: 80px;
                  font-size: 12px;
                  color:white;      
                  }
                  #promptButton{
                  margin-top: 5px;
                  margin-bottom: 10px;
                  font-size: 12px;
                  color:white;
                  }
            /* WELCOME                     */
                  #welcomeInfoText{
                  margin-top: 50px;
                  font-size: 30px;
                  color: black;
                  font-weight: 700;
                  }
                  #welcomeMobileText{
                  color: black;
                  font-size: 18px;
                  font-weight: 700;
                  }
                  #playButton{
                  color:  white;
                  background-color:  var(--main-heading-color);
                  margin-top: 20px;
                  font-size: 20px;
                  border-width: 1px;
                  }
                  #bell{
                  color: var(--main-v1-color);      
                  }
            /* HEADINGS                    */
                  #navBar{
                  margin-top: -290px;
                  }
                  #harmonizeHeading{
                  font-size: 16px;
                  font-weight: 700;
                  margin-top: 0px;
                  margin-bottom: 0px;
                  padding: 4px 0px;
                  width: 120px;
                  border-radius: 4px;      
                  }
                  #cuteBtn{
                  font-size: 16px;
                  margin-top: 0px;
                  margin-bottom: 0px;
                  padding: 4px 0px;
                  width: 32px;
                  border-radius: 32px; 
                  }
                  #ambienceHeading{
                  font-size: 16px;
                  font-weight: 700;
                  margin-top: 0px;
                  margin-bottom: 0px;
                  padding: 4px 0px;
                  width: 120px;
                  border-radius: 4px;  
                  }
                  #harmonyHeadingDiv{
                 /* width: 100%;
                  content: '\A';
                  white-space: pre;*/
                  }
                  #helpHeadingDiv{
                  /*width: 0%;
                  content: '\A';
                  white-space: pre;
                  margin-top: -36px;*/
                  }
                  #ambianceHeadingDiv{
                 /* width: 100%;
                  content: '\A';
                  white-space: pre;
                  margin-top: 10px;*/
                  }
            /* DRAGGIE CONTAINER           */
                  .masterDraggie{
                  margin-top: 100px;
                  margin-bottom: 0px;
                  width: 100%;
                  height: 100%;
                  }
                  .draggieContainer{
                  padding: 50px 100px;
                  border: 5px dotted var(--main-guide-color);
                  height: 200px;
                  width: 100px;
                  margin: auto;
                  /*width: 700px;
                  height: 600px;
                  margin-top: -200px;
                  margin-left: 800px;
                  background: transparent;
                  border-radius: 500px;
                  position: relative;*/
                  }
            /* ALL VOICE TAGS              */
                  #voiceBubbleText{
                  color:black;
                  margin-top: 22%;
                  }
                  #voiceBubbleText2{
                  color: white;
                  font-weight: 800;
                  margin-top: -10px;
                  }
            /* VOICE 1 DRAGGIE             */
                  .voice1Draggable{  
                  border-radius: 100px;
                  position: absolute;
                  background: var(--main-v1-color);
                  color: black;
                  }

                  .voice1Sizing1{
                  width: 100px;
                  height: 100px; 
                  opacity: 1;    
                  font-size: 14px; 
                  }

                  .voice1Sizing2{
                  width: 95px;
                  height: 95px; 
                  opacity: 0.95; 
                  font-size: 14px;    
                  }

                  .voice1Sizing3{
                  width: 90px;
                  height: 90px;
                  opacity: 0.9;  
                  font-size: 13px;    
                  }

                  .voice1Sizing4{
                  width: 85px;
                  height: 85px;
                  opacity: 0.85;  
                  font-size: 12px;    
                  }

                  .voice1Sizing5{
                  width: 80px;
                  height: 80px; 
                  opacity: 0.8;   
                  font-size: 11px;  
                  }

                  .voice1Sizing6{
                  width: 75px;
                  height: 75px; 
                  opacity: 0.75; 
                  font-size: 10px;    
                  }

                  .voice1Sizing7{
                  width: 70px;
                  height: 70px; 
                  opacity: 0.7;  
                  font-size: 9px;   
                  }

                  .voice1Sizing8{
                  width: 65px;
                  height: 65px; 
                  opacity: 0.65; 
                  font-size: 8px;    
                  }

                  .voice1Sizing9{
                  width: 60px;
                  height: 60px; 
                  opacity: 0.6;     
                  font-size: 7px;
                  }

                  .voice1Sizing10{
                  width: 55px;
                  height: 55px; 
                  opacity: 0.55;   
                  font-size: 6px;  
                  }  

                  .voice1Sizing11{
                  width: 50px;
                  height: 50px; 
                  opacity: .5;     
                  font-size: 5px;
                  }

                  .voice1Sizing12{
                  width: 45px;
                  height: 45px; 
                  opacity: 0.45;   
                  font-size: 4px;  
                  }

                  .voice1Sizing13{
                  width: 40px;
                  height: 40px;
                  opacity: 0.4;    
                  font-size: 3px;  
                  }

                  .voice1Sizing14{
                  width: 35px;
                  height: 35px;
                  opacity: 0.35;   
                  font-size: 2px;   
                  }

                  .voice1Sizing15{
                  width: 30px;
                  height: 30px; 
                  opacity: 0.3;    
                  font-size: 1px; 
                  }

                  .voice1Sizing16{
                  width: 25px;
                  height: 25px; 
                  opacity: 0.25;   
                  font-size: 1px;  
                  }

                  .voice1Sizing17{
                  width: 20px;
                  height: 20px; 
                  opacity: 0.2;     
                  font-size: 1px;
                  }

                  .voice1Sizing18{
                  width: 20px;
                  height: 20px; 
                  opacity: 0.15;     
                  font-size: 1px;
                  }

                  .voice1Sizing19{
                  width: 20px;
                  height: 20px; 
                  opacity: 0.1;     
                  font-size: 1px;
                  }

                  .voice1Sizing20{
                  width: 20px;
                  height: 20px; 
                  opacity: 0.05;     
                  font-size: 1px;
                  }

                  .voice1Draggable.is-dragging { opacity: 1; }
            /* VOICE 2 DRAGGIE             */
                  .voice2Draggable {
                  border-radius: 100px;
                  position: absolute;
                  background: var(--main-v2-color);
                  color: black;
                  }

                  .voice2Sizing1{
                  width: 100px;
                  height: 100px; 
                  opacity: 1;    
                  font-size: 14px; 
                  }

                  .voice2Sizing2{
                  width: 95px;
                  height: 95px; 
                  opacity: 0.95; 
                  font-size: 14px;    
                  }

                  .voice2Sizing3{
                  width: 90px;
                  height: 90px;
                  opacity: 0.9;  
                  font-size: 13px;    
                  }

                  .voice2Sizing4{
                  width: 85px;
                  height: 85px;
                  opacity: 0.85;  
                  font-size: 12px;    
                  }

                  .voice2Sizing5{
                  width: 80px;
                  height: 80px; 
                  opacity: 0.8;   
                  font-size: 11px;  
                  }

                  .voice2Sizing6{
                  width: 75px;
                  height: 75px; 
                  opacity: 0.75; 
                  font-size: 10px;    
                  }

                  .voice2Sizing7{
                  width: 70px;
                  height: 70px; 
                  opacity: 0.7;  
                  font-size: 9px;   
                  }

                  .voice2Sizing8{
                  width: 65px;
                  height: 65px; 
                  opacity: 0.65; 
                  font-size: 8px;    
                  }

                  .voice2Sizing9{
                  width: 60px;
                  height: 60px; 
                  opacity: 0.6;     
                  font-size: 7px;
                  }

                  .voice2Sizing10{
                  width: 55px;
                  height: 55px; 
                  opacity: 0.55;   
                  font-size: 6px;  
                  }  

                  .voice2Sizing11{
                  width: 50px;
                  height: 50px; 
                  opacity: .5;     
                  font-size: 5px;
                  }

                  .voice2Sizing12{
                  width: 45px;
                  height: 45px; 
                  opacity: 0.45;   
                  font-size: 4px;  
                  }

                  .voice2Sizing13{
                  width: 40px;
                  height: 40px;
                  opacity: 0.4;    
                  font-size: 3px;  
                  }

                  .voice2Sizing14{
                  width: 35px;
                  height: 35px;
                  opacity: 0.35;   
                  font-size: 2px;   
                  }

                  .voice2Sizing15{
                  width: 30px;
                  height: 30px; 
                  opacity: 0.3;    
                  font-size: 1px; 
                  }

                  .voice2Sizing16{
                  width: 25px;
                  height: 25px; 
                  opacity: 0.25;   
                  font-size: 1px;  
                  }

                  .voice2Sizing17{
                  width: 20px;
                  height: 20px; 
                  opacity: 0.2;     
                  font-size: 1px;
                  }

                  .voice2Sizing18{
                  width: 20px;
                  height: 20px; 
                  opacity: 0.15;     
                  font-size: 1px;
                  }

                  .voice2Sizing19{
                  width: 20px;
                  height: 20px; 
                  opacity: 0.1;     
                  font-size: 1px;
                  }

                  .voice2Sizing20{
                  width: 20px;
                  height: 20px; 
                  opacity: 0.05;     
                  font-size: 1px;
                  }

                  
                  .voice2Draggable.is-dragging { opacity: 1; }
            /* VOICE 3 DRAGGIE             */
                  .voice3Draggable {
                  border-radius: 100px;
                  position: absolute;
                  background: var(--main-v3-color);
                  color: black;
                  }

                  .voice3Sizing1{
                  width: 100px;
                  height: 100px; 
                  opacity: 1;    
                  font-size: 14px; 
                  }

                  .voice3Sizing2{
                  width: 95px;
                  height: 95px; 
                  opacity: 0.95; 
                  font-size: 14px;    
                  }

                  .voice3Sizing3{
                  width: 90px;
                  height: 90px;
                  opacity: 0.9;  
                  font-size: 13px;    
                  }

                  .voice3Sizing4{
                  width: 85px;
                  height: 85px;
                  opacity: 0.85;  
                  font-size: 12px;    
                  }

                  .voice3Sizing5{
                  width: 80px;
                  height: 80px; 
                  opacity: 0.8;   
                  font-size: 11px;  
                  }

                  .voice3Sizing6{
                  width: 75px;
                  height: 75px; 
                  opacity: 0.75; 
                  font-size: 10px;    
                  }

                  .voice3Sizing7{
                  width: 70px;
                  height: 70px; 
                  opacity: 0.7;  
                  font-size: 9px;   
                  }

                  .voice3Sizing8{
                  width: 65px;
                  height: 65px; 
                  opacity: 0.65; 
                  font-size: 8px;    
                  }

                  .voice3Sizing9{
                  width: 60px;
                  height: 60px; 
                  opacity: 0.6;     
                  font-size: 7px;
                  }

                  .voice3Sizing10{
                  width: 55px;
                  height: 55px; 
                  opacity: 0.55;   
                  font-size: 6px;  
                  }  

                  .voice3Sizing11{
                  width: 50px;
                  height: 50px; 
                  opacity: .5;     
                  font-size: 5px;
                  }

                  .voice3Sizing12{
                  width: 45px;
                  height: 45px; 
                  opacity: 0.45;   
                  font-size: 4px;  
                  }

                  .voice3Sizing13{
                  width: 40px;
                  height: 40px;
                  opacity: 0.4;    
                  font-size: 3px;  
                  }

                  .voice3Sizing14{
                  width: 35px;
                  height: 35px;
                  opacity: 0.35;   
                  font-size: 2px;   
                  }

                  .voice3Sizing15{
                  width: 30px;
                  height: 30px; 
                  opacity: 0.3;    
                  font-size: 1px; 
                  }

                  .voice3Sizing16{
                  width: 25px;
                  height: 25px; 
                  opacity: 0.25;   
                  font-size: 1px;  
                  }

                  .voice3Sizing17{
                  width: 20px;
                  height: 20px; 
                  opacity: 0.2;     
                  font-size: 1px;
                  }

                  .voice3Sizing18{
                  width: 20px;
                  height: 20px; 
                  opacity: 0.15;     
                  font-size: 1px;
                  }

                  .voice3Sizing19{
                  width: 20px;
                  height: 20px; 
                  opacity: 0.1;     
                  font-size: 1px;
                  }

                  .voice3Sizing20{
                  width: 20px;
                  height: 20px; 
                  opacity: 0.05;     
                  font-size: 1px;
                  }

                  .voice3Draggable.is-dragging { opacity: 1; }
            /* VOICE 4 DRAGGIE             */
                  .voice4Draggable {
                  border-radius: 100px;
                  position: absolute;
                  background: var(--main-v4-color);
                  color: black;
                  }

                  .voice4Sizing1{
                  width: 100px;
                  height: 100px; 
                  opacity: 1;    
                  font-size: 14px; 
                  }

                  .voice4Sizing2{
                  width: 95px;
                  height: 95px; 
                  opacity: 0.95; 
                  font-size: 14px;    
                  }

                  .voice4Sizing3{
                  width: 90px;
                  height: 90px;
                  opacity: 0.9;  
                  font-size: 13px;    
                  }

                  .voice4Sizing4{
                  width: 85px;
                  height: 85px;
                  opacity: 0.85;  
                  font-size: 12px;    
                  }

                  .voice4Sizing5{
                  width: 80px;
                  height: 80px; 
                  opacity: 0.8;   
                  font-size: 11px;  
                  }

                  .voice4Sizing6{
                  width: 75px;
                  height: 75px; 
                  opacity: 0.75; 
                  font-size: 10px;    
                  }

                  .voice4Sizing7{
                  width: 70px;
                  height: 70px; 
                  opacity: 0.7;  
                  font-size: 9px;   
                  }

                  .voice4Sizing8{
                  width: 65px;
                  height: 65px; 
                  opacity: 0.65; 
                  font-size: 8px;    
                  }

                  .voice4Sizing9{
                  width: 60px;
                  height: 60px; 
                  opacity: 0.6;     
                  font-size: 7px;
                  }

                  .voice4Sizing10{
                  width: 55px;
                  height: 55px; 
                  opacity: 0.55;   
                  font-size: 6px;  
                  }  

                  .voice4Sizing11{
                  width: 50px;
                  height: 50px; 
                  opacity: .5;     
                  font-size: 5px;
                  }

                  .voice4Sizing12{
                  width: 45px;
                  height: 45px; 
                  opacity: 0.45;   
                  font-size: 4px;  
                  }

                  .voice4Sizing13{
                  width: 40px;
                  height: 40px;
                  opacity: 0.4;    
                  font-size: 3px;  
                  }

                  .voice4Sizing14{
                  width: 35px;
                  height: 35px;
                  opacity: 0.35;   
                  font-size: 2px;   
                  }

                  .voice4Sizing15{
                  width: 30px;
                  height: 30px; 
                  opacity: 0.3;    
                  font-size: 1px; 
                  }

                  .voice4Sizing16{
                  width: 25px;
                  height: 25px; 
                  opacity: 0.25;   
                  font-size: 1px;  
                  }

                  .voice4Sizing17{
                  width: 20px;
                  height: 20px; 
                  opacity: 0.2;     
                  font-size: 1px;
                  }

                  .voice4Sizing18{
                  width: 20px;
                  height: 20px; 
                  opacity: 0.15;     
                  font-size: 1px;
                  }

                  .voice4Sizing19{
                  width: 20px;
                  height: 20px; 
                  opacity: 0.1;     
                  font-size: 1px;
                  }

                  .voice4Sizing20{
                  width: 20px;
                  height: 20px; 
                  opacity: 0.05;     
                  font-size: 1px;
                  }

                  
                  .voice4Draggable.is-dragging { opacity: 1; }
            /* ABOUT DRAGGIE               */
                  .aboutDraggable{  
                  width: 200px;
                  height: 200px;
                  border-radius: 275px;
                  background: white;
                  opacity: 1;
                  color: black;
                  position: absolute;
                  font-size: 50px;
                  border: var(--main-border-color);
                  }
                  #createdByHeader{
                  font-size: 18px;
                  margin-top: 20px;
                  font-weight: 600;      
                  }
                  #aboutTextID{
                  font-size: 18px;
                  margin-top: 10px;
                  font-weight: 400;
                  }
                  #newINC{
                  margin-top: -5px;
                  font-size: 14px;  
                  margin-bottom: -25px;    
                  }
                  .about2Draggable{  
                  width: 250px;
                  height: 250px;
                  border-radius: 300px;
                  background: white;
                  opacity: 1;
                  color: black;
                  position: absolute;
                  font-size: 50px;
                  border: var(--main-border-color);
                  }
                  #about2TextID{
                  max-width: 200px;
                  margin: auto;
                  font-size: 18px;
                  margin-top: 15px;
                  font-weight: 600;  
                  }
                  #about2TextID1{
                  font-size: 13px;
                  margin-top: 15px; 
                  text-align: left;
                  margin-left: 40px;     
                  }
                  .about3Draggable{  
                  width: 325px;
                  height: 325px;
                  border-radius: 325px;
                  background: white;
                  opacity: 1;
                  color: black;
                  position: absolute;
                  font-size: 50px;
                  border: var(--main-border-color);
                  }
                  #about3TextHeader{
                  font-size: 22px;
                  max-width: 255px;
                  margin: auto;
                  margin-top: 20px; 
                  font-weight: 600;       
                  }
                  #about3TextID{
                  font-size: 12px;
                  max-width: 255px;
                  margin: auto;
                  margin-top: 20px;
                  }
                  .about4Draggable{  
                  width: 250px;
                  height: 250px;
                  border-radius: 400px;
                  opacity: 1;
                  color: black;
                  position: absolute;
                  font-size: 50px;
                  background: white;
                  }
            /* PLAY SUN DRAGGIE            */
                  #sunLoadText1{
                  font-size: 18px;
                  margin-top: 42px;
                  font-weight: 700;      
                  }
                  #sunLoadText2{
                  font-size: 8px;
                  margin-top: -10px;
                  font-weight: 700;       
                  }
                  #sunTextID{
                  font-size: 10px;
                  margin-top: 38px;
                  font-weight: 700;
                  }
                  #sunTextID2{
                  font-size: 7px;
                  margin-top: -10px;
                  font-weight: 700;      
                  }
                  #togetherText{
                  font-size: 15px;
                  margin-top: -15px;
                  font-weight: 700;      
                  }
                  .playSunDraggable {
                  width: 100px;
                  height: 100px;
                  color: black;
                  background: white;
                  border-radius: 100px;
                  opacity: 1;
                  position: absolute;
                  }
                  .playSunDraggable.is-pointer-down {
                  opacity: 1;
                  }
                  .playSunDraggable.is-dragging { 
                  opacity: 1;
                  }
            /* REVERB COLORING             */
                  .reverbSizing1{
                  background: #000000;
                  /*width: 100%;
                  height: 100%;*/
                  }

                  .reverbSizing2{
                  background: #101010;
                  /*opacity: .95; */
                  }

                  .reverbSizing3{
                  background: #202020;
                  /*opacity: 0.9; */
                  }

                  .reverbSizing4{
                  background: #282828;
                  /*opacity: 0.85;  */
                  }

                  .reverbSizing5{
                  background: #303030; 
                  /*opacity: 0.8;  */
                  }

                  .reverbSizing6{
                  background: #383838;
                  /*opacity*/: 0.75; 
                  }

                  .reverbSizing7{
                  background: #484848;
                  /*opacity*/: 0.7; 
                  }

                  .reverbSizing8{
                  background: #585858;
                  /*opacity*/: 0.65; 
                  }

                  .reverbSizing9{
                  background: #696969;
                  /*opacity*/: 0.6;    
                  }

                  .reverbSizing10{
                  background: #808080;
                  /*opacity*/: 0.55; 
                  }  

                  .reverbSizing11{
                  background: #909090; 
                  /*opacity*/: 0.5;   
                  }

                  .reverbSizing12{
                  background: #A0A0A0;
                  /*opacity*/: 0.45; 
                  }

                  .reverbSizing13{
                  background: #A9A9A9;
                  /*opacity*/: 0.4; 
                  }

                  .reverbSizing14{
                  background: #B8B8B8;
                  /*opacity*/: 0.35; 
                  }

                  .reverbSizing15{
                  background: #C0C0C0;
                  /*opacity*/: 0.3; 
                  }

                  .reverbSizing16{
                  background: #D3D3D3;
                  /*opacity: 0.25; */
                  }

                  .reverbSizing17{
                  background: #DCDCDC;
                  /*opacity: 0.2;     */
                  }

                  .reverbSizing18{
                  background: #E8E8E8;
                  /*opacity: 0.15; */
                  }

                  .reverbSizing19{
                  background: #F5F5F5;
                  /*opacity: 0.1; */
                  }

                  .reverbSizing20{
                  background: #FFFFFF;
                 /* opacity: 0.05; */ 
                  }
            /* MISSON CONTROL              */
                  #controlsContainer{
                  max-width: 400px;
                  margin: auto;
                  margin-top: 50px;
                  margin-bottom: 0px;
                  height: 500px;
                  }
                  #masterControlDiv{
                  margin-top: 20px;
                  margin-left: -12px;
                  margin-bottom: 300px;
                  max-width: 1500px;
                  }
                  #masterControlBadges{
                  padding: 8px 8px;
                  font-size: 14px;
                  font-weight: 700;
                  width: 130px;
                  color: black; 
                  border: 2px solid black;
                  }
                  #masterTimingBadges{
                  padding: 8px 8px;
                  font-size: 14px;
                  font-weight: 700;
                  background-color: var(--main-time-color);
                  color: black; 
                  width: 130px;
                  border: 2px solid black;
                  }
                  #voice1SliderDiv{
                  width: 50%;
                  content: '\A';
                  white-space: pre;     
                  }
                  #voice2SliderDiv{
                  width: 50%;
                  content: '\A';
                  white-space: pre;      
                  }
                  #voice3SliderDiv{
                  margin-top: 20px;
                  width: 50%;
                  content: '\A';
                  white-space: pre;      
                  }
                  #voice4SliderDiv{
                  margin-top: 20px;
                  width: 50%;
                  content: '\A';
                  white-space: pre;      
                  }
                  #timingSliderDiv{
                  margin-top: 20px;
                  width: 50%;
                  content: '\A';
                  white-space: pre;
                  }
                  #daySliderDiv{
                  width: 50%;
                  content: '\A';
                  white-space: pre; 
                  margin-top: 20px;
                  }
                  #sliders1{
                  margin-top: 20px;
                  }
                  #sliders2{
                  margin-top: 20px;
                  }
                  #sliders3{
                  margin-top: 20px;
                  }
                  #sliders4{
                  margin-top: 20px;
                  }
                  #sliders5{
                  margin-top: 20px;
                  }
                  #slidersTiming{
                  margin-top: 20px;      
                  }
            /* BADGES                      */
                  .voice1Badge{
                  background: var(--main-heading-color);
                  color: black;
                  }
                  .voice2Badge{
                  background: var(--main-heading-color);
                  color: black;   
                  }
                  .voice3Badge{
                  background: var(--main-heading-color);
                  color: black;     
                  }
                  .voice4Badge{
                  background: var(--main-heading-color);
                  color: black; 
                  }
            /* AMBIANCE BUTTONS            */
                  #ambienceBtnLocation{
                  max-width: 400px;
                  margin: auto;
                  margin-top: 0px;
                  margin-bottom: 0px;
                  }
                  #ambienceBtns{
                  width: 125px;
                  border-radius: 4px;
                  font-size: 12px;
                  font-weight: 700;      
                  }
                  #ambienceBtn1Div{
                  width: 50%;
                  content: '\A';
                  white-space: pre;
                  margin-bottom: 20px;
                  }
                  #ambienceBtn2Div{
                  width: 50%;
                  content: '\A';
                  white-space: pre;
                  margin-bottom: 20px;
                  }
                  #ambienceBtn3Div{
                  width: 50%;
                  content: '\A';
                  white-space: pre;
                  }
                  #ambienceBtn4Div{
                  width: 50%;
                  content: '\A';
                  white-space: pre;
                  }
                  #ambienceHornDiv{
                  width: 50%;
                  content: '\A';
                  white-space: pre; 
                  margin-top: 30px;     
                  }
                  #ambienceNoiseDiv{
                  width: 50%;
                  content: '\A';
                  white-space: pre; 
                  margin-top: 30px;      
                  }
                  #ambienceSlider{
                  margin-top: 20px;
                  marker-left: 20px;
                  }
                  #ambienceBadges{
                  font-size: 22px;
                  background-color:var(--main-time-color);
                  color: black; 
                  }
            /* INSTRUMENT 1 RANGER         */
                  input[class="instrument1Ranger"] {
                  -webkit-appearance: none;
                  background: var(--main-heading-color);
                  height: 10px;
                  width: 130px;
                  border-radius: 20px;
                  margin: auto;
                  transform: rotateY(180deg);
                  }
                  input[class="instrument1Ranger"]::-moz-range-track{
                  -webkit-appearance: none;
                  background: var(--main-heading-color);
                  height: 10px;
                  width: 130px;
                  border-radius: 20px;
                  margin: auto;
                  transform: rotateY(180deg);
                  }
                  input[class="instrument1Ranger"]::-webkit-slider-thumb{
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-heading-color);
                  border: 2px solid #00001E;
                  }

                  input[class="instrument1Ranger"]::-moz-range-thumb{
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-heading-color);
                  border: 2px solid #00001E;
                  }
            /* INSTRUMENT 2 RANGER         */
                  input[class="instrument2Ranger"] {
                  -webkit-appearance: none;
                  background: var(--main-heading-color);
                  height: 10px;
                  width: 130px;
                  border-radius: 20px;
                  margin: auto;
                  transform: rotateY(180deg);
                  }
                  input[class="instrument2Ranger"]::-moz-range-track{
                  -webkit-appearance: none;
                  background: var(--main-heading-color);
                  height: 10px;
                  width: 130px;
                  border-radius: 20px;
                  margin: auto;
                  transform: rotateY(180deg);
                  }
                  input[class="instrument2Ranger"]::-webkit-slider-thumb {
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-heading-color);
                  border: 2px solid #00001E;
                  }
                  input[class="instrument2Ranger"]::-moz-range-thumb{
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-heading-color);
                  border: 2px solid #00001E;
                  }
            /* INSTRUMENT 3 RANGER         */
                  input[class="instrument3Ranger"] {
                  -webkit-appearance: none;
                  background: var(--main-heading-color);
                  height: 10px;
                  width: 130px;
                  border-radius: 20px;
                  margin: auto;
                  transform: rotateY(180deg);
                  }
                  input[class="instrument3Ranger"]::-moz-range-track{
                  -webkit-appearance: none;
                  background: var(--main-heading-color);
                  height: 10px;
                  width: 130px;
                  border-radius: 20px;
                  margin: auto;
                  transform: rotateY(180deg);
                  }
                  input[class="instrument3Ranger"]::-webkit-slider-thumb {
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-heading-color);
                  border: 2px solid #00001E;
                  }
                  input[class="instrument3Ranger"]::-moz-range-thumb{
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-heading-color);
                  border: 2px solid #00001E;
                  }
            /* INSTRUMENT 4 RANGER         */
                  input[class="instrument4Ranger"] {
                  -webkit-appearance: none;
                  background: var(--main-heading-color);
                  height: 10px;
                  width: 130px;
                  border-radius: 20px;
                  margin: auto;
                  transform: rotateY(180deg);
                  }
                  input[class="instrument4Ranger"]::-moz-range-track{
                  -webkit-appearance: none;
                  background: var(--main-heading-color);
                  height: 10px;
                  width: 130px;
                  border-radius: 20px;
                  margin: auto;
                  transform: rotateY(180deg);
                  }
                  input[class="instrument4Ranger"]::-webkit-slider-thumb {
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-heading-color);
                  border: 2px solid #00001E;
                  }
                  input[class="instrument4Ranger"]::-moz-range-thumb{
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-heading-color);
                  border: 2px solid #00001E;
                  }
            /* TIMING RANGER               */
                  input[class="timingRanger"] {
                  -webkit-appearance: none;
                  background-color: var(--main-sun-color);
                  height: 10px;
                  width: 130px;
                  border-radius: 20px;
                  margin: auto;
                  }

                  input[class="timingRanger"]::-webkit-slider-thumb {
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-sun-color);
                  border: 2px solid #00001E;
                  }

                  input[class="timingRanger"]::-moz-range-track{
                  -webkit-appearance: none;
                  background-color: var(--main-sun-color);
                  height: 10px;
                  width: 130px;
                  border-radius: 20px;
                  margin: auto;
                  }

                  input[class="timingRanger"]::-moz-range-thumb{
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-sun-color);
                  border: 2px solid #00001E;
                  }
            /* DAY RANGER                  */
                  input[class="dayRanger"] {
                  -webkit-appearance: none;
                  background-color: var(--main-time-color);
                  height: 10px;
                  width: 130px;
                  border-radius: 20px;
                  margin: auto;
                  }

                  input[class="dayRanger"]::-webkit-slider-thumb {
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-time-color);
                  border: 2px solid #00001E;
                  }

                  input[class="dayRanger"]::-moz-range-track{
                  -webkit-appearance: none;
                  background-color: var(--main-time-color);
                  height: 10px;
                  width: 130px;
                  border-radius: 20px;
                  margin: auto;
                  }

                  input[class="dayRanger"]::-moz-range-thumb{
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-time-color);
                  border: 2px solid #00001E;
                  }
            /* AMBIANCE RANGER STOPPED     */
                  input[class="ambianceRangerStop"] {
                  -webkit-appearance: none;
                  background-color: var(--main-stop-color);
                  height: 10px;
                  width: 130px;
                  border-radius: 20px;
                  margin: auto;
                  }

                  input[class="ambianceRangerStop"]::-webkit-slider-thumb {
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-stop-color);
                  border: 2px solid #00001E;
                  }
                  input[class="ambianceRangerStop"]::-moz-range-track{
                  -webkit-appearance: none;
                  background-color: var(--main-stop-color);
                  height: 10px;
                  width: 130px;
                  border-radius: 20px;
                  margin: auto;
                  }
                  input[class="ambianceRangerStop"]::-moz-range-thumb{
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-stop-color);
                  border: 2px solid #00001E;
                  }
            /* AMBIANCE RANGER PLAYING     */
                  input[class="ambianceRangerPlay"] {
                  -webkit-appearance: none;
                  background-color: var(--main-start-color);
                  height: 10px;
                  width: 130px;
                  border-radius: 20px;
                  margin: auto;
                  }

                  input[class="ambianceRangerPlay"]::-webkit-slider-thumb {
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-start-color);
                  border: 2px solid #00001E;
                  }  

                  input[class="ambianceRangerPlay"]::-moz-range-track{
                  -webkit-appearance: none;
                  background-color: var(--main-start-color);
                  height: 10px;
                  width: 130px;
                  border-radius: 20px;
                  margin: auto;
                  }

                  input[class="ambianceRangerPlay"]::-moz-range-thumb{
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-start-color);
                  border: 2px solid #00001E;
                  }    
            /* MAILING LIST                */
                  #mailingListText{
                  margin: auto;
                  max-width: 150px;
                  margin-top: 85px;
                  margin-bottom: 0px;
                  font-size: 12px;    
                  font-weight: 600;  
                  }
                  #mc_embed_signup{
                  background:#fff; 
                  font-size:12px; 
                  width:100%;
                  border-color: black;
                  background-color: transparent;
                  }
                  #mce-EMAIL{
                  font-size:12px; 
                  padding: 4px 10px;
                  margin-top: 0px;  
                  font-weight: 800;
                  width: 190px;
                  border-width: 2px;
                  border-radius: 10px;
                  background-color: transparent;
                  border-color: black;
                  }
                  #mc-embedded-subscribe{
                  font-size:12px; 
                  padding: 2px 10px;
                  margin-top: 4px;
                  font-weight: 800;
                  border-width: 2px;
                  border-radius: 10px;
                  background-color: transparent;
                  border-color: black;
                  }
      }
/** STYLINGS FOR SMALLER SCREENS < 600px   */
      @media (min-width: 350px) and (max-width: 576px) {
                  #mainDiv{
                  padding-right: 0px;
                  padding-left: 0px;
                  max-width: 2000px;   
                  }
                  #hornBtn{
                  width: 240px; 
                  height: 40px;
                  margin-top: 5px;
                  }
                  #hornBtnPrompt{
                  margin-top: 1px;
                  color: white;
                  font-size: 16px;
                  }
            /* PROMPT                      */
                  #promptText{
                  margin: auto;
                  max-width: 250px;
                  margin-top: 50px;
                  font-size: 14px;
                  color:white;      
                  }
                  #promptButton{
                  margin-top: 5px;
                  margin-bottom: 10px;
                  font-size: 14px;
                  color:white;
                  }
            /* WELCOME                     */
                  #welcomeInfoText{
                  margin-top: 50px;
                  font-size: 30px;
                  color: black;
                  font-weight: 700;
                  }
                  #welcomeMobileText{
                  color: black;
                  font-size: 18px;
                  font-weight: 700;
                  }
                  #playButton{
                  color:  white;
                  background-color:  var(--main-heading-color);
                  margin-top: 20px;
                  font-size: 20px;
                  border-width: 1px;
                  }
                  #bell{
                  color: var(--main-v1-color);      
                  }
            /* HEADINGS                    */
                  #navBar{
                  margin-top: -330px;
                  }
                  #harmonizeHeading{
                  font-size: 18px;
                  font-weight: 700;
                  margin-top: 0px;
                  margin-bottom: 0px;
                  padding: 4px 0px;
                  width: 150px;
                  border-radius: 4px;      
                  }
                  #cuteBtn{
                  font-size: 18px;
                  margin-top: 0px;
                  margin-bottom: 0px;
                  padding: 4px 0px;
                  width: 35px;
                  border-radius: 35px; 
                  }
                  #ambienceHeading{
                  font-size: 18px;
                  font-weight: 700;
                  margin-top: 0px;
                  margin-bottom: 0px;
                  padding: 4px 0px;
                  width: 150px;
                  border-radius: 4px;  
                  }
                  #harmonyHeadingDiv{
                 /* width: 100%;
                  content: '\A';
                  white-space: pre;*/
                  }
                  #helpHeadingDiv{
                  /*width: 0%;
                  content: '\A';
                  white-space: pre;
                  margin-top: -36px;*/
                  }
                  #ambianceHeadingDiv{
                 /* width: 100%;
                  content: '\A';
                  white-space: pre;
                  margin-top: 10px;*/
                  }
            /* DRAGGIE CONTAINER           */
                  .masterDraggie{
                  margin-top: 100px;
                  margin-bottom: 0px;
                  width: 100%;
                  height: 100%;
                  }
                  .draggieContainer{
                  padding: 50px 100px;
                  border: 5px dotted var(--main-guide-color);
                  height: 250px;
                  width: 100px;
                  margin: auto;
                  /*width: 700px;
                  height: 600px;
                  margin-top: -200px;
                  margin-left: 800px;
                  background: transparent;
                  border-radius: 500px;
                  position: relative;*/
                  }
            /* ALL VOICE TAGS              */
                  #voiceBubbleText{
                  color:black;
                  margin-top: 22%;
                  }
                  #voiceBubbleText2{
                  color: white;
                  font-weight: 800;
                  margin-top: -10px;
                  }
            /* VOICE 1 DRAGGIE             */
                  .voice1Draggable{  
                  border-radius: 100px;
                  position: absolute;
                  background: var(--main-v1-color);
                  color: black;
                  }

                  .voice1Sizing1{
                  width: 100px;
                  height: 100px; 
                  opacity: 1;    
                  font-size: 15px; 
                  }

                  .voice1Sizing2{
                  width: 95px;
                  height: 95px; 
                  opacity: 0.95; 
                  font-size: 14px;    
                  }

                  .voice1Sizing3{
                  width: 90px;
                  height: 90px;
                  opacity: 0.9;  
                  font-size: 13px;    
                  }

                  .voice1Sizing4{
                  width: 85px;
                  height: 85px;
                  opacity: 0.85;  
                  font-size: 12px;    
                  }

                  .voice1Sizing5{
                  width: 80px;
                  height: 80px; 
                  opacity: 0.8;   
                  font-size: 11px;  
                  }

                  .voice1Sizing6{
                  width: 75px;
                  height: 75px; 
                  opacity: 0.75; 
                  font-size: 10px;    
                  }

                  .voice1Sizing7{
                  width: 70px;
                  height: 70px; 
                  opacity: 0.7;  
                  font-size: 9px;   
                  }

                  .voice1Sizing8{
                  width: 65px;
                  height: 65px; 
                  opacity: 0.65; 
                  font-size: 8px;    
                  }

                  .voice1Sizing9{
                  width: 60px;
                  height: 60px; 
                  opacity: 0.6;     
                  font-size: 7px;
                  }

                  .voice1Sizing10{
                  width: 55px;
                  height: 55px; 
                  opacity: 0.55;   
                  font-size: 6px;  
                  }  

                  .voice1Sizing11{
                  width: 50px;
                  height: 50px; 
                  opacity: .5;     
                  font-size: 5px;
                  }

                  .voice1Sizing12{
                  width: 45px;
                  height: 45px; 
                  opacity: 0.45;   
                  font-size: 4px;  
                  }

                  .voice1Sizing13{
                  width: 40px;
                  height: 40px;
                  opacity: 0.4;    
                  font-size: 3px;  
                  }

                  .voice1Sizing14{
                  width: 35px;
                  height: 35px;
                  opacity: 0.35;   
                  font-size: 2px;   
                  }

                  .voice1Sizing15{
                  width: 30px;
                  height: 30px; 
                  opacity: 0.3;    
                  font-size: 1px; 
                  }

                  .voice1Sizing16{
                  width: 25px;
                  height: 25px; 
                  opacity: 0.25;   
                  font-size: 1px;  
                  }

                  .voice1Sizing17{
                  width: 20px;
                  height: 20px; 
                  opacity: 0.2;     
                  font-size: 1px;
                  }

                  .voice1Sizing18{
                  width: 20px;
                  height: 20px; 
                  opacity: 0.15;     
                  font-size: 1px;
                  }

                  .voice1Sizing19{
                  width: 20px;
                  height: 20px; 
                  opacity: 0.1;     
                  font-size: 1px;
                  }

                  .voice1Sizing20{
                  width: 20px;
                  height: 20px; 
                  opacity: 0.05;     
                  font-size: 1px;
                  }

                  .voice1Draggable.is-dragging { opacity: 1; }
            /* VOICE 2 DRAGGIE             */
                  .voice2Draggable {
                  border-radius: 100px;
                  position: absolute;
                  background: var(--main-v2-color);
                  color: black;
                  }

                  .voice2Sizing1{
                  width: 100px;
                  height: 100px; 
                  opacity: 1;    
                  font-size: 15px; 
                  }

                  .voice2Sizing2{
                  width: 95px;
                  height: 95px; 
                  opacity: 0.95; 
                  font-size: 14px;    
                  }

                  .voice2Sizing3{
                  width: 90px;
                  height: 90px;
                  opacity: 0.9;  
                  font-size: 13px;    
                  }

                  .voice2Sizing4{
                  width: 85px;
                  height: 85px;
                  opacity: 0.85;  
                  font-size: 12px;    
                  }

                  .voice2Sizing5{
                  width: 80px;
                  height: 80px; 
                  opacity: 0.8;   
                  font-size: 11px;  
                  }

                  .voice2Sizing6{
                  width: 75px;
                  height: 75px; 
                  opacity: 0.75; 
                  font-size: 10px;    
                  }

                  .voice2Sizing7{
                  width: 70px;
                  height: 70px; 
                  opacity: 0.7;  
                  font-size: 9px;   
                  }

                  .voice2Sizing8{
                  width: 65px;
                  height: 65px; 
                  opacity: 0.65; 
                  font-size: 8px;    
                  }

                  .voice2Sizing9{
                  width: 60px;
                  height: 60px; 
                  opacity: 0.6;     
                  font-size: 7px;
                  }

                  .voice2Sizing10{
                  width: 55px;
                  height: 55px; 
                  opacity: 0.55;   
                  font-size: 6px;  
                  }  

                  .voice2Sizing11{
                  width: 50px;
                  height: 50px; 
                  opacity: .5;     
                  font-size: 5px;
                  }

                  .voice2Sizing12{
                  width: 45px;
                  height: 45px; 
                  opacity: 0.45;   
                  font-size: 4px;  
                  }

                  .voice2Sizing13{
                  width: 40px;
                  height: 40px;
                  opacity: 0.4;    
                  font-size: 3px;  
                  }

                  .voice2Sizing14{
                  width: 35px;
                  height: 35px;
                  opacity: 0.35;   
                  font-size: 2px;   
                  }

                  .voice2Sizing15{
                  width: 30px;
                  height: 30px; 
                  opacity: 0.3;    
                  font-size: 1px; 
                  }

                  .voice2Sizing16{
                  width: 25px;
                  height: 25px; 
                  opacity: 0.25;   
                  font-size: 1px;  
                  }

                  .voice2Sizing17{
                  width: 20px;
                  height: 20px; 
                  opacity: 0.2;     
                  font-size: 1px;
                  }

                  .voice2Sizing18{
                  width: 20px;
                  height: 20px; 
                  opacity: 0.15;     
                  font-size: 1px;
                  }

                  .voice2Sizing19{
                  width: 20px;
                  height: 20px; 
                  opacity: 0.1;     
                  font-size: 1px;
                  }

                  .voice2Sizing20{
                  width: 20px;
                  height: 20px; 
                  opacity: 0.05;     
                  font-size: 1px;
                  }

                  
                  .voice2Draggable.is-dragging { opacity: 1; }
            /* VOICE 3 DRAGGIE             */
                  .voice3Draggable {
                  border-radius: 100px;
                  position: absolute;
                  background: var(--main-v3-color);
                  color: black;
                  }

                  .voice3Sizing1{
                  width: 100px;
                  height: 100px; 
                  opacity: 1;    
                  font-size: 15px; 
                  }

                  .voice3Sizing2{
                  width: 95px;
                  height: 95px; 
                  opacity: 0.95; 
                  font-size: 14px;    
                  }

                  .voice3Sizing3{
                  width: 90px;
                  height: 90px;
                  opacity: 0.9;  
                  font-size: 13px;    
                  }

                  .voice3Sizing4{
                  width: 85px;
                  height: 85px;
                  opacity: 0.85;  
                  font-size: 12px;    
                  }

                  .voice3Sizing5{
                  width: 80px;
                  height: 80px; 
                  opacity: 0.8;   
                  font-size: 11px;  
                  }

                  .voice3Sizing6{
                  width: 75px;
                  height: 75px; 
                  opacity: 0.75; 
                  font-size: 10px;    
                  }

                  .voice3Sizing7{
                  width: 70px;
                  height: 70px; 
                  opacity: 0.7;  
                  font-size: 9px;   
                  }

                  .voice3Sizing8{
                  width: 65px;
                  height: 65px; 
                  opacity: 0.65; 
                  font-size: 8px;    
                  }

                  .voice3Sizing9{
                  width: 60px;
                  height: 60px; 
                  opacity: 0.6;     
                  font-size: 7px;
                  }

                  .voice3Sizing10{
                  width: 55px;
                  height: 55px; 
                  opacity: 0.55;   
                  font-size: 6px;  
                  }  

                  .voice3Sizing11{
                  width: 50px;
                  height: 50px; 
                  opacity: .5;     
                  font-size: 5px;
                  }

                  .voice3Sizing12{
                  width: 45px;
                  height: 45px; 
                  opacity: 0.45;   
                  font-size: 4px;  
                  }

                  .voice3Sizing13{
                  width: 40px;
                  height: 40px;
                  opacity: 0.4;    
                  font-size: 3px;  
                  }

                  .voice3Sizing14{
                  width: 35px;
                  height: 35px;
                  opacity: 0.35;   
                  font-size: 2px;   
                  }

                  .voice3Sizing15{
                  width: 30px;
                  height: 30px; 
                  opacity: 0.3;    
                  font-size: 1px; 
                  }

                  .voice3Sizing16{
                  width: 25px;
                  height: 25px; 
                  opacity: 0.25;   
                  font-size: 1px;  
                  }

                  .voice3Sizing17{
                  width: 20px;
                  height: 20px; 
                  opacity: 0.2;     
                  font-size: 1px;
                  }

                  .voice3Sizing18{
                  width: 20px;
                  height: 20px; 
                  opacity: 0.15;     
                  font-size: 1px;
                  }

                  .voice3Sizing19{
                  width: 20px;
                  height: 20px; 
                  opacity: 0.1;     
                  font-size: 1px;
                  }

                  .voice3Sizing20{
                  width: 20px;
                  height: 20px; 
                  opacity: 0.05;     
                  font-size: 1px;
                  }

                  .voice3Draggable.is-dragging { opacity: 1; }
            /* VOICE 4 DRAGGIE             */
                  .voice4Draggable {
                  border-radius: 100px;
                  position: absolute;
                  background: var(--main-v4-color);
                  color: black;
                  }

                  .voice4Sizing1{
                  width: 100px;
                  height: 100px; 
                  opacity: 1;    
                  font-size: 15px; 
                  }

                  .voice4Sizing2{
                  width: 95px;
                  height: 95px; 
                  opacity: 0.95; 
                  font-size: 14px;    
                  }

                  .voice4Sizing3{
                  width: 90px;
                  height: 90px;
                  opacity: 0.9;  
                  font-size: 13px;    
                  }

                  .voice4Sizing4{
                  width: 85px;
                  height: 85px;
                  opacity: 0.85;  
                  font-size: 12px;    
                  }

                  .voice4Sizing5{
                  width: 80px;
                  height: 80px; 
                  opacity: 0.8;   
                  font-size: 11px;  
                  }

                  .voice4Sizing6{
                  width: 75px;
                  height: 75px; 
                  opacity: 0.75; 
                  font-size: 10px;    
                  }

                  .voice4Sizing7{
                  width: 70px;
                  height: 70px; 
                  opacity: 0.7;  
                  font-size: 9px;   
                  }

                  .voice4Sizing8{
                  width: 65px;
                  height: 65px; 
                  opacity: 0.65; 
                  font-size: 8px;    
                  }

                  .voice4Sizing9{
                  width: 60px;
                  height: 60px; 
                  opacity: 0.6;     
                  font-size: 7px;
                  }

                  .voice4Sizing10{
                  width: 55px;
                  height: 55px; 
                  opacity: 0.55;   
                  font-size: 6px;  
                  }  

                  .voice4Sizing11{
                  width: 50px;
                  height: 50px; 
                  opacity: .5;     
                  font-size: 5px;
                  }

                  .voice4Sizing12{
                  width: 45px;
                  height: 45px; 
                  opacity: 0.45;   
                  font-size: 4px;  
                  }

                  .voice4Sizing13{
                  width: 40px;
                  height: 40px;
                  opacity: 0.4;    
                  font-size: 3px;  
                  }

                  .voice4Sizing14{
                  width: 35px;
                  height: 35px;
                  opacity: 0.35;   
                  font-size: 2px;   
                  }

                  .voice4Sizing15{
                  width: 30px;
                  height: 30px; 
                  opacity: 0.3;    
                  font-size: 1px; 
                  }

                  .voice4Sizing16{
                  width: 25px;
                  height: 25px; 
                  opacity: 0.25;   
                  font-size: 1px;  
                  }

                  .voice4Sizing17{
                  width: 20px;
                  height: 20px; 
                  opacity: 0.2;     
                  font-size: 1px;
                  }

                  .voice4Sizing18{
                  width: 20px;
                  height: 20px; 
                  opacity: 0.15;     
                  font-size: 1px;
                  }

                  .voice4Sizing19{
                  width: 20px;
                  height: 20px; 
                  opacity: 0.1;     
                  font-size: 1px;
                  }

                  .voice4Sizing20{
                  width: 20px;
                  height: 20px; 
                  opacity: 0.05;     
                  font-size: 1px;
                  }

                  
                  .voice4Draggable.is-dragging { opacity: 1; }
            /* ABOUT DRAGGIE               */
                  .aboutDraggable{  
                  width: 200px;
                  height: 200px;
                  border-radius: 275px;
                  background: white;
                  opacity: 1;
                  color: black;
                  position: absolute;
                  font-size: 50px;
                  border: var(--main-border-color);
                  }
                  #createdByHeader{
                  font-size: 18px;
                  margin-top: 25px;
                  font-weight: 600;      
                  }
                  #aboutTextID{
                  font-size: 18px;
                  margin-top: 10px;
                  }
                  #newINC{
                  margin-top: -5px;
                  font-size: 14px;  
                  margin-bottom: -25px;    
                  }
                  .about2Draggable{  
                  width: 250px;
                  height: 250px;
                  border-radius: 300px;
                  background: white;
                  opacity: 1;
                  color: black;
                  position: absolute;
                  font-size: 50px;
                  border: var(--main-border-color);
                  }
                  #about2TextID{
                  max-width: 200px;
                  margin: auto;
                  font-size: 18px;
                  margin-top: 30px;
                  font-weight: 600; 
                  }
                  #about2TextID1{
                  font-size: 13px;
                  margin-top: 10px; 
                  text-align: left;
                  margin-left: 45px;     
                  }
                  .about3Draggable{  
                  width: 325px;
                  height: 325px;
                  border-radius: 325px;
                  background: white;
                  opacity: 1;
                  color: black;
                  position: absolute;
                  font-size: 50px;
                  border: var(--main-border-color);
                  }
                  #about3TextHeader{
                  font-size: 24px;
                  max-width: 255px;
                  margin: auto;
                  margin-top: 20px; 
                  font-weight: 600;       
                  }
                  #about3TextID{
                  font-size: 12px;
                  max-width: 260px;
                  margin: auto;
                  margin-top: 15px;
                  }
                  .about4Draggable{  
                  width: 250px;
                  height: 250px;
                  border-radius: 400px;
                  opacity: 1;
                  color: black;
                  position: absolute;
                  font-size: 50px;
                  background: white;
                  }
            /* PLAY SUN DRAGGIE            */
                  #sunLoadText1{
                  font-size: 18px;
                  margin-top: 44px;
                  font-weight: 700;      
                  }
                  #sunLoadText2{
                  font-size: 8px;
                  margin-top: -10px;
                  font-weight: 700;       
                  }
                  #sunTextID{
                  font-size: 10px;
                  margin-top: 40px;
                  font-weight: 700;
                  }
                  #sunTextID2{
                  font-size: 7px;
                  margin-top: -10px;
                  font-weight: 700;      
                  }
                  #togetherText{
                  font-size: 15px;
                  margin-top: -15px;
                  font-weight: 700;      
                  }
                  .playSunDraggable {
                  width: 100px;
                  height: 100px;
                  color: black;
                  background: white;
                  border-radius: 100px;
                  opacity: 1;
                  position: absolute;
                  }
                  .playSunDraggable.is-pointer-down {
                  opacity: 1;
                  }
                  .playSunDraggable.is-dragging { 
                  opacity: 1;
                  }
            /* REVERB COLORING             */
                  .reverbSizing1{
                  background: #000000;
                  /*width: 100%;
                  height: 100%;*/
                  -webkit-background-size: cover;
                  -moz-background-size: cover;
                  -o-background-size: cover;
                  background-size: cover;
                  background:...;
                  }

                  .reverbSizing2{
                  background: #101010;
                  /*opacity: .95; */
                  }

                  .reverbSizing3{
                  background: #202020;
                  /*opacity: 0.9; */
                  }

                  .reverbSizing4{
                  background: #282828;
                  /*opacity: 0.85;  */
                  }

                  .reverbSizing5{
                  background: #303030; 
                  /*opacity: 0.8;  */
                  }

                  .reverbSizing6{
                  background: #383838;
                  /*opacity*/: 0.75; 
                  }

                  .reverbSizing7{
                  background: #484848;
                  /*opacity*/: 0.7; 
                  }

                  .reverbSizing8{
                  background: #585858;
                  /*opacity*/: 0.65; 
                  }

                  .reverbSizing9{
                  background: #696969;
                  /*opacity*/: 0.6;    
                  }

                  .reverbSizing10{
                  background: #808080;
                  /*opacity*/: 0.55; 
                  }  

                  .reverbSizing11{
                  background: #909090; 
                  /*opacity*/: 0.5;   
                  }

                  .reverbSizing12{
                  background: #A0A0A0;
                  /*opacity*/: 0.45; 
                  }

                  .reverbSizing13{
                  background: #A9A9A9;
                  /*opacity*/: 0.4; 
                  }

                  .reverbSizing14{
                  background: #B8B8B8;
                  /*opacity*/: 0.35; 
                  }

                  .reverbSizing15{
                  background: #C0C0C0;
                  /*opacity*/: 0.3; 
                  }

                  .reverbSizing16{
                  background: #D3D3D3;
                  /*opacity: 0.25; */
                  }

                  .reverbSizing17{
                  background: #DCDCDC;
                  /*opacity: 0.2;     */
                  }

                  .reverbSizing18{
                  background: #E8E8E8;
                  /*opacity: 0.15; */
                  }

                  .reverbSizing19{
                  background: #F5F5F5;
                  /*opacity: 0.1; */
                  }

                  .reverbSizing20{
                  background: #FFFFFF;
                 /* opacity: 0.05; */ 
                  }
            /* MISSON CONTROL              */
                  #controlsContainer{
                  max-width: 400px;
                  margin: auto;
                  margin-top: 50px;
                  margin-bottom: 0px;
                  height: 500px;
                  }
                  #masterControlDiv{
                  margin-top: 0px;
                  margin-left: -8px;
                  margin-bottom: 300px;
                  max-width: 1500px;
                  }
                  #masterControlBadges{
                  border-radius: 6px;
                  padding: 8px 8px;
                  font-size: 16px;
                  font-weight: 700;
                  width: 150px;
                  color: black; 
                  border: 2px solid black;
                  }
                  #masterTimingBadges{
                  border-radius: 6px;
                  padding: 8px 8px;
                  font-size: 16px;
                  font-weight: 700;
                  background-color: var(--main-time-color);
                  color: black; 
                  width: 150px;
                  border: 2px solid black;
                  }
                  #voice1SliderDiv{
                  width: 50%;
                  content: '\A';
                  white-space: pre;     
                  }
                  #voice2SliderDiv{
                  width: 50%;
                  content: '\A';
                  white-space: pre;      
                  }
                  #voice3SliderDiv{
                  margin-top: 20px;
                  width: 50%;
                  content: '\A';
                  white-space: pre;      
                  }
                  #voice4SliderDiv{
                  margin-top: 20px;
                  width: 50%;
                  content: '\A';
                  white-space: pre;      
                  }
                  #timingSliderDiv{
                  margin-top: 30px;
                  width: 50%;
                  content: '\A';
                  white-space: pre;
                  }
                  #daySliderDiv{
                  width: 50%;
                  content: '\A';
                  white-space: pre; 
                  margin-top: 30px;
                  }
                  #sliders1{
                  margin-top: 20px;
                  }
                  #sliders2{
                  margin-top: 20px;
                  }
                  #sliders3{
                  margin-top: 20px;
                  }
                  #sliders4{
                  margin-top: 20px;
                  }
                  #sliders5{
                  margin-top: 20px;
                  }
                  #slidersTiming{
                  margin-top: 20px;      
                  }
            /* BADGES                      */
                  .voice1Badge{
                  background: var(--main-heading-color);
                  color: black;
                  }
                  .voice2Badge{
                  background: var(--main-heading-color);
                  color: black;   
                  }
                  .voice3Badge{
                  background: var(--main-heading-color);
                  color: black;     
                  }
                  .voice4Badge{
                  background: var(--main-heading-color);
                  color: black; 
                  }
            /* AMBIANCE BUTTONS            */
                  #ambienceBtnLocation{
                  max-width: 400px;
                  margin: auto;
                  margin-top: 0px;
                  margin-bottom: 0px;
                  margin-left: -6px;
                  }
                  #ambienceBtns{
                  width: 150px;
                  border-radius: 4px;
                  font-size: 16px;
                  font-weight: 700;      
                  }
                  #ambienceBtn1Div{
                  width: 50%;
                  content: '\A';
                  white-space: pre;
                  margin-bottom: 20px;
                  }
                  #ambienceBtn2Div{
                  width: 50%;
                  content: '\A';
                  white-space: pre;
                  margin-bottom: 20px;
                  }
                  #ambienceBtn3Div{
                  width: 50%;
                  content: '\A';
                  white-space: pre;
                  }
                  #ambienceBtn4Div{
                  width: 50%;
                  content: '\A';
                  white-space: pre;
                  }
                  #ambienceHornDiv{
                  width: 50%;
                  content: '\A';
                  white-space: pre; 
                  margin-top: 30px;     
                  }
                  #ambienceNoiseDiv{
                  width: 50%;
                  content: '\A';
                  white-space: pre; 
                  margin-top: 30px;      
                  }
                  #ambienceSlider{
                  margin-top: 20px;
                  marker-left: 20px;
                  }
                  #ambienceBadges{
                  font-size: 22px;
                  background-color:var(--main-time-color);
                  color: black; 
                  }
            /* INSTRUMENT 1 RANGER         */
                  input[class="instrument1Ranger"] {
                  -webkit-appearance: none;
                  background: var(--main-heading-color);
                  height: 10px;
                  width: 130px;
                  border-radius: 20px;
                  margin: auto;
                  transform: rotateY(180deg);
                  }
                  input[class="instrument1Ranger"]::-moz-range-track{
                  -webkit-appearance: none;
                  background: var(--main-heading-color);
                  height: 10px;
                  width: 130px;
                  border-radius: 20px;
                  margin: auto;
                  transform: rotateY(180deg);
                  }
                  input[class="instrument1Ranger"]::-webkit-slider-thumb{
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-heading-color);
                  border: 2px solid #00001E;
                  }

                  input[class="instrument1Ranger"]::-moz-range-thumb{
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-heading-color);
                  border: 2px solid #00001E;
                  }
            /* INSTRUMENT 2 RANGER         */
                  input[class="instrument2Ranger"] {
                  -webkit-appearance: none;
                  background: var(--main-heading-color);
                  height: 10px;
                  width: 130px;
                  border-radius: 20px;
                  margin: auto;
                  transform: rotateY(180deg);
                  }
                  input[class="instrument2Ranger"]::-moz-range-track{
                  -webkit-appearance: none;
                  background: var(--main-heading-color);
                  height: 10px;
                  width: 130px;
                  border-radius: 20px;
                  margin: auto;
                  transform: rotateY(180deg);
                  }
                  input[class="instrument2Ranger"]::-webkit-slider-thumb {
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-heading-color);
                  border: 2px solid #00001E;
                  }
                  input[class="instrument2Ranger"]::-moz-range-thumb{
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-heading-color);
                  border: 2px solid #00001E;
                  }
            /* INSTRUMENT 3 RANGER         */
                  input[class="instrument3Ranger"] {
                  -webkit-appearance: none;
                  background: var(--main-heading-color);
                  height: 10px;
                  width: 130px;
                  border-radius: 20px;
                  margin: auto;
                  transform: rotateY(180deg);
                  }
                  input[class="instrument3Ranger"]::-moz-range-track{
                  -webkit-appearance: none;
                  background: var(--main-heading-color);
                  height: 10px;
                  width: 130px;
                  border-radius: 20px;
                  margin: auto;
                  transform: rotateY(180deg);
                  }
                  input[class="instrument3Ranger"]::-webkit-slider-thumb {
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-heading-color);
                  border: 2px solid #00001E;
                  }
                  input[class="instrument3Ranger"]::-moz-range-thumb{
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-heading-color);
                  border: 2px solid #00001E;
                  }
            /* INSTRUMENT 4 RANGER         */
                  input[class="instrument4Ranger"] {
                  -webkit-appearance: none;
                  background: var(--main-heading-color);
                  height: 10px;
                  width: 130px;
                  border-radius: 20px;
                  margin: auto;
                  transform: rotateY(180deg);
                  }
                  input[class="instrument4Ranger"]::-moz-range-track{
                  -webkit-appearance: none;
                  background: var(--main-heading-color);
                  height: 10px;
                  width: 130px;
                  border-radius: 20px;
                  margin: auto;
                  transform: rotateY(180deg);
                  }
                  input[class="instrument4Ranger"]::-webkit-slider-thumb {
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-heading-color);
                  border: 2px solid #00001E;
                  }
                  input[class="instrument4Ranger"]::-moz-range-thumb{
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-heading-color);
                  border: 2px solid #00001E;
                  }
            /* TIMING RANGER               */
                  input[class="timingRanger"] {
                  -webkit-appearance: none;
                  background-color: var(--main-sun-color);
                  height: 10px;
                  width: 130px;
                  border-radius: 20px;
                  margin: auto;
                  }

                  input[class="timingRanger"]::-webkit-slider-thumb {
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-sun-color);
                  border: 2px solid #00001E;
                  }

                  input[class="timingRanger"]::-moz-range-track{
                  -webkit-appearance: none;
                  background-color: var(--main-sun-color);
                  height: 10px;
                  width: 130px;
                  border-radius: 20px;
                  margin: auto;
                  }

                  input[class="timingRanger"]::-moz-range-thumb{
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-sun-color);
                  border: 2px solid #00001E;
                  }
            /* DAY RANGER                  */
                  input[class="dayRanger"] {
                  -webkit-appearance: none;
                  background-color: var(--main-time-color);
                  height: 10px;
                  width: 130px;
                  border-radius: 20px;
                  margin: auto;
                  }

                  input[class="dayRanger"]::-webkit-slider-thumb {
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-time-color);
                  border: 2px solid #00001E;
                  }

                  input[class="dayRanger"]::-moz-range-track{
                  -webkit-appearance: none;
                  background-color: var(--main-time-color);
                  height: 10px;
                  width: 130px;
                  border-radius: 20px;
                  margin: auto;
                  }

                  input[class="dayRanger"]::-moz-range-thumb{
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-time-color);
                  border: 2px solid #00001E;
                  }
            /* AMBIANCE RANGER STOPPED     */
                  input[class="ambianceRangerStop"] {
                  -webkit-appearance: none;
                  background-color: var(--main-stop-color);
                  height: 10px;
                  width: 130px;
                  border-radius: 20px;
                  margin: auto;
                  }

                  input[class="ambianceRangerStop"]::-webkit-slider-thumb {
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-stop-color);
                  border: 2px solid #00001E;
                  }
                  input[class="ambianceRangerStop"]::-moz-range-track{
                  -webkit-appearance: none;
                  background-color: var(--main-stop-color);
                  height: 10px;
                  width: 130px;
                  border-radius: 20px;
                  margin: auto;
                  }
                  input[class="ambianceRangerStop"]::-moz-range-thumb{
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-stop-color);
                  border: 2px solid #00001E;
                  }
            /* AMBIANCE RANGER PLAYING     */
                  input[class="ambianceRangerPlay"] {
                  -webkit-appearance: none;
                  background-color: var(--main-start-color);
                  height: 10px;
                  width: 130px;
                  border-radius: 20px;
                  margin: auto;
                  }

                  input[class="ambianceRangerPlay"]::-webkit-slider-thumb {
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-start-color);
                  border: 2px solid #00001E;
                  }  

                  input[class="ambianceRangerPlay"]::-moz-range-track{
                  -webkit-appearance: none;
                  background-color: var(--main-start-color);
                  height: 10px;
                  width: 130px;
                  border-radius: 20px;
                  margin: auto;
                  }

                  input[class="ambianceRangerPlay"]::-moz-range-thumb{
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-start-color);
                  border: 2px solid #00001E;
                  }    
            /* MAILING LIST                */
                  #mailingListText{
                  margin: auto;
                  max-width: 200px;
                  margin-top: 80px;
                  margin-bottom: 0px;
                  font-size: 16px;      
                  font-weight: 600;
                  }
                  #mc_embed_signup{
                  background:#fff; 
                  font-size:12px; 
                  width:100%;
                  border-color: black;
                  background-color: transparent;
                  }
                  #mce-EMAIL{
                  font-size:12px; 
                  padding: 4px 10px;
                  margin-top: 0px;  
                  font-weight: 800;
                  width: 190px;
                  border-width: 2px;
                  border-radius: 10px;
                  background-color: transparent;
                  border-color: black;
                  }
                  #mc-embedded-subscribe{
                  font-size:12px; 
                  padding: 2px 10px;
                  margin-top: 4px;
                  font-weight: 800;
                  border-width: 2px;
                  border-radius: 10px;
                  background-color: transparent;
                  border-color: black;
                  }
      }
/** STYLINGS FOR MEDIUM SCREENS < 768px   */
      @media (min-width: 577px) and (max-width: 768px) {
                  #mainDiv{
                  padding-right: 0px;
                  padding-left: 0px;
                  max-width: 2000px;   
                  }
                  #hornBtn{
                  width: 350px; 
                  height: 50px;
                  margin-top: 20px;
                  }
                  #hornBtnPrompt{
                  margin-top: 2px;
                  color: white;
                  font-size: 22px;
                  }
            /* PROMPT                      */
                  #promptText{
                  margin: auto;
                  max-width: 700px;
                  margin-top: 110px;
                  font-size: 22px;
                  color:white;   
                  }
                  #promptButton{
                  margin-top: 5px;
                  margin-bottom: 20px;
                  font-size: 20px;
                  color:white;
                  }
            /* WELCOME                     */
                  #welcomeInfoText{
                  margin-top: 50px;
                  font-size: 30px;
                  color: black;
                  font-weight: 700;
                  }
                  #welcomeMobileText{
                  color: black;
                  font-size: 18px;
                  font-weight: 700;
                  }
                  #playButton{
                  color:  white;
                  background-color:  var(--main-heading-color);
                  margin-top: 20px;
                  font-size: 20px;
                  border-width: 1px;
                  }
                  #bell{
                  color: var(--main-v1-color);      
                  }
            /* HEADINGS                    */
                  #navBar{
                  margin-top: -510px;
                  }
                  #harmonizeHeading{
                  font-size: 18px;
                  font-weight: 700;
                  margin-top: 20px;
                  margin-bottom: 0px;
                  width: 180px;
                  border-radius: 4px;      
                  }
                  #cuteBtn{
                  font-size: 18px;
                  margin-top: 20px;
                  margin-bottom: 0px;
                  width: 40px;
                  border-radius: 40px; 
                  }
                  #ambienceHeading{
                  font-size: 18px;
                  font-weight: 700;
                  margin-top: 20px;
                  margin-bottom: 0px;
                  width: 180px;
                  border-radius: 4px;  
                  }
                  #harmonyHeadingDiv{
                  /*margin-left: 50px;*/
                  }
                  #helpHeadingDiv{
                 
                  }
                  #ambianceHeadingDiv{
                  /*margin-left: -50px;*/
                  }
            /* DRAGGIE CONTAINER           */
                  .masterDraggie{
                  margin-top: 100px;
                  margin-bottom: 0px;
                  width: 100%;
                  height: 100%;
                  }
                  .draggieContainer{
                  padding: 200px 200px;
                  border: 5px dotted var(--main-guide-color);
                  height: 300px;
                  width: 100px;
                  margin: auto;
                  /*width: 700px;
                  height: 600px;
                  margin-top: -200px;
                  margin-left: 800px;
                  background: transparent;
                  border-radius: 500px;
                  position: relative;*/
                  }
            /* ALL VOICE TAGS              */
                  #voiceBubbleText{
                  color:black;
                  margin-top: 30%;
                  }
                  #voiceBubbleText2{
                  color: white;
                  font-weight: 800;
                  margin-top: -10px;
                  }
            /* VOICE 1 DRAGGIE             */
                  .voice1Draggable{  
                  border-radius: 100px;
                  position: absolute;
                  background: var(--main-v1-color);
                  color: black;
                  }

                  .voice1Sizing1{
                  width: 145px;
                  height: 145px; 
                  opacity: 1;    
                  font-size: 20px; 
                  }

                  .voice1Sizing2{
                  width: 140px;
                  height: 140px; 
                  opacity: 0.95; 
                  font-size: 19px;    
                  }

                  .voice1Sizing3{
                  width: 135px;
                  height: 135px;
                  opacity: 0.9;  
                  font-size: 18px;    
                  }

                  .voice1Sizing4{
                  width: 130px;
                  height: 130px;
                  opacity: 0.85;  
                  font-size: 17px;    
                  }

                  .voice1Sizing5{
                  width: 125px;
                  height: 125px; 
                  opacity: 0.8;   
                  font-size: 16px;  
                  }

                  .voice1Sizing6{
                  width: 120px;
                  height: 120px; 
                  opacity: 0.75; 
                  font-size: 15px;    
                  }

                  .voice1Sizing7{
                  width: 115px;
                  height: 115px; 
                  opacity: 0.7;  
                  font-size: 14px;   
                  }

                  .voice1Sizing8{
                  width: 110px;
                  height: 110px; 
                  opacity: 0.65; 
                  font-size: 13px;    
                  }

                  .voice1Sizing9{
                  width: 105px;
                  height: 105px; 
                  opacity: 0.6;     
                  font-size: 12px;
                  }

                  .voice1Sizing10{
                  width: 100px;
                  height: 100px; 
                  opacity: 0.55;   
                  font-size: 11px;  
                  }  

                  .voice1Sizing11{
                  width: 95px;
                  height: 95px; 
                  opacity: .5;     
                  font-size: 10px;
                  }

                  .voice1Sizing12{
                  width: 90px;
                  height: 90px; 
                  opacity: 0.45;   
                  font-size: 9px;  
                  }

                  .voice1Sizing13{
                  width: 85px;
                  height: 85px;
                  opacity: 0.4;    
                  font-size: 8px;  
                  }

                  .voice1Sizing14{
                  width: 80px;
                  height: 80px;
                  opacity: 0.35;   
                  font-size: 8px;   
                  }

                  .voice1Sizing15{
                  width: 75px;
                  height: 75px; 
                  opacity: 0.3;    
                  font-size: 8px; 
                  }

                  .voice1Sizing16{
                  width: 70px;
                  height: 70px; 
                  opacity: 0.25;   
                  font-size: 8px;  
                  }

                  .voice1Sizing17{
                  width: 65px;
                  height: 65px; 
                  opacity: 0.2;     
                  font-size: 8px;
                  }

                  .voice1Sizing18{
                  width: 60px;
                  height: 60px; 
                  opacity: 0.15;     
                  font-size: 8px;
                  }

                  .voice1Sizing19{
                  width: 55px;
                  height: 55px; 
                  opacity: 0.1;     
                  font-size: 8px;
                  }

                  .voice1Sizing20{
                  width: 50px;
                  height: 50px; 
                  opacity: 0.05;     
                  font-size: 8px;
                  }

                  .voice1Draggable.is-dragging { opacity: 1; }
            /* VOICE 2 DRAGGIE             */
                  .voice2Draggable {
                  border-radius: 100px;
                  position: absolute;
                  background: var(--main-v2-color);
                  color: black;
                  }

                  .voice2Sizing1{
                  width: 145px;
                  height: 145px; 
                  opacity: 1;    
                  font-size: 20px; 
                  }

                  .voice2Sizing2{
                  width: 140px;
                  height: 140px; 
                  opacity: 0.95; 
                  font-size: 19px;    
                  }

                  .voice2Sizing3{
                  width: 135px;
                  height: 135px;
                  opacity: 0.9;  
                  font-size: 18px;    
                  }

                  .voice2Sizing4{
                  width: 130px;
                  height: 130px;
                  opacity: 0.85;  
                  font-size: 17px;    
                  }

                  .voice2Sizing5{
                  width: 125px;
                  height: 125px; 
                  opacity: 0.8;   
                  font-size: 16px;  
                  }

                  .voice2Sizing6{
                  width: 120px;
                  height: 120px; 
                  opacity: 0.75; 
                  font-size: 15px;    
                  }

                  .voice2Sizing7{
                  width: 115px;
                  height: 115px; 
                  opacity: 0.7;  
                  font-size: 14px;   
                  }

                  .voice2Sizing8{
                  width: 110px;
                  height: 110px; 
                  opacity: 0.65; 
                  font-size: 13px;    
                  }

                  .voice2Sizing9{
                  width: 105px;
                  height: 105px; 
                  opacity: 0.6;     
                  font-size: 12px;
                  }

                  .voice2Sizing10{
                  width: 100px;
                  height: 100px; 
                  opacity: 0.55;   
                  font-size: 11px;  
                  }  

                  .voice2Sizing11{
                  width: 95px;
                  height: 95px; 
                  opacity: .5;     
                  font-size: 10px;
                  }

                  .voice2Sizing12{
                  width: 90px;
                  height: 90px; 
                  opacity: 0.45;   
                  font-size: 9px;  
                  }

                  .voice2Sizing13{
                  width: 85px;
                  height: 85px;
                  opacity: 0.4;    
                  font-size: 8px;  
                  }

                  .voice2Sizing14{
                  width: 80px;
                  height: 80px;
                  opacity: 0.35;   
                  font-size: 8px;   
                  }

                  .voice2Sizing15{
                  width: 75px;
                  height: 75px; 
                  opacity: 0.3;    
                  font-size: 8px; 
                  }

                  .voice2Sizing16{
                  width: 70px;
                  height: 70px; 
                  opacity: 0.25;   
                  font-size: 8px;  
                  }

                  .voice2Sizing17{
                  width: 65px;
                  height: 65px; 
                  opacity: 0.2;     
                  font-size: 8px;
                  }

                  .voice2Sizing18{
                  width: 60px;
                  height: 60px; 
                  opacity: 0.15;     
                  font-size: 8px;
                  }

                  .voice2Sizing19{
                  width: 55px;
                  height: 55px; 
                  opacity: 0.1;     
                  font-size: 8px;
                  }

                  .voice2Sizing20{
                  width: 50px;
                  height: 50px; 
                  opacity: 0.05;     
                  font-size: 8px;
                  }

                  .voice2Draggable.is-dragging { opacity: 1; }
            /* VOICE 3 DRAGGIE             */
                  .voice3Draggable {
                  border-radius: 100px;
                  position: absolute;
                  background: var(--main-v3-color);
                  color: black;
                  }

                  .voice3Sizing1{
                  width: 145px;
                  height: 145px; 
                  opacity: 1;    
                  font-size: 20px; 
                  }

                  .voice3Sizing2{
                  width: 140px;
                  height: 140px; 
                  opacity: 0.95; 
                  font-size: 19px;    
                  }

                  .voice3Sizing3{
                  width: 135px;
                  height: 135px;
                  opacity: 0.9;  
                  font-size: 18px;    
                  }

                  .voice3Sizing4{
                  width: 130px;
                  height: 130px;
                  opacity: 0.85;  
                  font-size: 17px;    
                  }

                  .voice3Sizing5{
                  width: 125px;
                  height: 125px; 
                  opacity: 0.8;   
                  font-size: 16px;  
                  }

                  .voice3Sizing6{
                  width: 120px;
                  height: 120px; 
                  opacity: 0.75; 
                  font-size: 15px;    
                  }

                  .voice3Sizing7{
                  width: 115px;
                  height: 115px; 
                  opacity: 0.7;  
                  font-size: 14px;   
                  }

                  .voice3Sizing8{
                  width: 110px;
                  height: 110px; 
                  opacity: 0.65; 
                  font-size: 13px;    
                  }

                  .voice3Sizing9{
                  width: 105px;
                  height: 105px; 
                  opacity: 0.6;     
                  font-size: 12px;
                  }

                  .voice3Sizing10{
                  width: 100px;
                  height: 100px; 
                  opacity: 0.55;   
                  font-size: 11px;  
                  }  

                  .voice3Sizing11{
                  width: 95px;
                  height: 95px; 
                  opacity: .5;     
                  font-size: 10px;
                  }

                  .voice3Sizing12{
                  width: 90px;
                  height: 90px; 
                  opacity: 0.45;   
                  font-size: 9px;  
                  }

                  .voice3Sizing13{
                  width: 85px;
                  height: 85px;
                  opacity: 0.4;    
                  font-size: 8px;  
                  }

                  .voice3Sizing14{
                  width: 80px;
                  height: 80px;
                  opacity: 0.35;   
                  font-size: 8px;   
                  }

                  .voice3Sizing15{
                  width: 75px;
                  height: 75px; 
                  opacity: 0.3;    
                  font-size: 8px; 
                  }

                  .voice3Sizing16{
                  width: 70px;
                  height: 70px; 
                  opacity: 0.25;   
                  font-size: 8px;  
                  }

                  .voice3Sizing17{
                  width: 65px;
                  height: 65px; 
                  opacity: 0.2;     
                  font-size: 8px;
                  }

                  .voice3Sizing18{
                  width: 60px;
                  height: 60px; 
                  opacity: 0.15;     
                  font-size: 8px;
                  }

                  .voice3Sizing19{
                  width: 55px;
                  height: 55px; 
                  opacity: 0.1;     
                  font-size: 8px;
                  }

                  .voice3Sizing20{
                  width: 50px;
                  height: 50px; 
                  opacity: 0.05;     
                  font-size: 8px;
                  }

                  .voice3Draggable.is-dragging { opacity: 1; }
            /* VOICE 4 DRAGGIE             */
                  .voice4Draggable {
                  border-radius: 100px;
                  position: absolute;
                  background: var(--main-v4-color);
                  color: black;
                  }
                  
                  .voice4Sizing1{
                  width: 145px;
                  height: 145px; 
                  opacity: 1;    
                  font-size: 20px; 
                  }

                  .voice4Sizing2{
                  width: 140px;
                  height: 140px; 
                  opacity: 0.95; 
                  font-size: 19px;    
                  }

                  .voice4Sizing3{
                  width: 135px;
                  height: 135px;
                  opacity: 0.9;  
                  font-size: 18px;    
                  }

                  .voice4Sizing4{
                  width: 130px;
                  height: 130px;
                  opacity: 0.85;  
                  font-size: 17px;    
                  }

                  .voice4Sizing5{
                  width: 125px;
                  height: 125px; 
                  opacity: 0.8;   
                  font-size: 16px;  
                  }

                  .voice4Sizing6{
                  width: 120px;
                  height: 120px; 
                  opacity: 0.75; 
                  font-size: 15px;    
                  }

                  .voice4Sizing7{
                  width: 115px;
                  height: 115px; 
                  opacity: 0.7;  
                  font-size: 14px;   
                  }

                  .voice4Sizing8{
                  width: 110px;
                  height: 110px; 
                  opacity: 0.65; 
                  font-size: 13px;    
                  }

                  .voice4Sizing9{
                  width: 105px;
                  height: 105px; 
                  opacity: 0.6;     
                  font-size: 12px;
                  }

                  .voice4Sizing10{
                  width: 100px;
                  height: 100px; 
                  opacity: 0.55;   
                  font-size: 11px;  
                  }  

                  .voice4Sizing11{
                  width: 95px;
                  height: 95px; 
                  opacity: .5;     
                  font-size: 10px;
                  }

                  .voice4Sizing12{
                  width: 90px;
                  height: 90px; 
                  opacity: 0.45;   
                  font-size: 9px;  
                  }

                  .voice4Sizing13{
                  width: 85px;
                  height: 85px;
                  opacity: 0.4;    
                  font-size: 8px;  
                  }

                  .voice4Sizing14{
                  width: 80px;
                  height: 80px;
                  opacity: 0.35;   
                  font-size: 8px;   
                  }

                  .voice4Sizing15{
                  width: 75px;
                  height: 75px; 
                  opacity: 0.3;    
                  font-size: 8px; 
                  }

                  .voice4Sizing16{
                  width: 70px;
                  height: 70px; 
                  opacity: 0.25;   
                  font-size: 8px;  
                  }

                  .voice4Sizing17{
                  width: 65px;
                  height: 65px; 
                  opacity: 0.2;     
                  font-size: 8px;
                  }

                  .voice4Sizing18{
                  width: 60px;
                  height: 60px; 
                  opacity: 0.15;     
                  font-size: 8px;
                  }

                  .voice4Sizing19{
                  width: 55px;
                  height: 55px; 
                  opacity: 0.1;     
                  font-size: 8px;
                  }

                  .voice4Sizing20{
                  width: 50px;
                  height: 50px; 
                  opacity: 0.05;     
                  font-size: 8px;
                  }

                  .voice4Draggable.is-dragging { opacity: 1; }
            /* ABOUT DRAGGIE               */
                  .aboutDraggable{  
                  width: 250px;
                  height: 250px;
                  border-radius: 275px;
                  background: white;
                  opacity: 1;
                  color: black;
                  position: absolute;
                  font-size: 50px;
                  border: var(--main-border-color);
                  }
                  #createdByHeader{
                  font-size: 24px;
                  margin-top: 25px;
                  font-weight: 600;      
                  }
                  #aboutTextID{
                  font-size: 24px;
                  margin-top: 10px;
                  }
                  #newINC{
                  margin-top: -5px;
                  font-size: 18px;  
                  margin-bottom: -35px;    
                  }
                  .about2Draggable{  
                  width: 300px;
                  height: 300px;
                  border-radius: 300px;
                  background: white; 
                  opacity: 1;
                  color: black;
                  position: absolute;
                  font-size: 50px;
                  border: var(--main-border-color);
                  }
                  #about2TextID{
                  max-width: 250px;
                  margin: auto;
                  font-size: 24px;
                  margin-top: 35px;
                  font-weight: 600; 
                  }
                  #about2TextID1{
                  font-size: 15px;
                  margin-top: 10px; 
                  text-align: left;
                  margin-left: 55px;     
                  }
                  .about3Draggable{  
                  width: 360px;
                  height: 360px;
                  border-radius: 325px;
                  background: white; 
                  opacity: 1;
                  color: black;
                  position: absolute;
                  font-size: 50px;
                  border: var(--main-border-color);
                  }
                  #about3TextHeader{
                  font-size: 28px;
                  max-width: 255px;
                  margin: auto;
                  margin-top: 20px; 
                  font-weight: 600;       
                  }
                  #about3TextID{
                  font-size: 13px;
                  max-width: 280px;
                  margin: auto;
                  margin-top: 15px;
                  }
                  .about4Draggable{  
                  width: 250px;
                  height: 250px;
                  border-radius: 400px;
                  opacity: 1;
                  color: black;
                  position: absolute;
                  font-size: 50px;
                  background: white;
                  }
            /* PLAY SUN DRAGGIE            */
                  #sunLoadText1{
                  font-size: 22px;
                  margin-top: 63px;
                  font-weight: 700;      
                  }
                  #sunLoadText2{
                  font-size: 14px;
                  margin-top: -12px;
                  font-weight: 700;       
                  }
                  #sunTextID{
                  font-size: 16px;
                  margin-top: 55px;
                  font-weight: 700;
                  }
                  #sunTextID2{
                  font-size: 12px;
                  margin-top: -13px;
                  font-weight: 700;      
                  }
                  #togetherText{
                  font-size: 24px;
                  margin-top: -25px;
                  font-weight: 700;      
                  }
                  .playSunDraggable {
                  width: 145px;
                  height: 145px;
                  color: black;
                  background: white;
                  border-radius: 100px;
                  opacity: 1;
                  position: absolute;
                  }
                  .playSunDraggable.is-pointer-down {
                  opacity: 1;
                  }
                  .playSunDraggable.is-dragging { 
                  opacity: 1;
                  }
            /* REVERB COLORING             */
                  .reverbSizing1{
                  background: #000000;
                  /*width: 100%;
                  height: 100%;*/
                  -webkit-background-size: cover;
                  -moz-background-size: cover;
                  -o-background-size: cover;
                  background-size: cover;
                  background:...;
                  }

                  .reverbSizing2{
                  background: #101010;
                  /*opacity: .95; */
                  }

                  .reverbSizing3{
                  background: #202020;
                  /*opacity: 0.9; */
                  }

                  .reverbSizing4{
                  background: #282828;
                  /*opacity: 0.85;  */
                  }

                  .reverbSizing5{
                  background: #303030; 
                  /*opacity: 0.8;  */
                  }

                  .reverbSizing6{
                  background: #383838;
                  /*opacity*/: 0.75; 
                  }

                  .reverbSizing7{
                  background: #484848;
                  /*opacity*/: 0.7; 
                  }

                  .reverbSizing8{
                  background: #585858;
                  /*opacity*/: 0.65; 
                  }

                  .reverbSizing9{
                  background: #696969;
                  /*opacity*/: 0.6;    
                  }

                  .reverbSizing10{
                  background: #808080;
                  /*opacity*/: 0.55; 
                  }  

                  .reverbSizing11{
                  background: #909090; 
                  /*opacity*/: 0.5;   
                  }

                  .reverbSizing12{
                  background: #A0A0A0;
                  /*opacity*/: 0.45; 
                  }

                  .reverbSizing13{
                  background: #A9A9A9;
                  /*opacity*/: 0.4; 
                  }

                  .reverbSizing14{
                  background: #B8B8B8;
                  /*opacity*/: 0.35; 
                  }

                  .reverbSizing15{
                  background: #C0C0C0;
                  /*opacity*/: 0.3; 
                  }

                  .reverbSizing16{
                  background: #D3D3D3;
                  /*opacity: 0.25; */
                  }

                  .reverbSizing17{
                  background: #DCDCDC;
                  /*opacity: 0.2;     */
                  }

                  .reverbSizing18{
                  background: #E8E8E8;
                  /*opacity: 0.15; */
                  }

                  .reverbSizing19{
                  background: #F5F5F5;
                  /*opacity: 0.1; */
                  }

                  .reverbSizing20{
                  background: #FFFFFF;
                 /* opacity: 0.05; */ 
                  }
            /* MISSON CONTROL              */
                  #controlsContainer{
                  max-width: 1000px;
                  margin: auto;
                  margin-top: 150px;
                  margin-bottom: 50px;
                  height: 400px;
                  }
                  #masterControlDiv{
                  margin-top: 0px;
                  margin-left: 0px;
                  margin-bottom: 0px;
                  }
                  #masterControlBadges{
                  padding: 8px 5px;
                  font-size: 16px;
                  font-weight: 700;
                  width: 150px;
                  color: black; 
                  border: 2px solid black;
                  border-radius: 5px;
                  }
                  #masterTimingBadges{
                  padding: 8px 8px;
                  font-size: 17px;
                  font-weight: 700;
                  background-color: var(--main-time-color);
                  color: black; 
                  width: 150px;
                  border: 2px solid black;
                  border-radius: 5px;
                  }
                  #voice1SliderDiv{
                  width: 25%;
                  }
                  #voice2SliderDiv{
                  width: 25%;
                  }
                  #voice3SliderDiv{
                  width: 25%;
                  }
                  #voice4SliderDiv{
                  width: 25%;
                  }
                  #timingSmoosh{
                  max-width: 500px;
                  margin: auto;     
                  }
                  #timingSliderDiv{
                  width: 50%;
                  content: '\A';
                  white-space: pre; 
                  margin-top: 30px;
                  }
                  #daySliderDiv{
                  width: 50%;
                  content: '\A';
                  white-space: pre; 
                  margin-top: 30px;
                  }
                  #sliders1{
                  margin-top: 20px;
                  }
                  #sliders2{
                  margin-top: 20px;
                  }
                  #sliders3{
                  margin-top: 20px;
                  }
                  #sliders4{
                  margin-top: 20px;
                  }
                  #sliders5{
                  margin-top: 20px;      
                  }
                  #slidersTiming{
                  margin-top: 20px;
                  }
            /* BADGES                      */
                  .voice1Badge{
                  background: var(--main-heading-color);
                  color: black;
                  }
                  .voice2Badge{
                  background: var(--main-heading-color);
                  color: black;   
                  }
                  .voice3Badge{
                  background: var(--main-heading-color);
                  color: black;     
                  }
                  .voice4Badge{
                  background: var(--main-heading-color);
                  color: black; 
                  }
            /* AMBIANCE BUTTONS            */
                  #ambienceBtnLocation{
                  max-width: 1000px;
                  margin: auto;
                  margin-top: 0px;
                  margin-bottom: 0px;
                  }
                  #ambienceBtns{
                  width: 150px;
                  border-radius: 4px;
                  font-size: 16px;
                  font-weight: 700;      
                  }
                  #ambienceBtn1Div{
                  width: 25%;
                  }
                  #ambienceBtn2Div{
                  width: 25%;
                  }
                  #ambienceBtn3Div{
                  width: 25%;
                  }
                  #ambienceBtn4Div{
                  width: 25%;
                  }
                  #ambienceHornDiv{
                  width: 50%;
                  content: '\A';
                  white-space: pre; 
                  margin-top: 30px;     
                  }
                  #ambienceNoiseDiv{
                  width: 50%;
                  content: '\A';
                  white-space: pre; 
                  margin-top: 30px;      
                  }
                  #ambienceSlider{
                  margin-top: 20px;
                  }
                  #ambienceBadges{
                  font-size: 22px;
                  background-color:var(--main-time-color);
                  color: black; 
                  }
            /* INSTRUMENT 1 RANGER         */
                  input[class="instrument1Ranger"] {
                  -webkit-appearance: none;
                  background: var(--main-heading-color);
                  height: 10px;
                  width: 140px;
                  border-radius: 20px;
                  margin: auto;
                  transform: rotateY(180deg);
                  }
                  input[class="instrument1Ranger"]::-moz-range-track{
                  -webkit-appearance: none;
                  background: var(--main-heading-color);
                  height: 10px;
                  width: 140px;
                  border-radius: 20px;
                  margin: auto;
                  transform: rotateY(180deg);
                  }
                  input[class="instrument1Ranger"]::-webkit-slider-thumb{
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-heading-color);
                  border: 2px solid #00001E;
                  }

                  input[class="instrument1Ranger"]::-moz-range-thumb{
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-heading-color);
                  border: 2px solid #00001E;
                  }
            /* INSTRUMENT 2 RANGER         */
                  input[class="instrument2Ranger"] {
                  -webkit-appearance: none;
                  background: var(--main-heading-color);
                  height: 10px;
                  width: 140px;
                  border-radius: 20px;
                  margin: auto;
                  transform: rotateY(180deg);
                  }
                  input[class="instrument2Ranger"]::-moz-range-track{
                  -webkit-appearance: none;
                  background: var(--main-heading-color);
                  height: 10px;
                  width: 140px;
                  border-radius: 20px;
                  margin: auto;
                  transform: rotateY(180deg);
                  }
                  input[class="instrument2Ranger"]::-webkit-slider-thumb {
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-heading-color);
                  border: 2px solid #00001E;
                  }
                  input[class="instrument2Ranger"]::-moz-range-thumb{
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-heading-color);
                  border: 2px solid #00001E;
                  }
            /* INSTRUMENT 3 RANGER         */
                  input[class="instrument3Ranger"] {
                  -webkit-appearance: none;
                  background: var(--main-heading-color);
                  height: 10px;
                  width: 140px;
                  border-radius: 20px;
                  margin: auto;
                  transform: rotateY(180deg);
                  }
                  input[class="instrument3Ranger"]::-moz-range-track{
                  -webkit-appearance: none;
                  background: var(--main-heading-color);
                  height: 10px;
                  width: 140px;
                  border-radius: 20px;
                  margin: auto;
                  transform: rotateY(180deg);
                  }
                  input[class="instrument3Ranger"]::-webkit-slider-thumb {
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-heading-color);
                  border: 2px solid #00001E;
                  }
                  input[class="instrument3Ranger"]::-moz-range-thumb{
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-heading-color);
                  border: 2px solid #00001E;
                  }
            /* INSTRUMENT 4 RANGER         */
                  input[class="instrument4Ranger"] {
                  -webkit-appearance: none;
                  background: var(--main-heading-color);
                  height: 10px;
                  width: 140px;
                  border-radius: 20px;
                  margin: auto;
                  transform: rotateY(180deg);
                  }
                  input[class="instrument4Ranger"]::-moz-range-track{
                  -webkit-appearance: none;
                  background: var(--main-heading-color);
                  height: 10px;
                  width: 140px;
                  border-radius: 20px;
                  margin: auto;
                  transform: rotateY(180deg);
                  }
                  input[class="instrument4Ranger"]::-webkit-slider-thumb {
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-heading-color);
                  border: 2px solid #00001E;
                  }
                  input[class="instrument4Ranger"]::-moz-range-thumb{
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-heading-color);
                  border: 2px solid #00001E;
                  }
            /* TIMING RANGER               */
                  input[class="timingRanger"] {
                  -webkit-appearance: none;
                  background-color: var(--main-sun-color);
                  height: 10px;
                  width: 130px;
                  border-radius: 20px;
                  margin: auto;
                  }

                  input[class="timingRanger"]::-webkit-slider-thumb {
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-sun-color);
                  border: 2px solid #00001E;
                  }

                  input[class="timingRanger"]::-moz-range-track{
                  -webkit-appearance: none;
                  background-color: var(--main-sun-color);
                  height: 10px;
                  width: 130px;
                  border-radius: 20px;
                  margin: auto;
                  }

                  input[class="timingRanger"]::-moz-range-thumb{
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-sun-color);
                  border: 2px solid #00001E;
                  }
            /* DAY RANGER                  */
                  input[class="dayRanger"] {
                  -webkit-appearance: none;
                  background-color: var(--main-time-color);
                  height: 10px;
                  width: 130px;
                  border-radius: 20px;
                  margin: auto;
                  }

                  input[class="dayRanger"]::-webkit-slider-thumb {
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-time-color);
                  border: 2px solid #00001E;
                  }

                  input[class="dayRanger"]::-moz-range-track{
                  -webkit-appearance: none;
                  background-color: var(--main-time-color);
                  height: 10px;
                  width: 130px;
                  border-radius: 20px;
                  margin: auto;
                  }

                  input[class="dayRanger"]::-moz-range-thumb{
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-time-color);
                  border: 2px solid #00001E;
                  }
            /* AMBIANCE RANGER STOPPED     */
                  input[class="ambianceRangerStop"] {
                  -webkit-appearance: none;
                  background-color: var(--main-stop-color);
                  height: 10px;
                  width: 130px;
                  border-radius: 20px;
                  margin: auto;
                  }

                  input[class="ambianceRangerStop"]::-webkit-slider-thumb {
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-stop-color);
                  border: 2px solid #00001E;
                  }
                  input[class="ambianceRangerStop"]::-moz-range-track{
                  -webkit-appearance: none;
                  background-color: var(--main-stop-color);
                  height: 10px;
                  width: 130px;
                  border-radius: 20px;
                  margin: auto;
                  }
                  input[class="ambianceRangerStop"]::-moz-range-thumb{
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-stop-color);
                  border: 2px solid #00001E;
                  }
            /* AMBIANCE RANGER PLAYING     */
                  input[class="ambianceRangerPlay"] {
                  -webkit-appearance: none;
                  background-color: var(--main-start-color);
                  height: 10px;
                  width: 130px;
                  border-radius: 20px;
                  margin: auto;
                  }

                  input[class="ambianceRangerPlay"]::-webkit-slider-thumb {
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-start-color);
                  border: 2px solid #00001E;
                  }  

                  input[class="ambianceRangerPlay"]::-moz-range-track{
                  -webkit-appearance: none;
                  background-color: var(--main-start-color);
                  height: 10px;
                  width: 130px;
                  border-radius: 20px;
                  margin: auto;
                  }

                  input[class="ambianceRangerPlay"]::-moz-range-thumb{
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-start-color);
                  border: 2px solid #00001E;
                  }    
            /* MAILING LIST                */
                  #mailingListText{
                  margin: auto;
                  max-width: 200px;
                  margin-top: 75px;
                  margin-bottom: 0px;
                  font-size: 16px;   
                  font-weight: 600;   
                  }
                  #mc_embed_signup{
                  background:#fff; 
                  font-size:12px; 
                  width:100%;
                  border-color: black;
                  background-color: transparent;
                  }
                  #mce-EMAIL{
                  font-size:12px; 
                  padding: 4px 10px;
                  margin-top: 0px;  
                  font-weight: 800;
                  width: 190px;
                  border-width: 2px;
                  border-radius: 10px;
                  background-color: transparent;
                  border-color: black;
                  }
                  #mc-embedded-subscribe{
                  font-size:12px; 
                  padding: 2px 10px;
                  margin-top: 4px;
                  font-weight: 800;
                  border-width: 2px;
                  border-radius: 10px;
                  background-color: transparent;
                  border-color: black;
                  } 
      }
/** STYLINGS FOR TABLET SCREENS  < 1025px   */
      @media (min-width: 769px) and (max-width: 1023px){
                  #mainDiv{
                  padding-right: 0px;
                  padding-left: 0px;
                  max-width: 2000px;   
                  }
                  #hornBtn{
                  width: 325px; 
                  height: 50px;
                  margin-top: 20px;
                  border-width: 3px;
                  }
                  #hornBtnPrompt{
                  margin-top: 2px;
                  color: white;
                  font-size: 22px;
                  }
            /* PROMPT                      */
                  #promptText{
                  margin: auto;
                  max-width: 800px;
                  margin-top: 110px;
                  font-size: 22px;
                  color:white;   
                  }
                  #promptButton{
                  margin-top: 5px;
                  margin-bottom: 20px;
                  font-size: 20px;
                  color:white;
                  }
            /* WELCOME                     */
                  #welcomeInfoText{
                  margin-top: 50px;
                  font-size: 30px;
                  color: black;
                  font-weight: 700;
                  }
                  #welcomeMobileText{
                  color: black;
                  font-size: 18px;
                  font-weight: 700;
                  }
                  #playButton{
                  color:  white;
                  background-color:  var(--main-heading-color);
                  margin-top: 20px;
                  font-size: 20px;
                  border-width: 1px;
                  }
                  #bell{
                  color: var(--main-v1-color);      
                  }
            /* HEADINGS                    */
                  #navBar{
                  margin-top: -600px;
                  }
                  #harmonizeHeading{
                  font-size: 20px;
                  font-weight: 700;
                  margin-top: 20px;
                  margin-bottom: 0px;
                  padding: 6px 0px;
                  width: 150px;
                  border-radius: 4px;      
                  }
                   #cuteBtn{
                  font-size: 20px;
                  margin-top: 20px;
                  margin-bottom: 0px;
                  width: 45px;
                  border-radius: 45px; 
                  }
                  #ambienceHeading{
                  font-size: 20px;
                  font-weight: 700;
                  margin-top: 20px;
                  margin-bottom: 0px;
                  width: 150px;
                  border-radius: 4px;  
                  }
                  #harmonyHeadingDiv{
                  
                  }
                  #helpHeadingDiv{
                  
                  }
                  #ambianceHeadingDiv{
                  
                  }
            /* DRAGGIE CONTAINER           */
                  .masterDraggie{
                  margin-top: 100px;
                  margin-bottom: 0px;
                  width: 100%;
                  height: 100%;
                  }
                  .draggieContainer{
                  padding: 100px 300px;
                  border: 5px dotted var(--main-guide-color);
                  height: 500px;
                  width: 30%;
                  margin: auto;
                  /*width: 700px;
                  height: 600px;
                  margin-top: -200px;
                  margin-left: 800px;
                  background: transparent;
                  border-radius: 500px;
                  position: relative;*/
                  }
            /* ALL VOICE TAGS              */
                  #voiceBubbleText{
                  color:black;
                  margin-top: 35%;
                  }
                  #voiceBubbleText2{
                  color: white;
                  font-weight: 800;
                  margin-top: -10px;
                  }
            /* VOICE 1 DRAGGIE             */
                  .voice1Draggable{  
                  border-radius: 100px;
                  position: absolute;
                  background: var(--main-v1-color);
                  color: black;
                  }

                  .voice1Sizing1{
                  width: 150px;
                  height: 150px; 
                  opacity: 1;    
                  font-size: 18.5px; 
                  }

                  .voice1Sizing2{
                  width: 145px;
                  height: 145px; 
                  opacity: 0.95; 
                  font-size: 18px;    
                  }

                  .voice1Sizing3{
                  width: 140px;
                  height: 140px;
                  opacity: 0.9;  
                  font-size: 17.5px;    
                  }

                  .voice1Sizing4{
                  width: 135px;
                  height: 135px;
                  opacity: 0.85;  
                  font-size: 17px;    
                  }

                  .voice1Sizing5{
                  width: 130px;
                  height: 130px; 
                  opacity: 0.8;   
                  font-size: 16.5px;  
                  }

                  .voice1Sizing6{
                  width: 125px;
                  height: 125px; 
                  opacity: 0.75; 
                  font-size: 16px;    
                  }

                  .voice1Sizing7{
                  width: 120px;
                  height: 120px; 
                  opacity: 0.7;  
                  font-size: 15.5px;   
                  }

                  .voice1Sizing8{
                  width: 115px;
                  height: 115px; 
                  opacity: 0.65; 
                  font-size: 15px;    
                  }

                  .voice1Sizing9{
                  width: 110px;
                  height: 110px; 
                  opacity: 0.6;     
                  font-size: 14.5px;
                  }

                  .voice1Sizing10{
                  width: 105px;
                  height: 105px; 
                  opacity: 0.55;   
                  font-size: 14px;  
                  }  

                  .voice1Sizing11{
                  width: 100px;
                  height: 100px; 
                  opacity: .5;     
                  font-size: 13.5px;
                  }

                  .voice1Sizing12{
                  width: 95px;
                  height: 95px; 
                  opacity: 0.45;   
                  font-size: 13px;  
                  }

                  .voice1Sizing13{
                  width: 90px;
                  height: 90px;
                  opacity: 0.4;    
                  font-size: 12.5px;  
                  }

                  .voice1Sizing14{
                  width: 85px;
                  height: 85px;
                  opacity: 0.35;   
                  font-size: 12px;   
                  }

                  .voice1Sizing15{
                  width: 80px;
                  height: 80px; 
                  opacity: 0.3;    
                  font-size: 11.5px; 
                  }

                  .voice1Sizing16{
                  width: 75px;
                  height: 75px; 
                  opacity: 0.25;   
                  font-size: 11px;  
                  }

                  .voice1Sizing17{
                  width: 70px;
                  height: 70px; 
                  opacity: 0.2;     
                  font-size: 10.5px;
                  }

                  .voice1Sizing18{
                  width: 65px;
                  height: 65px; 
                  opacity: 0.15;     
                  font-size: 10px;
                  }

                  .voice1Sizing19{
                  width: 60px;
                  height: 60px; 
                  opacity: 0.1;     
                  font-size: 9.5px;
                  }

                  .voice1Sizing20{
                  width: 55px;
                  height: 55px; 
                  opacity: 0.05;     
                  font-size: 9px;
                  }

                  .voice1Draggable.is-dragging { opacity: 1; }
            /* VOICE 2 DRAGGIE             */
                  .voice2Draggable {
                  border-radius: 100px;
                  position: absolute;
                  background: var(--main-v2-color);
                  color: black;
                  }

                  .voice2Sizing1{
                  width: 150px;
                  height: 150px; 
                  opacity: 1;    
                  font-size: 18.5px; 
                  }

                  .voice2Sizing2{
                  width: 145px;
                  height: 145px; 
                  opacity: 0.95; 
                  font-size: 18px;    
                  }

                  .voice2Sizing3{
                  width: 140px;
                  height: 140px;
                  opacity: 0.9;  
                  font-size: 17.5px;    
                  }

                  .voice2Sizing4{
                  width: 135px;
                  height: 135px;
                  opacity: 0.85;  
                  font-size: 17px;    
                  }

                  .voice2Sizing5{
                  width: 130px;
                  height: 130px; 
                  opacity: 0.8;   
                  font-size: 16.5px;  
                  }

                  .voice2Sizing6{
                  width: 125px;
                  height: 125px; 
                  opacity: 0.75; 
                  font-size: 16px;    
                  }

                  .voice2Sizing7{
                  width: 120px;
                  height: 120px; 
                  opacity: 0.7;  
                  font-size: 15.5px;   
                  }

                  .voice2Sizing8{
                  width: 115px;
                  height: 115px; 
                  opacity: 0.65; 
                  font-size: 15px;    
                  }

                  .voice2Sizing9{
                  width: 110px;
                  height: 110px; 
                  opacity: 0.6;     
                  font-size: 14.5px;
                  }

                  .voice2Sizing10{
                  width: 105px;
                  height: 105px; 
                  opacity: 0.55;   
                  font-size: 14px;  
                  }  

                  .voice2Sizing11{
                  width: 100px;
                  height: 100px; 
                  opacity: .5;     
                  font-size: 13.5px;
                  }

                  .voice2Sizing12{
                  width: 95px;
                  height: 95px; 
                  opacity: 0.45;   
                  font-size: 13px;  
                  }

                  .voice2Sizing13{
                  width: 90px;
                  height: 90px;
                  opacity: 0.4;    
                  font-size: 12.5px;  
                  }

                  .voice2Sizing14{
                  width: 85px;
                  height: 85px;
                  opacity: 0.35;   
                  font-size: 12px;   
                  }

                  .voice2Sizing15{
                  width: 80px;
                  height: 80px; 
                  opacity: 0.3;    
                  font-size: 11.5px; 
                  }

                  .voice2Sizing16{
                  width: 75px;
                  height: 75px; 
                  opacity: 0.25;   
                  font-size: 11px;  
                  }

                  .voice2Sizing17{
                  width: 70px;
                  height: 70px; 
                  opacity: 0.2;     
                  font-size: 10.5px;
                  }

                  .voice2Sizing18{
                  width: 65px;
                  height: 65px; 
                  opacity: 0.15;     
                  font-size: 10px;
                  }

                  .voice2Sizing19{
                  width: 60px;
                  height: 60px; 
                  opacity: 0.1;     
                  font-size: 9.5px;
                  }

                  .voice2Sizing20{
                  width: 55px;
                  height: 55px; 
                  opacity: 0.05;     
                  font-size: 9px;
                  }

                  .voice2Draggable.is-dragging { opacity: 1; }
            /* VOICE 3 DRAGGIE             */
                  .voice3Draggable {
                  border-radius: 100px;
                  position: absolute;
                  background: var(--main-v3-color);
                  color: black;
                  }

                  .voice3Sizing1{
                  width: 150px;
                  height: 150px; 
                  opacity: 1;    
                  font-size: 18.5px; 
                  }

                  .voice3Sizing2{
                  width: 145px;
                  height: 145px; 
                  opacity: 0.95; 
                  font-size: 18px;    
                  }

                  .voice3Sizing3{
                  width: 140px;
                  height: 140px;
                  opacity: 0.9;  
                  font-size: 17.5px;    
                  }

                  .voice3Sizing4{
                  width: 135px;
                  height: 135px;
                  opacity: 0.85;  
                  font-size: 17px;    
                  }

                  .voice3Sizing5{
                  width: 130px;
                  height: 130px; 
                  opacity: 0.8;   
                  font-size: 16.5px;  
                  }

                  .voice3Sizing6{
                  width: 125px;
                  height: 125px; 
                  opacity: 0.75; 
                  font-size: 16px;    
                  }

                  .voice3Sizing7{
                  width: 120px;
                  height: 120px; 
                  opacity: 0.7;  
                  font-size: 15.5px;   
                  }

                  .voice3Sizing8{
                  width: 115px;
                  height: 115px; 
                  opacity: 0.65; 
                  font-size: 15px;    
                  }

                  .voice3Sizing9{
                  width: 110px;
                  height: 110px; 
                  opacity: 0.6;     
                  font-size: 14.5px;
                  }

                  .voice3Sizing10{
                  width: 105px;
                  height: 105px; 
                  opacity: 0.55;   
                  font-size: 14px;  
                  }  

                  .voice3Sizing11{
                  width: 100px;
                  height: 100px; 
                  opacity: .5;     
                  font-size: 13.5px;
                  }

                  .voice3Sizing12{
                  width: 95px;
                  height: 95px; 
                  opacity: 0.45;   
                  font-size: 13px;  
                  }

                  .voice3Sizing13{
                  width: 90px;
                  height: 90px;
                  opacity: 0.4;    
                  font-size: 12.5px;  
                  }

                  .voice3Sizing14{
                  width: 85px;
                  height: 85px;
                  opacity: 0.35;   
                  font-size: 12px;   
                  }

                  .voice3Sizing15{
                  width: 80px;
                  height: 80px; 
                  opacity: 0.3;    
                  font-size: 11.5px; 
                  }

                  .voice3Sizing16{
                  width: 75px;
                  height: 75px; 
                  opacity: 0.25;   
                  font-size: 11px;  
                  }

                  .voice3Sizing17{
                  width: 70px;
                  height: 70px; 
                  opacity: 0.2;     
                  font-size: 10.5px;
                  }

                  .voice3Sizing18{
                  width: 65px;
                  height: 65px; 
                  opacity: 0.15;     
                  font-size: 10px;
                  }

                  .voice3Sizing19{
                  width: 60px;
                  height: 60px; 
                  opacity: 0.1;     
                  font-size: 9.5px;
                  }

                  .voice3Sizing20{
                  width: 55px;
                  height: 55px; 
                  opacity: 0.05;     
                  font-size: 8px;
                  }

                  .voice3Draggable.is-dragging { opacity: 1; }
            /* VOICE 4 DRAGGIE             */
                  .voice4Draggable {
                  border-radius: 100px;
                  position: absolute;
                  background: var(--main-v4-color);
                  color: black;
                  }

                  .voice4Sizing1{
                  width: 150px;
                  height: 150px; 
                  opacity: 1;    
                  font-size: 18.5px; 
                  }

                  .voice4Sizing2{
                  width: 145px;
                  height: 145px; 
                  opacity: 0.95; 
                  font-size: 18px;    
                  }

                  .voice4Sizing3{
                  width: 140px;
                  height: 140px;
                  opacity: 0.9;  
                  font-size: 17.5px;    
                  }

                  .voice4Sizing4{
                  width: 135px;
                  height: 135px;
                  opacity: 0.85;  
                  font-size: 17px;    
                  }

                  .voice4Sizing5{
                  width: 130px;
                  height: 130px; 
                  opacity: 0.8;   
                  font-size: 16.5px;  
                  }

                  .voice4Sizing6{
                  width: 125px;
                  height: 125px; 
                  opacity: 0.75; 
                  font-size: 16px;    
                  }

                  .voice4Sizing7{
                  width: 120px;
                  height: 120px; 
                  opacity: 0.7;  
                  font-size: 15.5px;   
                  }

                  .voice4Sizing8{
                  width: 115px;
                  height: 115px; 
                  opacity: 0.65; 
                  font-size: 15px;    
                  }

                  .voice4Sizing9{
                  width: 110px;
                  height: 110px; 
                  opacity: 0.6;     
                  font-size: 14.5px;
                  }

                  .voice4Sizing10{
                  width: 105px;
                  height: 105px; 
                  opacity: 0.55;   
                  font-size: 14px;  
                  }  

                  .voice4Sizing11{
                  width: 100px;
                  height: 100px; 
                  opacity: .5;     
                  font-size: 13.5px;
                  }

                  .voice4Sizing12{
                  width: 95px;
                  height: 95px; 
                  opacity: 0.45;   
                  font-size: 13px;  
                  }

                  .voice4Sizing13{
                  width: 90px;
                  height: 90px;
                  opacity: 0.4;    
                  font-size: 12.5px;  
                  }

                  .voice4Sizing14{
                  width: 85px;
                  height: 85px;
                  opacity: 0.35;   
                  font-size: 12px;   
                  }

                  .voice4Sizing15{
                  width: 80px;
                  height: 80px; 
                  opacity: 0.3;    
                  font-size: 11.5px; 
                  }

                  .voice4Sizing16{
                  width: 75px;
                  height: 75px; 
                  opacity: 0.25;   
                  font-size: 11px;  
                  }

                  .voice4Sizing17{
                  width: 70px;
                  height: 70px; 
                  opacity: 0.2;     
                  font-size: 10.5px;
                  }

                  .voice4Sizing18{
                  width: 65px;
                  height: 65px; 
                  opacity: 0.15;     
                  font-size: 10px;
                  }

                  .voice4Sizing19{
                  width: 60px;
                  height: 60px; 
                  opacity: 0.1;     
                  font-size: 9.5px;
                  }

                  .voice4Sizing20{
                  width: 55px;
                  height: 55px; 
                  opacity: 0.05;     
                  font-size: 9px;
                  }

                  .voice4Draggable.is-dragging { opacity: 1; }
            /* ABOUT DRAGGIE               */
                  .aboutDraggable{  
                  width: 275px;
                  height: 275px;
                  border-radius: 275px;
                  background: white;
                  opacity: 1;
                  color: black;
                  position: absolute;
                  font-size: 50px;
                  border: var(--main-border-color);
                  }
                  #createdByHeader{
                  font-size: 24px;
                  margin-top: 30px;
                  font-weight: 600;      
                  }
                  #aboutTextID{
                  font-size: 24px;
                  margin-top: 20px;
                  }
                  #newINC{
                  margin-top: -5px;
                  font-size: 18px;  
                  margin-bottom: -30px;    
                  }
                  .about2Draggable{  
                  width: 320px;
                  height: 320px;
                  border-radius: 300px;
                  background: white;
                  opacity: 1;
                  color: black;
                  position: absolute;
                  font-size: 50px;
                  border: var(--main-border-color);
                  }
                  #about2TextID{
                  max-width: 250px;
                  margin: auto;
                  font-size: 24px;
                  margin-top: 40px;
                  font-weight: 600; 
                  }
                  #about2TextID1{
                  font-size: 16px;
                  margin-top: 10px; 
                  text-align: left;
                  margin-left: 60px;     
                  }
                  .about3Draggable{  
                  width: 400px;
                  height: 400px;
                  border-radius: 325px;
                  background: white;
                  opacity: 1;
                  color: black;
                  position: absolute;
                  font-size: 50px;
                  border: var(--main-border-color);
                  }
                  #about3TextHeader{
                  font-size: 30px;
                  max-width: 255px;
                  margin: auto;
                  margin-top: 20px; 
                  font-weight: 600;       
                  }
                  #about3TextID{
                  font-size: 15px;
                  max-width: 315px;
                  margin: auto;
                  margin-top: 20px;
                  }
                  .about4Draggable{  
                  width: 250px;
                  height: 250px;
                  border-radius: 400px;
                  opacity: 1;
                  color: black;
                  position: absolute;
                  font-size: 50px;
                  background: white;
                  }
            /* PLAY SUN DRAGGIE            */
                  #sunLoadText1{
                  font-size: 23px;
                  margin-top: 66px;
                  font-weight: 700;      
                  }
                  #sunLoadText2{
                  font-size: 14px;
                  margin-top: -12px;
                  font-weight: 700;       
                  }
                  #sunTextID{
                  font-size: 16px;
                  margin-top: 55px;
                  font-weight: 700;
                  }
                  #sunTextID2{
                  font-size: 12px;
                  margin-top: -15px;
                  font-weight: 700;      
                  }
                  #togetherText{
                  font-size: 24px;
                  margin-top: -25px;
                  font-weight: 700;      
                  }
                  .playSunDraggable {
                  width: 150px;
                  height: 150px;
                  color: black;
                  background: white;
                  border-radius: 100px;
                  opacity: 1;
                  position: absolute;
                  }
                  .playSunDraggable.is-pointer-down {
                  opacity: 1;
                  }
                  .playSunDraggable.is-dragging { 
                  opacity: 1;
                  }
            /* REVERB COLORING             */
                  .reverbSizing1{
                  background: #000000;
                  /*width: 100%;
                  height: 100%;*/
                  -webkit-background-size: cover;
                  -moz-background-size: cover;
                  -o-background-size: cover;
                  background-size: cover;
                  background:...;
                  }

                  .reverbSizing2{
                  background: #101010;
                  /*opacity: .95; */
                  }

                  .reverbSizing3{
                  background: #202020;
                  /*opacity: 0.9; */
                  }

                  .reverbSizing4{
                  background: #282828;
                  /*opacity: 0.85;  */
                  }

                  .reverbSizing5{
                  background: #303030; 
                  /*opacity: 0.8;  */
                  }

                  .reverbSizing6{
                  background: #383838;
                  /*opacity*/: 0.75; 
                  }

                  .reverbSizing7{
                  background: #484848;
                  /*opacity*/: 0.7; 
                  }

                  .reverbSizing8{
                  background: #585858;
                  /*opacity*/: 0.65; 
                  }

                  .reverbSizing9{
                  background: #696969;
                  /*opacity*/: 0.6;    
                  }

                  .reverbSizing10{
                  background: #808080;
                  /*opacity*/: 0.55; 
                  }  

                  .reverbSizing11{
                  background: #909090; 
                  /*opacity*/: 0.5;   
                  }

                  .reverbSizing12{
                  background: #A0A0A0;
                  /*opacity*/: 0.45; 
                  }

                  .reverbSizing13{
                  background: #A9A9A9;
                  /*opacity*/: 0.4; 
                  }

                  .reverbSizing14{
                  background: #B8B8B8;
                  /*opacity*/: 0.35; 
                  }

                  .reverbSizing15{
                  background: #C0C0C0;
                  /*opacity*/: 0.3; 
                  }

                  .reverbSizing16{
                  background: #D3D3D3;
                  /*opacity: 0.25; */
                  }

                  .reverbSizing17{
                  background: #DCDCDC;
                  /*opacity: 0.2;     */
                  }

                  .reverbSizing18{
                  background: #E8E8E8;
                  /*opacity: 0.15; */
                  }

                  .reverbSizing19{
                  background: #F5F5F5;
                  /*opacity: 0.1; */
                  }

                  .reverbSizing20{
                  background: #FFFFFF;
                 /* opacity: 0.05; */ 
                  }
            /* MISSON CONTROL              */
                  #controlsContainer{
                  max-width: 1000px;
                  margin: auto;
                  margin-top: 75px;
                  margin-bottom: 50px;
                  height: 400px;
                  }
                  #masterControlDiv{
                  margin-top: 0px;
                  margin-bottom: 0px;
                  }
                  #masterControlBadges{
                  padding: 8px 8px;
                  font-size: 17px;
                  font-weight: 700;
                  width: 160px;
                  color: black; 
                  border: 2px solid black;
                  }
                  #masterTimingBadges{
                  padding: 8px 8px;
                  font-size: 17px;
                  font-weight: 700;
                  background-color: var(--main-time-color);
                  color: black; 
                  width: 150px;
                  border: 2px solid black;
                  }
                  #voice1SliderDiv{
                  width: 25%;
                  }
                  #voice2SliderDiv{
                  width: 25%;
                  }
                  #voice3SliderDiv{
                  width: 25%;
                  }
                  #voice4SliderDiv{
                  width: 25%;
                  }
                  #timingSmoosh{
                  max-width: 500px;
                  margin: auto;     
                  }
                  #timingSliderDiv{
                  width: 50%;
                  content: '\A';
                  white-space: pre; 
                  margin-top: 30px;
                  }
                  #daySliderDiv{
                  width: 50%;
                  content: '\A';
                  white-space: pre; 
                  margin-top: 30px;
                  }
                  #sliders1{
                  margin-top: 20px;
                  }
                  #sliders2{
                  margin-top: 20px;
                  }
                  #sliders3{
                  margin-top: 20px;
                  }
                  #sliders4{
                  margin-top: 20px;
                  }
                  #sliders5{
                  margin-top: 20px;      
                  }
                  #slidersTiming{
                  margin-top: 20px;
                  }
            /* BADGES                      */
                  .voice1Badge{
                  background: var(--main-heading-color);
                  color: black;
                  }
                  .voice2Badge{
                  background: var(--main-heading-color);
                  color: black;   
                  }
                  .voice3Badge{
                  background: var(--main-heading-color);
                  color: black;     
                  }
                  .voice4Badge{
                  background: var(--main-heading-color);
                  color: black; 
                  }
            /* AMBIANCE BUTTONS            */
                  #ambienceBtnLocation{
                  max-width: 1000px;
                  margin: auto;
                  margin-top: 0px;
                  margin-bottom: 0px;
                  }
                  #ambienceBtns{
                  width: 150px;
                  border-radius: 4px;
                  font-size: 16px;
                  font-weight: 700;      
                  }
                  #ambienceBtn1Div{
                  width: 25%;
                  }
                  #ambienceBtn2Div{
                  width: 25%;
                  }
                  #ambienceBtn3Div{
                  width: 25%;
                  }
                  #ambienceBtn4Div{
                  width: 25%;
                  }
                  #ambienceHornDiv{
                  width: 50%;
                  content: '\A';
                  white-space: pre; 
                  margin-top: 30px;     
                  }
                  #ambienceNoiseDiv{
                  width: 50%;
                  content: '\A';
                  white-space: pre; 
                  margin-top: 30px;      
                  }
                  #ambienceSlider{
                  margin-top: 20px;
                  }
                  #ambienceBadges{
                  font-size: 22px;
                  background-color:var(--main-time-color);
                  color: black; 
                  }
            /* INSTRUMENT 1 RANGER         */
                  input[class="instrument1Ranger"] {
                  -webkit-appearance: none;
                  background: var(--main-heading-color);
                  height: 10px;
                  width: 140px;
                  border-radius: 20px;
                  margin: auto;
                  transform: rotateY(180deg);
                  }
                  input[class="instrument1Ranger"]::-moz-range-track{
                  -webkit-appearance: none;
                  background: var(--main-heading-color);
                  height: 10px;
                  width: 140px;
                  border-radius: 20px;
                  margin: auto;
                  transform: rotateY(180deg);
                  }
                  input[class="instrument1Ranger"]::-webkit-slider-thumb{
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-heading-color);
                  border: 2px solid #00001E;
                  }

                  input[class="instrument1Ranger"]::-moz-range-thumb{
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-heading-color);
                  border: 2px solid #00001E;
                  }
            /* INSTRUMENT 2 RANGER         */
                  input[class="instrument2Ranger"] {
                  -webkit-appearance: none;
                  background: var(--main-heading-color);
                  height: 10px;
                  width: 140px;
                  border-radius: 20px;
                  margin: auto;
                  transform: rotateY(180deg);
                  }
                  input[class="instrument2Ranger"]::-moz-range-track{
                  -webkit-appearance: none;
                  background: var(--main-heading-color);
                  height: 10px;
                  width: 140px;
                  border-radius: 20px;
                  margin: auto;
                  transform: rotateY(180deg);
                  }
                  input[class="instrument2Ranger"]::-webkit-slider-thumb {
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-heading-color);
                  border: 2px solid #00001E;
                  }
                  input[class="instrument2Ranger"]::-moz-range-thumb{
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-heading-color);
                  border: 2px solid #00001E;
                  }
            /* INSTRUMENT 3 RANGER         */
                  input[class="instrument3Ranger"] {
                  -webkit-appearance: none;
                  background: var(--main-heading-color);
                  height: 10px;
                  width: 140px;
                  border-radius: 20px;
                  margin: auto;
                  transform: rotateY(180deg);
                  }
                  input[class="instrument3Ranger"]::-moz-range-track{
                  -webkit-appearance: none;
                  background: var(--main-heading-color);
                  height: 10px;
                  width: 140px;
                  border-radius: 20px;
                  margin: auto;
                  transform: rotateY(180deg);
                  }
                  input[class="instrument3Ranger"]::-webkit-slider-thumb {
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-heading-color);
                  border: 2px solid #00001E;
                  }
                  input[class="instrument3Ranger"]::-moz-range-thumb{
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-heading-color);
                  border: 2px solid #00001E;
                  }
            /* INSTRUMENT 4 RANGER         */
                  input[class="instrument4Ranger"] {
                  -webkit-appearance: none;
                  background: var(--main-heading-color);
                  height: 10px;
                  width: 140px;
                  border-radius: 20px;
                  margin: auto;
                  transform: rotateY(180deg);
                  }
                  input[class="instrument4Ranger"]::-moz-range-track{
                  -webkit-appearance: none;
                  background: var(--main-heading-color);
                  height: 10px;
                  width: 140px;
                  border-radius: 20px;
                  margin: auto;
                  transform: rotateY(180deg);
                  }
                  input[class="instrument4Ranger"]::-webkit-slider-thumb {
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-heading-color);
                  border: 2px solid #00001E;
                  }
                  input[class="instrument4Ranger"]::-moz-range-thumb{
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-heading-color);
                  border: 2px solid #00001E;
                  }
            /* TIMING RANGER               */
                  input[class="timingRanger"] {
                  -webkit-appearance: none;
                  background-color: var(--main-sun-color);
                  height: 10px;
                  width: 130px;
                  border-radius: 20px;
                  margin: auto;
                  }

                  input[class="timingRanger"]::-webkit-slider-thumb {
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-sun-color);
                  border: 2px solid #00001E;
                  }

                  input[class="timingRanger"]::-moz-range-track{
                  -webkit-appearance: none;
                  background-color: var(--main-sun-color);
                  height: 10px;
                  width: 130px;
                  border-radius: 20px;
                  margin: auto;
                  }

                  input[class="timingRanger"]::-moz-range-thumb{
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-sun-color);
                  border: 2px solid #00001E;
                  }
            /* DAY RANGER                  */
                  input[class="dayRanger"] {
                  -webkit-appearance: none;
                  background-color: var(--main-time-color);
                  height: 10px;
                  width: 130px;
                  border-radius: 20px;
                  margin: auto;
                  }

                  input[class="dayRanger"]::-webkit-slider-thumb {
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-time-color);
                  border: 2px solid #00001E;
                  }

                  input[class="dayRanger"]::-moz-range-track{
                  -webkit-appearance: none;
                  background-color: var(--main-time-color);
                  height: 10px;
                  width: 130px;
                  border-radius: 20px;
                  margin: auto;
                  }

                  input[class="dayRanger"]::-moz-range-thumb{
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-time-color);
                  border: 2px solid #00001E;
                  }
            /* AMBIANCE RANGER STOPPED     */
                  input[class="ambianceRangerStop"] {
                  -webkit-appearance: none;
                  background-color: var(--main-stop-color);
                  height: 10px;
                  width: 130px;
                  border-radius: 20px;
                  margin: auto;
                  }

                  input[class="ambianceRangerStop"]::-webkit-slider-thumb {
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-stop-color);
                  border: 2px solid #00001E;
                  }
                  input[class="ambianceRangerStop"]::-moz-range-track{
                  -webkit-appearance: none;
                  background-color: var(--main-stop-color);
                  height: 10px;
                  width: 130px;
                  border-radius: 20px;
                  margin: auto;
                  }
                  input[class="ambianceRangerStop"]::-moz-range-thumb{
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-stop-color);
                  border: 2px solid #00001E;
                  }
            /* AMBIANCE RANGER PLAYING     */
                  input[class="ambianceRangerPlay"] {
                  -webkit-appearance: none;
                  background-color: var(--main-start-color);
                  height: 10px;
                  width: 130px;
                  border-radius: 20px;
                  margin: auto;
                  }

                  input[class="ambianceRangerPlay"]::-webkit-slider-thumb {
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-start-color);
                  border: 2px solid #00001E;
                  }  

                  input[class="ambianceRangerPlay"]::-moz-range-track{
                  -webkit-appearance: none;
                  background-color: var(--main-start-color);
                  height: 10px;
                  width: 130px;
                  border-radius: 20px;
                  margin: auto;
                  }

                  input[class="ambianceRangerPlay"]::-moz-range-thumb{
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-start-color);
                  border: 2px solid #00001E;
                  }    
            /* MAILING LIST                */
                  #mailingListText{
                  margin: auto;
                  max-width: 200px;
                  margin-top: 80px;
                  margin-bottom: 0px;
                  font-size: 16px;  
                  font-weight: 600;      
                  }
                  #mc_embed_signup{
                  background:#fff; 
                  font-size:12px; 
                  width:100%;
                  border-color: black;
                  background-color: transparent;
                  }
                  #mce-EMAIL{
                  font-size:12px; 
                  padding: 4px 10px;
                  margin-top: 0px;  
                  font-weight: 800;
                  width: 225px;
                  border-width: 2px;
                  border-radius: 10px;
                  background-color: transparent;
                  border-color: black;
                  }
                  #mc-embedded-subscribe{
                  font-size:12px; 
                  padding: 2px 10px;
                  margin-top: 4px;
                  font-weight: 800;
                  border-width: 2px;
                  border-radius: 10px;
                  background-color: transparent;
                  border-color: black;
                  } 
      }
/** STYLINGS FOR BIG TABLET SCREENS  > 769px   */
      @media (min-width: 1024px) and (max-width: 1299px){
                  #mainDiv{
                  padding-right: 0px;
                  padding-left: 0px;
                  max-width: 2000px;   
                  }
                  #hornBtn{
                  width: 400px; 
                  height: 60px;
                  margin-top: 20px;
                  border-width: 3px;
                  }
                  #hornBtnPrompt{
                  margin-top: 2px;
                  color: white;
                  font-size: 26px;
                  }
      @media (max-height: 549px) {
                  #controlsContainer{
                  max-width: 1200px;
                  margin: auto;
                  margin-top: -22%;
                  margin-bottom: 50px;
                  height: 400px;
                  }
                  /* PROMPT                      */
                  #promptText{
                  max-width: 450px;
                  margin-top: -25%;
                  font-size: 24px;
                  color:white;   
                  }
                  #promptButton{
                  margin-left: -70%;
                  margin-top: 5px;
                  margin-bottom: 0px;
                  font-size: 20px;
                  color:white;
                  }
      }
      @media (min-height: 550px) and (max-height: 600px) {
                  #controlsContainer{
                  max-width: 1200px;
                  margin: auto;
                  margin-top: -20%;
                  margin-bottom: 50px;
                  height: 400px;
                  }
                  /* PROMPT                      */
                  #promptText{
                  max-width: 450px;
                  margin-top: -25%;
                  font-size: 24px;
                  color:white;   
                  }
                  #promptButton{
                  margin-left: -70%;
                  margin-top: 5px;
                  margin-bottom: 0px;
                  font-size: 20px;
                  color:white;
                  }
      }
      @media (min-height: 601px) and (max-height: 649px) {
                  #controlsContainer{
                  max-width: 1200px;
                  margin: auto;
                  margin-top: -18%;
                  margin-bottom: 50px;
                  height: 400px;
                  }
                  /* PROMPT                      */
                  #promptText{
                  max-width: 450px;
                  margin-top: -25%;
                  font-size: 24px;
                  color:white;   
                  }
                  #promptButton{
                  margin-left: -70%;
                  margin-top: 5px;
                  margin-bottom: 0px;
                  font-size: 20px;
                  color:white;
                  }
      }
      @media (min-height: 650px) and (max-height: 700px) {
                  #controlsContainer{
                  max-width: 1200px;
                  margin: auto;
                  margin-top: -15%;
                  margin-bottom: 50px;
                  height: 400px;
                  }
                  /* PROMPT                      */
                  #promptText{
                  max-width: 450px;
                  margin-top: -25%;
                  font-size: 24px;
                  color:white;   
                  }
                  #promptButton{
                  margin-left: -70%;
                  margin-top: 5px;
                  margin-bottom: 0px;
                  font-size: 20px;
                  color:white;
                  }
      }
      @media (min-height: 701px) and (max-height: 749px) {
                  #controlsContainer{
                  max-width: 1200px;
                  margin: auto;
                  margin-top: -13%;
                  margin-bottom: 50px;
                  height: 400px;
                  }
                  /* PROMPT                      */
                  #promptText{
                  max-width: 450px;
                  margin-top: -25%;
                  font-size: 24px;
                  color:white;   
                  }
                  #promptButton{
                  margin-left: -70%;
                  margin-top: 5px;
                  margin-bottom: 0px;
                  font-size: 20px;
                  color:white;
                  }
      }
      @media (min-height: 750px) and (max-height: 900px) {
                  #controlsContainer{
                  max-width: 1200px;
                  margin: auto;
                  margin-top: -12%;
                  margin-bottom: 50px;
                  height: 400px;
                  }
                  /* PROMPT                      */
                  #promptText{
                  max-width: 450px;
                  margin-top: -25%;
                  font-size: 24px;
                  color:white;   
                  }
                  #promptButton{
                  margin-left: -70%;
                  margin-top: 5px;
                  margin-bottom: 0px;
                  font-size: 20px;
                  color:white;
                  }
      }
      @media (min-height: 901px) and (max-height: 1000px) {
                  #controlsContainer{
                  max-width: 1200px;
                  margin: auto;
                  margin-top: -5%;
                  margin-bottom: 50px;
                  height: 400px;
                  }
                  /* PROMPT                      */
                  #promptText{
                  max-width: 450px;
                  margin-top: -25%;
                  font-size: 24px;
                  color:white;   
                  }
                  #promptButton{
                  margin-left: -70%;
                  margin-top: 5px;
                  margin-bottom: 0px;
                  font-size: 20px;
                  color:white;
                  }
      }
      @media (min-height: 1001px) and (max-height: 1100px) {
                  #controlsContainer{
                  max-width: 1200px;
                  margin: auto;
                  margin-top: 0%;
                  margin-bottom: 50px;
                  height: 400px;
                  }
                  /* PROMPT                      */
                  #promptText{
                  margin: auto;
                  max-width: 800px;
                  margin-top: -2%;
                  font-size: 24px;
                  color:white;   
                  }
                  #promptButton{
                  margin-top: 5px;
                  margin-bottom: 30px;
                  font-size: 20px;
                  color:white;
                  }
      }
      @media (min-height: 1101px) {
                  #controlsContainer{
                  max-width: 1200px;
                  margin: auto;
                  margin-top: 10%;
                  margin-bottom: 50px;
                  height: 400px;
                  }
                  /* PROMPT                      */
                  #promptText{
                  margin: auto;
                  max-width: 800px;
                  margin-top: 5%;
                  font-size: 24px;
                  color:white;   
                  }
                  #promptButton{
                  margin-top: 5px;
                  margin-bottom: 30px;
                  font-size: 20px;
                  color:white;
                  }
      }
            /* PROMPT                      */
                  /*#promptText{
                  margin: auto;
                  max-width: 800px;
                  margin-top: 50px;
                  font-size: 24px;
                  color:white;   
                  }
                  #promptButton{
                  margin-top: 5px;
                  margin-bottom: 30px;
                  font-size: 20px;
                  color:white;
                  }*/
            /* WELCOME                     */
                  #welcomeInfoText{
                  margin-top: 50px;
                  font-size: 30px;
                  color: black;
                  font-weight: 700;
                  }
                  #welcomeMobileText{
                  color: black;
                  font-size: 18px;
                  font-weight: 700;
                  }
                  #playButton{
                  color:  white;
                  background-color:  var(--main-heading-color);
                  margin-top: 20px;
                  font-size: 20px;
                  border-width: 1px;
                  }
                  #bell{
                  color: var(--main-v1-color);      
                  }
            /* HEADINGS                    */
                  #navBar{
                  margin-top: -700px;
                  }
                  #harmonizeHeading{
                  font-size: 24px;
                  font-weight: 700;
                  margin-top: 20px;
                  margin-bottom: 0px;
                  width: 200px;
                  border-radius: 4px;      
                  }
                  #cuteBtn{
                  font-size: 24px;
                  margin-top: 20px;
                  margin-bottom: 0px;
                  width: 50px;
                  border-radius: 50px; 
                  }
                  #ambienceHeading{
                  font-size: 24px;
                  font-weight: 700;
                  margin-top: 20px;
                  margin-bottom: 0px;
                  width: 200px;
                  border-radius: 4px;  
                  }
                  #harmonyHeadingDiv{
                  
                  }
                  #helpHeadingDiv{
                  
                  }
                  #ambianceHeadingDiv{
                  
                  }
            /* DRAGGIE CONTAINER           */
                  .masterDraggie{
                  margin-top: 100px;
                  margin-bottom: 0px;
                  width: 100%;
                  height: 100%;
                  }
                  .draggieContainer{
                  padding: 100px 300px;
                  border: 5px dotted var(--main-guide-color);
                  height: 600px;
                  width: 50%;
                  margin: auto;
                  /*width: 700px;
                  height: 600px;
                  margin-top: -200px;
                  margin-left: 800px;
                  background: transparent;
                  border-radius: 500px;
                  position: relative;*/
                  }
            /* ALL VOICE TAGS              */
                  #voiceBubbleText{
                  color:black;
                  margin-top: 30%;
                  }
                  #voiceBubbleText2{
                  color: white;
                  font-weight: 800;
                  margin-top: -10px;
                  }
            /* VOICE 1 DRAGGIE             */
                  .voice1Draggable{  
                  border-radius: 100px;
                  position: absolute;
                  background: var(--main-v1-color);
                  color: black;
                  }

                  .voice1Sizing1{
                  width: 175px;
                  height: 175px; 
                  opacity: 1;    
                  font-size: 24px; 
                  }

                  .voice1Sizing2{
                  width: 170px;
                  height: 170px; 
                  opacity: 0.95; 
                  font-size: 20px;    
                  }

                  .voice1Sizing3{
                  width: 165px;
                  height: 165px;
                  opacity: 0.9;  
                  font-size: 19.5px;    
                  }

                  .voice1Sizing4{
                  width: 160px;
                  height: 160px;
                  opacity: 0.85;  
                  font-size: 19px;    
                  }

                  .voice1Sizing5{
                  width: 155px;
                  height: 155px; 
                  opacity: 0.8;   
                  font-size: 18.5px;  
                  }

                  .voice1Sizing6{
                  width: 150px;
                  height: 150px; 
                  opacity: 0.75; 
                  font-size: 18px;    
                  }

                  .voice1Sizing7{
                  width: 145px;
                  height: 145px; 
                  opacity: 0.7;  
                  font-size: 17.5px;   
                  }

                  .voice1Sizing8{
                  width: 140px;
                  height: 140px; 
                  opacity: 0.65; 
                  font-size: 17px;    
                  }

                  .voice1Sizing9{
                  width: 135px;
                  height: 135px; 
                  opacity: 0.6;     
                  font-size: 16.5px;
                  }

                  .voice1Sizing10{
                  width: 130px;
                  height: 130px; 
                  opacity: 0.55;   
                  font-size: 16px;  
                  }  

                  .voice1Sizing11{
                  width: 125px;
                  height: 125px; 
                  opacity: .5;     
                  font-size: 15.5px;
                  }

                  .voice1Sizing12{
                  width: 120px;
                  height: 120px; 
                  opacity: 0.45;   
                  font-size: 15px;  
                  }

                  .voice1Sizing13{
                  width: 115px;
                  height: 115px;
                  opacity: 0.4;    
                  font-size: 14.5px;  
                  }

                  .voice1Sizing14{
                  width: 110px;
                  height: 110px;
                  opacity: 0.35;   
                  font-size: 14px;   
                  }

                  .voice1Sizing15{
                  width: 105px;
                  height: 105px; 
                  opacity: 0.3;    
                  font-size: 13.5px; 
                  }

                  .voice1Sizing16{
                  width: 100px;
                  height: 100px; 
                  opacity: 0.25;   
                  font-size: 13px;  
                  }

                  .voice1Sizing17{
                  width: 95px;
                  height: 95px; 
                  opacity: 0.2;     
                  font-size: 12.5px;
                  }

                  .voice1Sizing18{
                  width: 90px;
                  height: 90px; 
                  opacity: 0.15;     
                  font-size: 12px;
                  }

                  .voice1Sizing19{
                  width: 85px;
                  height: 85px; 
                  opacity: 0.1;     
                  font-size: 11.5px;
                  }

                  .voice1Sizing20{
                  width: 80px;
                  height: 80px; 
                  opacity: 0.05;     
                  font-size: 11px;
                  }

                 
                  .voice1Draggable.is-dragging { opacity: 1; }
            /* VOICE 2 DRAGGIE             */
                  .voice2Draggable {
                  border-radius: 100px;
                  position: absolute;
                  background: var(--main-v2-color);
                  color: black;
                  }

                  .voice2Sizing1{
                  width: 175px;
                  height: 175px; 
                  opacity: 1;    
                  font-size: 20.5px; 
                  }

                  .voice2Sizing2{
                  width: 170px;
                  height: 170px; 
                  opacity: 0.95; 
                  font-size: 20px;    
                  }

                  .voice2Sizing3{
                  width: 165px;
                  height: 165px;
                  opacity: 0.9;  
                  font-size: 19.5px;    
                  }

                  .voice2Sizing4{
                  width: 160px;
                  height: 160px;
                  opacity: 0.85;  
                  font-size: 19px;    
                  }

                  .voice2Sizing5{
                  width: 155px;
                  height: 155px; 
                  opacity: 0.8;   
                  font-size: 18.5px;  
                  }

                  .voice2Sizing6{
                  width: 150px;
                  height: 150px; 
                  opacity: 0.75; 
                  font-size: 18px;    
                  }

                  .voice2Sizing7{
                  width: 145px;
                  height: 145px; 
                  opacity: 0.7;  
                  font-size: 17.5px;   
                  }

                  .voice2Sizing8{
                  width: 140px;
                  height: 140px; 
                  opacity: 0.65; 
                  font-size: 17px;    
                  }

                  .voice2Sizing9{
                  width: 135px;
                  height: 135px; 
                  opacity: 0.6;     
                  font-size: 16.5px;
                  }

                  .voice2Sizing10{
                  width: 130px;
                  height: 130px; 
                  opacity: 0.55;   
                  font-size: 16px;  
                  }  

                  .voice2Sizing11{
                  width: 125px;
                  height: 125px; 
                  opacity: .5;     
                  font-size: 15.5px;
                  }

                  .voice2Sizing12{
                  width: 120px;
                  height: 120px; 
                  opacity: 0.45;   
                  font-size: 15px;  
                  }

                  .voice2Sizing13{
                  width: 115px;
                  height: 115px;
                  opacity: 0.4;    
                  font-size: 14.5px;  
                  }

                  .voice2Sizing14{
                  width: 110px;
                  height: 110px;
                  opacity: 0.35;   
                  font-size: 14px;   
                  }

                  .voice2Sizing15{
                  width: 105px;
                  height: 105px; 
                  opacity: 0.3;    
                  font-size: 13.5px; 
                  }

                  .voice2Sizing16{
                  width: 100px;
                  height: 100px; 
                  opacity: 0.25;   
                  font-size: 13px;  
                  }

                  .voice2Sizing17{
                  width: 95px;
                  height: 95px; 
                  opacity: 0.2;     
                  font-size: 12.5px;
                  }

                  .voice2Sizing18{
                  width: 90px;
                  height: 90px; 
                  opacity: 0.15;     
                  font-size: 12px;
                  }

                  .voice2Sizing19{
                  width: 85px;
                  height: 85px; 
                  opacity: 0.1;     
                  font-size: 11.5px;
                  }

                  .voice2Sizing20{
                  width: 80px;
                  height: 80px; 
                  opacity: 0.05;     
                  font-size: 11px;
                  }

                  
                  .voice2Draggable.is-dragging { opacity: 1; }
            /* VOICE 3 DRAGGIE             */
                  .voice3Draggable {
                  border-radius: 100px;
                  position: absolute;
                  background: var(--main-v3-color);
                  color: black;
                  }

                  .voice3Sizing1{
                  width: 175px;
                  height: 175px; 
                  opacity: 1;    
                  font-size: 20.5px; 
                  }

                  .voice3Sizing2{
                  width: 170px;
                  height: 170px; 
                  opacity: 0.95; 
                  font-size: 20px;    
                  }

                  .voice3Sizing3{
                  width: 165px;
                  height: 165px;
                  opacity: 0.9;  
                  font-size: 19.5px;    
                  }

                  .voice3Sizing4{
                  width: 160px;
                  height: 160px;
                  opacity: 0.85;  
                  font-size: 19px;    
                  }

                  .voice3Sizing5{
                  width: 155px;
                  height: 155px; 
                  opacity: 0.8;   
                  font-size: 18.5px;  
                  }

                  .voice3Sizing6{
                  width: 150px;
                  height: 150px; 
                  opacity: 0.75; 
                  font-size: 18px;    
                  }

                  .voice3Sizing7{
                  width: 145px;
                  height: 145px; 
                  opacity: 0.7;  
                  font-size: 17.5px;   
                  }

                  .voice3Sizing8{
                  width: 140px;
                  height: 140px; 
                  opacity: 0.65; 
                  font-size: 17px;    
                  }

                  .voice3Sizing9{
                  width: 135px;
                  height: 135px; 
                  opacity: 0.6;     
                  font-size: 16.5px;
                  }

                  .voice3Sizing10{
                  width: 130px;
                  height: 130px; 
                  opacity: 0.55;   
                  font-size: 16px;  
                  }  

                  .voice3Sizing11{
                  width: 125px;
                  height: 125px; 
                  opacity: .5;     
                  font-size: 15.5px;
                  }

                  .voice3Sizing12{
                  width: 120px;
                  height: 120px; 
                  opacity: 0.45;   
                  font-size: 15px;  
                  }

                  .voice3Sizing13{
                  width: 115px;
                  height: 115px;
                  opacity: 0.4;    
                  font-size: 14.5px;  
                  }

                  .voice3Sizing14{
                  width: 110px;
                  height: 110px;
                  opacity: 0.35;   
                  font-size: 14px;   
                  }

                  .voice3Sizing15{
                  width: 105px;
                  height: 105px; 
                  opacity: 0.3;    
                  font-size: 13.5px; 
                  }

                  .voice3Sizing16{
                  width: 100px;
                  height: 100px; 
                  opacity: 0.25;   
                  font-size: 13px;  
                  }

                  .voice3Sizing17{
                  width: 95px;
                  height: 95px; 
                  opacity: 0.2;     
                  font-size: 12.5px;
                  }

                  .voice3Sizing18{
                  width: 90px;
                  height: 90px; 
                  opacity: 0.15;     
                  font-size: 12px;
                  }

                  .voice3Sizing19{
                  width: 85px;
                  height: 85px; 
                  opacity: 0.1;     
                  font-size: 11.5px;
                  }

                  .voice3Sizing20{
                  width: 80px;
                  height: 80px; 
                  opacity: 0.05;     
                  font-size: 11px;
                  }

                  .voice3Draggable.is-dragging { opacity: 1; }
            /* VOICE 4 DRAGGIE             */
                  .voice4Draggable {
                  border-radius: 100px;
                  position: absolute;
                  background: var(--main-v4-color);
                  color: black;
                  }

                  .voice4Sizing1{
                  width: 175px;
                  height: 175px; 
                  opacity: 1;    
                  font-size: 20.5px; 
                  }

                  .voice4Sizing2{
                  width: 170px;
                  height: 170px; 
                  opacity: 0.95; 
                  font-size: 20px;    
                  }

                  .voice4Sizing3{
                  width: 165px;
                  height: 165px;
                  opacity: 0.9;  
                  font-size: 19.5px;    
                  }

                  .voice4Sizing4{
                  width: 160px;
                  height: 160px;
                  opacity: 0.85;  
                  font-size: 19px;    
                  }

                  .voice4Sizing5{
                  width: 155px;
                  height: 155px; 
                  opacity: 0.8;   
                  font-size: 18.5px;  
                  }

                  .voice4Sizing6{
                  width: 150px;
                  height: 150px; 
                  opacity: 0.75; 
                  font-size: 18px;    
                  }

                  .voice4Sizing7{
                  width: 145px;
                  height: 145px; 
                  opacity: 0.7;  
                  font-size: 17.5px;   
                  }

                  .voice4Sizing8{
                  width: 140px;
                  height: 140px; 
                  opacity: 0.65; 
                  font-size: 17px;    
                  }

                  .voice4Sizing9{
                  width: 135px;
                  height: 135px; 
                  opacity: 0.6;     
                  font-size: 16.5px;
                  }

                  .voice4Sizing10{
                  width: 130px;
                  height: 130px; 
                  opacity: 0.55;   
                  font-size: 16px;  
                  }  

                  .voice4Sizing11{
                  width: 125px;
                  height: 125px; 
                  opacity: .5;     
                  font-size: 15.5px;
                  }

                  .voice4Sizing12{
                  width: 120px;
                  height: 120px; 
                  opacity: 0.45;   
                  font-size: 15px;  
                  }

                  .voice4Sizing13{
                  width: 115px;
                  height: 115px;
                  opacity: 0.4;    
                  font-size: 14.5px;  
                  }

                  .voice4Sizing14{
                  width: 110px;
                  height: 110px;
                  opacity: 0.35;   
                  font-size: 14px;   
                  }

                  .voice4Sizing15{
                  width: 105px;
                  height: 105px; 
                  opacity: 0.3;    
                  font-size: 13.5px; 
                  }

                  .voice4Sizing16{
                  width: 100px;
                  height: 100px; 
                  opacity: 0.25;   
                  font-size: 13px;  
                  }

                  .voice4Sizing17{
                  width: 95px;
                  height: 95px; 
                  opacity: 0.2;     
                  font-size: 12.5px;
                  }

                  .voice4Sizing18{
                  width: 90px;
                  height: 90px; 
                  opacity: 0.15;     
                  font-size: 12px;
                  }

                  .voice4Sizing19{
                  width: 85px;
                  height: 85px; 
                  opacity: 0.1;     
                  font-size: 11.5px;
                  }

                  .voice4Sizing20{
                  width: 80px;
                  height: 80px; 
                  opacity: 0.05;     
                  font-size: 11px;
                  }

                  .voice4Draggable.is-dragging { opacity: 1; }
            /* ABOUT DRAGGIE               */
                  .aboutDraggable{  
                  width: 300px;
                  height: 300px;
                  border-radius: 275px;
                  background: white;
                  opacity: 1;
                  color: black;
                  position: absolute;
                  font-size: 50px;
                  border: var(--main-border-color);
                  }
                  #createdByHeader{
                  font-size: 26px;
                  margin-top: 30px;
                  font-weight: 600;      
                  }
                  #aboutTextID{
                  font-size: 27px;
                  margin-top: 20px;
                  }
                  #newINC{
                  margin-top: -5px;
                  font-size: 18px;  
                  margin-bottom: -30px;    
                  }
                  .about2Draggable{  
                  width: 320px;
                  height: 320px;
                  border-radius: 300px;
                  background: white;
                  opacity: 1;
                  color: black;
                  position: absolute;
                  font-size: 50px;
                  border: var(--main-border-color);
                  }
                  #about2TextID{
                  max-width: 250px;
                  margin: auto;
                  font-size: 26px;
                  margin-top: 30px;
                  font-weight: 600;
                  }
                  #about2TextID1{
                  font-size: 17px;
                  margin-top: 10px; 
                  text-align: left;
                  margin-left: 55px;     
                  }
                  .about3Draggable{  
                  width: 450px;
                  height: 450px;
                  border-radius: 325px;
                  background: white;
                  opacity: 1;
                  color: black;
                  position: absolute;
                  font-size: 50px;
                  border: var(--main-border-color);
                  }
                  #about3TextHeader{
                  font-size: 32px;
                  max-width: 255px;
                  margin: auto;
                  margin-top: 20px; 
                  font-weight: 600;       
                  }
                  #about3TextID{
                  font-size: 17px;
                  max-width: 350px;
                  margin: auto;
                  margin-top: 10px;
                  }
                  .about4Draggable{  
                  width: 250px;
                  height: 250px;
                  border-radius: 400px;
                  opacity: 1;
                  color: black;
                  position: absolute;
                  font-size: 50px;
                  background: white;
                  }
            /* PLAY SUN DRAGGIE            */
                  #sunLoadText1{
                  font-size: 26px;
                  margin-top: 72px;
                  font-weight: 700;      
                  }
                  #sunLoadText2{
                  font-size: 18px;
                  margin-top: -12px;
                  font-weight: 700;       
                  }
                  #sunTextID{
                  font-size: 19px;
                  margin-top: 65px;
                  font-weight: 700;
                  }
                  #sunTextID2{
                  font-size: 14px;
                  margin-top: -15px;
                  font-weight: 700;      
                  }
                  #togetherText{
                  font-size: 26px;
                  margin-top: -25px;
                  font-weight: 700;      
                  }
                  .playSunDraggable {
                  width: 175px;
                  height: 175px;
                  border-radius: 200px;
                  opacity: 1;
                  position: absolute;
                  font-size: 50px;
                  color: black;
                  background: var(--main-sun-color);
                  }
                  .playSunDraggable.is-pointer-down {
                  opacity: 1;
                  }
                  .playSunDraggable.is-dragging { 
                  opacity: 1;
                  }
            /* REVERB COLORING             */
                  .reverbSizing1{
                  background: #000000;
                  /*width: 100%;
                  height: 100%;*/
                  -webkit-background-size: cover;
                  -moz-background-size: cover;
                  -o-background-size: cover;
                  background-size: cover;
                  background:...;
                  }

                  .reverbSizing2{
                  background: #101010;
                  /*opacity: .95; */
                  }

                  .reverbSizing3{
                  background: #202020;
                  /*opacity: 0.9; */
                  }

                  .reverbSizing4{
                  background: #282828;
                  /*opacity: 0.85;  */
                  }

                  .reverbSizing5{
                  background: #303030; 
                  /*opacity: 0.8;  */
                  }

                  .reverbSizing6{
                  background: #383838;
                  /*opacity*/: 0.75; 
                  }

                  .reverbSizing7{
                  background: #484848;
                  /*opacity*/: 0.7; 
                  }

                  .reverbSizing8{
                  background: #585858;
                  /*opacity*/: 0.65; 
                  }

                  .reverbSizing9{
                  background: #696969;
                  /*opacity*/: 0.6;    
                  }

                  .reverbSizing10{
                  background: #808080;
                  /*opacity*/: 0.55; 
                  }  

                  .reverbSizing11{
                  background: #909090; 
                  /*opacity*/: 0.5;   
                  }

                  .reverbSizing12{
                  background: #A0A0A0;
                  /*opacity*/: 0.45; 
                  }

                  .reverbSizing13{
                  background: #A9A9A9;
                  /*opacity*/: 0.4; 
                  }

                  .reverbSizing14{
                  background: #B8B8B8;
                  /*opacity*/: 0.35; 
                  }

                  .reverbSizing15{
                  background: #C0C0C0;
                  /*opacity*/: 0.3; 
                  }

                  .reverbSizing16{
                  background: #D3D3D3;
                  /*opacity: 0.25; */
                  }

                  .reverbSizing17{
                  background: #DCDCDC;
                  /*opacity: 0.2;     */
                  }

                  .reverbSizing18{
                  background: #E8E8E8;
                  /*opacity: 0.15; */
                  }

                  .reverbSizing19{
                  background: #F5F5F5;
                  /*opacity: 0.1; */
                  }

                  .reverbSizing20{
                  background: #FFFFFF;
                 /* opacity: 0.05; */ 
                  }
            /* MISSON CONTROL              */
                  /*#controlsContainer{
                  max-width: 1000px;
                  margin: auto;
                  margin-top: 0px;
                  margin-bottom: 50px;
                  height: 800px;
                  }*/
                  #masterControlDiv{
                  margin-top: 0px;
                  margin-bottom: 0px;
                  }
                  #masterControlBadges{
                  border-radius: 4px;
                  padding: 8px 4px;
                  font-size: 17px;
                  font-weight: 700;
                  width: 160px;
                  color: black; 
                  border: 2px solid black;
                  }
                  #masterTimingBadges{
                  border-radius: 4px;
                  padding: 8px 4px;
                  font-size: 17px;
                  font-weight: 700;
                  background-color: var(--main-time-color);
                  color: black; 
                  width: 160px;
                  border: 2px solid black;
                  }
                  #voice1SliderDiv{
                  }
                  #voice2SliderDiv{
                  }
                  #voice3SliderDiv{
                  }
                  #voice4SliderDiv{
                  }
                  #timingSliderDiv{
                  }
                  #daySliderDiv{
                  }
                  #sliders1{
                  margin-top: 20px;
                  }
                  #sliders2{
                  margin-top: 20px;
                  }
                  #sliders3{
                  margin-top: 20px;
                  }
                  #sliders4{
                  margin-top: 20px;
                  }
                  #sliders5{
                  margin-top: 20px;      
                  }
                  #slidersTiming{
                  margin-top: 20px;
                  }
            /* BADGES                      */
                  .voice1Badge{
                  background: var(--main-heading-color);
                  color: black;
                  }
                  .voice2Badge{
                  background: var(--main-heading-color);
                  color: black;   
                  }
                  .voice3Badge{
                  background: var(--main-heading-color);
                  color: black;     
                  }
                  .voice4Badge{
                  background: var(--main-heading-color);
                  color: black; 
                  }
            /* AMBIANCE BUTTONS            */
                  #ambienceBtnLocation{
                  max-width: 1000px;
                  margin: auto;
                  margin-top: 0px;
                  margin-bottom: 0px;
                  }
                  #ambienceBtns{
                  width: 150px;
                  border-radius: 4px;
                  font-size: 16px;
                  font-weight: 700;      
                  }
                  #ambienceBtn1Div{
                  }
                  #ambienceBtn2Div{
                  }
                  #ambienceBtn3Div{
                  }
                  #ambienceBtn4Div{
                  }
                  #ambienceSlider{
                  margin-top: 20px;
                  }
                  #ambienceBadges{
                  font-size: 22px;
                  background-color:var(--main-time-color);
                  color: black; 
                  }
            /* INSTRUMENT 1 RANGER         */
                  input[class="instrument1Ranger"] {
                  -webkit-appearance: none;
                  background: var(--main-heading-color);
                  height: 10px;
                  width: 140px;
                  border-radius: 20px;
                  margin: auto;
                  transform: rotateY(180deg);
                  }
                  input[class="instrument1Ranger"]::-moz-range-track{
                  -webkit-appearance: none;
                  background: var(--main-heading-color);
                  height: 10px;
                  width: 140px;
                  border-radius: 20px;
                  margin: auto;
                  transform: rotateY(180deg);
                  }
                  input[class="instrument1Ranger"]::-webkit-slider-thumb{
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-heading-color);
                  border: 2px solid #00001E;
                  }

                  input[class="instrument1Ranger"]::-moz-range-thumb{
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-heading-color);
                  border: 2px solid #00001E;
                  }
            /* INSTRUMENT 2 RANGER         */
                  input[class="instrument2Ranger"] {
                  -webkit-appearance: none;
                  background: var(--main-heading-color);
                  height: 10px;
                  width: 140px;
                  border-radius: 20px;
                  margin: auto;
                  transform: rotateY(180deg);
                  }
                  input[class="instrument2Ranger"]::-moz-range-track{
                  -webkit-appearance: none;
                  background: var(--main-heading-color);
                  height: 10px;
                  width: 140px;
                  border-radius: 20px;
                  margin: auto;
                  transform: rotateY(180deg);
                  }
                  input[class="instrument2Ranger"]::-webkit-slider-thumb {
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-heading-color);
                  border: 2px solid #00001E;
                  }
                  input[class="instrument2Ranger"]::-moz-range-thumb{
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-heading-color);
                  border: 2px solid #00001E;
                  }
            /* INSTRUMENT 3 RANGER         */
                  input[class="instrument3Ranger"] {
                  -webkit-appearance: none;
                  background: var(--main-heading-color);
                  height: 10px;
                  width: 140px;
                  border-radius: 20px;
                  margin: auto;
                  transform: rotateY(180deg);
                  }
                  input[class="instrument3Ranger"]::-moz-range-track{
                  -webkit-appearance: none;
                  background: var(--main-heading-color);
                  height: 10px;
                  width: 140px;
                  border-radius: 20px;
                  margin: auto;
                  transform: rotateY(180deg);
                  }
                  input[class="instrument3Ranger"]::-webkit-slider-thumb {
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-heading-color);
                  border: 2px solid #00001E;
                  }
                  input[class="instrument3Ranger"]::-moz-range-thumb{
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-heading-color);
                  border: 2px solid #00001E;
                  }
            /* INSTRUMENT 4 RANGER         */
                  input[class="instrument4Ranger"] {
                  -webkit-appearance: none;
                  background: var(--main-heading-color);
                  height: 10px;
                  width: 140px;
                  border-radius: 20px;
                  margin: auto;
                  transform: rotateY(180deg);
                  }
                  input[class="instrument4Ranger"]::-moz-range-track{
                  -webkit-appearance: none;
                  background: var(--main-heading-color);
                  height: 10px;
                  width: 140px;
                  border-radius: 20px;
                  margin: auto;
                  transform: rotateY(180deg);
                  }
                  input[class="instrument4Ranger"]::-webkit-slider-thumb {
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-heading-color);
                  border: 2px solid #00001E;
                  }
                  input[class="instrument4Ranger"]::-moz-range-thumb{
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-heading-color);
                  border: 2px solid #00001E;
                  }
            /* TIMING RANGER               */
                  input[class="timingRanger"] {
                  -webkit-appearance: none;
                  background-color: var(--main-sun-color);
                  height: 10px;
                  width: 140px;
                  border-radius: 20px;
                  margin: auto;
                  }

                  input[class="timingRanger"]::-webkit-slider-thumb {
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-sun-color);
                  border: 2px solid #00001E;
                  }

                  input[class="timingRanger"]::-moz-range-track{
                  -webkit-appearance: none;
                  background-color: var(--main-sun-color);
                  height: 10px;
                  width: 140px;
                  border-radius: 20px;
                  margin: auto;
                  }

                  input[class="timingRanger"]::-moz-range-thumb{
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-sun-color);
                  border: 2px solid #00001E;
                  }
            /* DAY RANGER                  */
                  input[class="dayRanger"] {
                  -webkit-appearance: none;
                  background-color: var(--main-time-color);
                  height: 10px;
                  width: 140px;
                  border-radius: 20px;
                  margin: auto;
                  }

                  input[class="dayRanger"]::-webkit-slider-thumb {
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-time-color);
                  border: 2px solid #00001E;
                  }

                  input[class="dayRanger"]::-moz-range-track{
                  -webkit-appearance: none;
                  background-color: var(--main-time-color);
                  height: 10px;
                  width: 140px;
                  border-radius: 20px;
                  margin: auto;
                  }

                  input[class="dayRanger"]::-moz-range-thumb{
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-time-color);
                  border: 2px solid #00001E;
                  }
            /* AMBIANCE RANGER STOPPED     */
                  input[class="ambianceRangerStop"] {
                  -webkit-appearance: none;
                  background-color: var(--main-stop-color);
                  height: 10px;
                  width: 140px;
                  border-radius: 20px;
                  margin: auto;
                  }

                  input[class="ambianceRangerStop"]::-webkit-slider-thumb {
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-stop-color);
                  border: 2px solid #00001E;
                  }
                  input[class="ambianceRangerStop"]::-moz-range-track{
                  -webkit-appearance: none;
                  background-color: var(--main-stop-color);
                  height: 10px;
                  width: 140px;
                  border-radius: 20px;
                  margin: auto;
                  }
                  input[class="ambianceRangerStop"]::-moz-range-thumb{
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-stop-color);
                  border: 2px solid #00001E;
                  }
            /* AMBIANCE RANGER PLAYING     */
                  input[class="ambianceRangerPlay"] {
                  -webkit-appearance: none;
                  background-color: var(--main-start-color);
                  height: 10px;
                  width: 140px;
                  border-radius: 20px;
                  margin: auto;
                  }

                  input[class="ambianceRangerPlay"]::-webkit-slider-thumb {
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-start-color);
                  border: 2px solid #00001E;
                  }  

                  input[class="ambianceRangerPlay"]::-moz-range-track{
                  -webkit-appearance: none;
                  background-color: var(--main-start-color);
                  height: 10px;
                  width: 140px;
                  border-radius: 20px;
                  margin: auto;
                  }

                  input[class="ambianceRangerPlay"]::-moz-range-thumb{
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-start-color);
                  border: 2px solid #00001E;
                  }    
            /* MAILING LIST                */
                  #mailingListText{
                  margin: auto;
                  max-width: 200px;
                  margin-top: 75px;
                  margin-bottom: 0px;
                  font-size: 17px;   
                  font-weight: 600;      
                  }
                  #mc_embed_signup{
                  background:#fff; 
                  font-size:12px; 
                  width:100%;
                  border-color: black;
                  background-color: transparent;
                  }
                  #mce-EMAIL{
                  font-size:12px; 
                  padding: 4px 10px;
                  margin-top: 0px;  
                  font-weight: 800;
                  width: 225px;
                  border-width: 2px;
                  border-radius: 10px;
                  background-color: transparent;
                  border-color: black;
                  }
                  #mc-embedded-subscribe{
                  font-size:12px; 
                  padding: 2px 10px;
                  margin-top: 4px;
                  font-weight: 800;
                  border-width: 2px;
                  border-radius: 10px;
                  background-color: transparent;
                  border-color: black;
                  }    
    }
/** STYLINGS FOR DESKTOP SCREENS > 1600px  */
      @media (min-width: 1300px) {
                  #mainDiv{
                  padding-right: 0px;
                  padding-left: 0px;
                  max-width: 2000px;   
                  }
                  #hornBtn{
                  width: 400px; 
                  height: 60px;
                  margin-top: 20px;
                  border-width: 3px;
                  }
                  #hornBtnPrompt{
                  color: white;
                  margin-top: 2px;
                  font-size: 26px;
                  }
      @media (max-height: 549px) {
                  #controlsContainer{
                  max-width: 1200px;
                  margin: auto;
                  margin-top: -22%;
                  margin-bottom: 50px;
                  height: 400px;
                  }
                  /* PROMPT                      */
                  #promptText{
                  max-width: 450px;
                  margin-top: -25%;
                  font-size: 24px;
                  color:white;   
                  }
                  #promptButton{
                  margin-left: -70%;
                  margin-top: 5px;
                  margin-bottom: 0px;
                  font-size: 20px;
                  color:white;
                  }
      }
      @media (min-height: 550px) and (max-height: 600px) {
                  #controlsContainer{
                  max-width: 1200px;
                  margin: auto;
                  margin-top: -20%;
                  margin-bottom: 50px;
                  height: 400px;
                  }
                  /* PROMPT                      */
                  #promptText{
                  max-width: 450px;
                  margin-top: -25%;
                  font-size: 24px;
                  color:white;   
                  }
                  #promptButton{
                  margin-left: -70%;
                  margin-top: 5px;
                  margin-bottom: 0px;
                  font-size: 20px;
                  color:white;
                  }
      }
      @media (min-height: 601px) and (max-height: 649px) {
                  #controlsContainer{
                  max-width: 1200px;
                  margin: auto;
                  margin-top: -18%;
                  margin-bottom: 50px;
                  height: 400px;
                  }
                  /* PROMPT                      */
                  #promptText{
                  max-width: 450px;
                  margin-top: -25%;
                  font-size: 24px;
                  color:white;   
                  }
                  #promptButton{
                  margin-left: -70%;
                  margin-top: 5px;
                  margin-bottom: 0px;
                  font-size: 20px;
                  color:white;
                  }
      }
      @media (min-height: 650px) and (max-height: 700px) {
                  #controlsContainer{
                  max-width: 1200px;
                  margin: auto;
                  margin-top: -15%;
                  margin-bottom: 50px;
                  height: 400px;
                  }
                  /* PROMPT                      */
                  #promptText{
                  max-width: 450px;
                  margin-top: -25%;
                  font-size: 24px;
                  color:white;   
                  }
                  #promptButton{
                  margin-left: -70%;
                  margin-top: 5px;
                  margin-bottom: 0px;
                  font-size: 20px;
                  color:white;
                  }
      }
      @media (min-height: 701px) and (max-height: 749px) {
                  #controlsContainer{
                  max-width: 1200px;
                  margin: auto;
                  margin-top: -13%;
                  margin-bottom: 50px;
                  height: 400px;
                  }
                  /* PROMPT                      */
                  #promptText{
                  max-width: 450px;
                  margin-top: -25%;
                  font-size: 24px;
                  color:white;   
                  }
                  #promptButton{
                  margin-left: -70%;
                  margin-top: 5px;
                  margin-bottom: 0px;
                  font-size: 20px;
                  color:white;
                  }
      }
      @media (min-height: 750px) and (max-height: 900px) {
                  #controlsContainer{
                  max-width: 1200px;
                  margin: auto;
                  margin-top: -12%;
                  margin-bottom: 50px;
                  height: 400px;
                  }
                  /* PROMPT                      */
                  #promptText{
                  max-width: 450px;
                  margin-top: -25%;
                  font-size: 24px;
                  color:white;   
                  }
                  #promptButton{
                  margin-left: -70%;
                  margin-top: 5px;
                  margin-bottom: 0px;
                  font-size: 20px;
                  color:white;
                  }
      }
      @media (min-height: 901px) and (max-height: 1000px) {
                  #controlsContainer{
                  max-width: 1200px;
                  margin: auto;
                  margin-top: -5%;
                  margin-bottom: 50px;
                  height: 400px;
                  }
                  /* PROMPT                      */
                  #promptText{
                  max-width: 450px;
                  margin-top: -25%;
                  font-size: 24px;
                  color:white;   
                  }
                  #promptButton{
                  margin-left: -70%;
                  margin-top: 5px;
                  margin-bottom: 0px;
                  font-size: 20px;
                  color:white;
                  }
      }
      @media (min-height: 1001px) and (max-height: 1100px) {
                  #controlsContainer{
                  max-width: 1200px;
                  margin: auto;
                  margin-top: 0%;
                  margin-bottom: 50px;
                  height: 400px;
                  }
                  /* PROMPT                      */
                  #promptText{
                  margin: auto;
                  max-width: 800px;
                  margin-top: -2%;
                  font-size: 24px;
                  color:white;   
                  }
                  #promptButton{
                  margin-top: 5px;
                  margin-bottom: 30px;
                  font-size: 20px;
                  color:white;
                  }
      }
      @media (min-height: 1101px) {
                  #controlsContainer{
                  max-width: 1200px;
                  margin: auto;
                  margin-top: 10%;
                  margin-bottom: 50px;
                  height: 400px;
                  }
                  /* PROMPT                      */
                  #promptText{
                  margin: auto;
                  max-width: 800px;
                  margin-top: 5%;
                  font-size: 24px;
                  color:white;   
                  }
                  #promptButton{
                  margin-top: 5px;
                  margin-bottom: 30px;
                  font-size: 20px;
                  color:white;
                  }
      }
            /* WELCOME                    */
                  #welcomeInfoText{
                  margin-top: 50px;
                  font-size: 30px;
                  color: black;
                  font-weight: 700;
                  }
                  #welcomeMobileText{
                  color: black;
                  font-size: 18px;
                  font-weight: 700;
                  }
                  #playButton{
                  color:  white;
                  background-color:  var(--main-heading-color);
                  margin-top: 20px;
                  font-size: 20px;
                  border-width: 1px;
                  }
                  #bell{
                  color: var(--main-v1-color);      
                  }
            /* HEADINGS                    */
                  #navBar{
                  margin-top: -780px;
                  }
                  #harmonizeHeading{
                  font-size: 26px;
                  font-weight: 600;
                  width: 200px;
                  height: 50px;
                  border-radius: 4px;      
                  }
                  #cuteBtn{
                  font-size: 26px;
                  font-weight: 600;
                  width: 50px;
                  height: 50px;
                  border-radius: 50px; 
                  }
                  #ambienceHeading{
                  font-size: 26px;
                  font-weight: 600;
                  width: 200px;
                  border-radius: 4px;  
                  }
                  #harmonyHeadingDiv{
                  /*margin-top: 20px;
                  margin-bottom: 0px;*/
                  /*margin-left: 250px;*/
                  }
                  #helpHeadingDiv{
                  
                  }
                  #ambianceHeadingDiv{
                  /*margin-top: 20px;
                  margin-bottom: 0px;*/
                  }
            /* DRAGGIE CONTAINER           */
                  .masterDraggie{
                  margin-top: 100px;
                  margin-bottom: 0px;
                  width: 100%;
                  height: 100%;  
                  }
                  .draggieContainer{
                  padding: 100px 175px;
                  border: 5px dotted var(--main-guide-color);
                  height: 700px;
                  width: 50%;
                  margin: auto;
                  /*width: 700px;
                  height: 600px;
                  margin-top: -200px;
                  margin-left: 800px;
                  background: transparent;
                  border-radius: 500px;
                  position: relative;*/
                  }
            /* ALL VOICE TAGS              */
                  #voiceBubbleText{
                  color:black;
                  margin-top: 30%;
                  }
                  #voiceBubbleText2{
                  color: white;
                  font-weight: 800;
                  margin-top: -10px;
                  }
            /* VOICE 1 DRAGGIE             */
                  .voice1Draggable{  
                  border-radius: 400px;
                  position: absolute;
                  background: var(--main-v1-color);
                  color: black;
                  }

                  .voice1Sizing1{
                  width: 200px;
                  height: 200px; 
                  opacity: 1;    
                  font-size: 27.5px; 
                  }

                  .voice1Sizing2{
                  width: 195px;
                  height: 195px; 
                  opacity: 0.95; 
                  font-size: 27px;    
                  }

                  .voice1Sizing3{
                  width: 190px;
                  height: 190px;
                  opacity: 0.9;  
                  font-size: 26.5px;    
                  }

                  .voice1Sizing4{
                  width: 185px;
                  height: 185px;
                  opacity: 0.85;  
                  font-size: 26px;    
                  }

                  .voice1Sizing5{
                  width: 180px;
                  height: 180px; 
                  opacity: 0.8;   
                  font-size: 25.5px;  
                  }

                  .voice1Sizing6{
                  width: 175px;
                  height: 175px; 
                  opacity: 0.75; 
                  font-size: 25px;    
                  }

                  .voice1Sizing7{
                  width: 170px;
                  height: 170px; 
                  opacity: 0.7;  
                  font-size: 24.5px;   
                  }

                  .voice1Sizing8{
                  width: 165px;
                  height: 165px; 
                  opacity: 0.65; 
                  font-size: 24px;    
                  }

                  .voice1Sizing9{
                  width: 160px;
                  height: 160px; 
                  opacity: 0.6;     
                  font-size: 23.5px;
                  }

                  .voice1Sizing10{
                  width: 155px;
                  height: 155px; 
                  opacity: 0.55;   
                  font-size: 23px;  
                  }  

                  .voice1Sizing11{
                  width: 150px;
                  height: 150px; 
                  opacity: .5;     
                  font-size: 22.5px;
                  }

                  .voice1Sizing12{
                  width: 145px;
                  height: 145px; 
                  opacity: 0.45;   
                  font-size: 22px;  
                  }

                  .voice1Sizing13{
                  width: 140px;
                  height: 140px;
                  opacity: 0.4;    
                  font-size: 21.5px;  
                  }

                  .voice1Sizing14{
                  width: 135px;
                  height: 135px;
                  opacity: 0.35;   
                  font-size: 21px;   
                  }

                  .voice1Sizing15{
                  width: 130px;
                  height: 130px; 
                  opacity: 0.3;    
                  font-size: 20.5px; 
                  }

                  .voice1Sizing16{
                  width: 125px;
                  height: 125px; 
                  opacity: 0.25;   
                  font-size: 20px;  
                  }

                  .voice1Sizing17{
                  width: 120px;
                  height: 120px; 
                  opacity: 0.2;     
                  font-size: 19.5px;
                  }

                  .voice1Sizing18{
                  width: 115px;
                  height: 115px; 
                  opacity: 0.15;     
                  font-size: 19px;
                  }

                  .voice1Sizing19{
                  width: 110px;
                  height: 110px; 
                  opacity: 0.1;     
                  font-size: 18.5px;
                  }

                  .voice1Sizing20{
                  width: 105px;
                  height: 105px; 
                  opacity: 0.05;     
                  font-size: 18px;
                  }

                  
                  .voice1Draggable.is-dragging { opacity: 1; }

                  .voice1Handle{
                  background: #555;
                  background: white;
                  width: 100px;
                  height: 100px;
                  border-radius: 100px;
                  margin-top: 50px;
                  margin-left: 50px;
                  color: white;
                  }
            /* VOICE 2 DRAGGIE             */
                  .voice2Draggable {
                  border-radius: 400px;
                  position: absolute;
                  border: var(--main-border-color);
                  background: var(--main-v2-color);
                  color: black;
                  }

                  .voice2Sizing1{
                  width: 200px;
                  height: 200px; 
                  opacity: 1;    
                  font-size: 27.5px; 
                  }

                  .voice2Sizing2{
                  width: 195px;
                  height: 195px; 
                  opacity: 0.95; 
                  font-size: 27px;    
                  }

                  .voice2Sizing3{
                  width: 190px;
                  height: 190px;
                  opacity: 0.9;  
                  font-size: 26.5px;    
                  }

                  .voice2Sizing4{
                  width: 185px;
                  height: 185px;
                  opacity: 0.85;  
                  font-size: 26px;    
                  }

                  .voice2Sizing5{
                  width: 180px;
                  height: 180px; 
                  opacity: 0.8;   
                  font-size: 25.5px;  
                  }

                  .voice2Sizing6{
                  width: 175px;
                  height: 175px; 
                  opacity: 0.75; 
                  font-size: 25px;    
                  }

                  .voice2Sizing7{
                  width: 170px;
                  height: 170px; 
                  opacity: 0.7;  
                  font-size: 24.5px;   
                  }

                  .voice2Sizing8{
                  width: 165px;
                  height: 165px; 
                  opacity: 0.65; 
                  font-size: 24px;    
                  }

                  .voice2Sizing9{
                  width: 160px;
                  height: 160px; 
                  opacity: 0.6;     
                  font-size: 23.5px;
                  }

                  .voice2Sizing10{
                  width: 155px;
                  height: 155px; 
                  opacity: 0.55;   
                  font-size: 23px;  
                  }  

                  .voice2Sizing11{
                  width: 150px;
                  height: 150px; 
                  opacity: .5;     
                  font-size: 22.5px;
                  }

                  .voice2Sizing12{
                  width: 145px;
                  height: 145px; 
                  opacity: 0.45;   
                  font-size: 22px;  
                  }

                  .voice2Sizing13{
                  width: 140px;
                  height: 140px;
                  opacity: 0.4;    
                  font-size: 21.5px;  
                  }

                  .voice2Sizing14{
                  width: 135px;
                  height: 135px;
                  opacity: 0.35;   
                  font-size: 21px;   
                  }

                  .voice2Sizing15{
                  width: 130px;
                  height: 130px; 
                  opacity: 0.3;    
                  font-size: 20.5px; 
                  }

                  .voice2Sizing16{
                  width: 125px;
                  height: 125px; 
                  opacity: 0.25;   
                  font-size: 20px;  
                  }

                  .voice2Sizing17{
                  width: 120px;
                  height: 120px; 
                  opacity: 0.2;     
                  font-size: 19.5px;
                  }

                  .voice2Sizing18{
                  width: 115px;
                  height: 115px; 
                  opacity: 0.15;     
                  font-size: 19px;
                  }

                  .voice2Sizing19{
                  width: 110px;
                  height: 110px; 
                  opacity: 0.1;     
                  font-size: 18.5px;
                  }

                  .voice2Sizing20{
                  width: 105px;
                  height: 105px; 
                  opacity: 0.05;     
                  font-size: 18px;
                  }
                  .voice2Draggable.is-dragging { opacity: 1; }

                  .voice2Handle{
                  background: #555;
                  background: white;
                  border-radius: 100px;
                  margin-top: 50px;
                  margin-left: 50px;
                  color: white;
                  }
            /* VOICE 3 DRAGGIE             */
                  .voice3Draggable {
                  border-radius: 400px;
                  position: absolute;
                  border: var(--main-border-color);
                  background: var(--main-v3-color);
                  color: black;
                  }

                  .voice3Sizing1{
                  width: 200px;
                  height: 200px; 
                  opacity: 1;    
                  font-size: 27.5px; 
                  }

                  .voice3Sizing2{
                  width: 195px;
                  height: 195px; 
                  opacity: 0.95; 
                  font-size: 27px;    
                  }

                  .voice3Sizing3{
                  width: 190px;
                  height: 190px;
                  opacity: 0.9;  
                  font-size: 26.5px;    
                  }

                  .voice3Sizing4{
                  width: 185px;
                  height: 185px;
                  opacity: 0.85;  
                  font-size: 26px;    
                  }

                  .voice3Sizing5{
                  width: 180px;
                  height: 180px; 
                  opacity: 0.8;   
                  font-size: 25.5px;  
                  }

                  .voice3Sizing6{
                  width: 175px;
                  height: 175px; 
                  opacity: 0.75; 
                  font-size: 25px;    
                  }

                  .voice3Sizing7{
                  width: 170px;
                  height: 170px; 
                  opacity: 0.7;  
                  font-size: 24px;   
                  }

                  .voice3Sizing8{
                  width: 165px;
                  height: 165px; 
                  opacity: 0.65; 
                  font-size: 23px;    
                  }

                  .voice3Sizing9{
                  width: 160px;
                  height: 160px; 
                  opacity: 0.6;     
                  font-size: 22px;
                  }

                  .voice3Sizing10{
                  width: 155px;
                  height: 155px; 
                  opacity: 0.55;   
                  font-size: 21px;  
                  }  

                  .voice3Sizing11{
                  width: 150px;
                  height: 150px; 
                  opacity: .5;     
                  font-size: 20px;
                  }

                  .voice3Sizing12{
                  width: 145px;
                  height: 145px; 
                  opacity: 0.45;   
                  font-size: 19px;  
                  }

                  .voice3Sizing13{
                  width: 140px;
                  height: 140px;
                  opacity: 0.4;    
                  font-size: 18px;  
                  }

                  .voice3Sizing14{
                  width: 135px;
                  height: 135px;
                  opacity: 0.35;   
                  font-size: 17px;   
                  }

                  .voice3Sizing15{
                  width: 130px;
                  height: 130px; 
                  opacity: 0.3;    
                  font-size: 16px; 
                  }

                  .voice3Sizing16{
                  width: 125px;
                  height: 125px; 
                  opacity: 0.25;   
                  font-size: 15px;  
                  }

                  .voice3Sizing17{
                  width: 120px;
                  height: 120px; 
                  opacity: 0.2;     
                  font-size: 14px;
                  }

                  .voice3Sizing18{
                  width: 115px;
                  height: 115px; 
                  opacity: 0.15;     
                  font-size: 13px;
                  }

                  .voice3Sizing19{
                  width: 110px;
                  height: 110px; 
                  opacity: 0.1;     
                  font-size: 12px;
                  }

                  .voice3Sizing20{
                  width: 105px;
                  height: 105px; 
                  opacity: 0.05;     
                  font-size: 11px;
                  }

                 
                 
                  .voice3Draggable.is-dragging { opacity: 1; }

                  .voice3Handle{
                  background: #555;
                  background: white;
                  width: 100px;
                  height: 100px;
                  border-radius: 100px;
                  margin-top: 50px;
                  margin-left: 50px;
                  color: white;
                  }
            /* VOICE 4 DRAGGIE             */
                  .voice4Draggable {
                  border-radius: 400px;
                  position: absolute;
                  border: var(--main-border-color);
                  background: var(--main-v4-color);
                  color: white;
                  }
                  
                  .voice4Sizing1{
                  width: 200px;
                  height: 200px; 
                  opacity: 1;    
                  font-size: 27.5px; 
                  }

                  .voice4Sizing2{
                  width: 195px;
                  height: 195px; 
                  opacity: 0.95; 
                  font-size: 27px;    
                  }

                  .voice4Sizing3{
                  width: 190px;
                  height: 190px;
                  opacity: 0.9;  
                  font-size: 26.5px;    
                  }

                  .voice4Sizing4{
                  width: 185px;
                  height: 185px;
                  opacity: 0.85;  
                  font-size: 26px;    
                  }

                  .voice4Sizing5{
                  width: 180px;
                  height: 180px; 
                  opacity: 0.8;   
                  font-size: 25.5px;  
                  }

                  .voice4Sizing6{
                  width: 175px;
                  height: 175px; 
                  opacity: 0.75; 
                  font-size: 25px;    
                  }

                  .voice4Sizing7{
                  width: 170px;
                  height: 170px; 
                  opacity: 0.7;  
                  font-size: 24.5px;   
                  }

                  .voice4Sizing8{
                  width: 165px;
                  height: 165px; 
                  opacity: 0.65; 
                  font-size: 24px;    
                  }

                  .voice4Sizing9{
                  width: 160px;
                  height: 160px; 
                  opacity: 0.6;     
                  font-size: 23.5px;
                  }

                  .voice4Sizing10{
                  width: 155px;
                  height: 155px; 
                  opacity: 0.55;   
                  font-size: 23px;  
                  }  

                  .voice4Sizing11{
                  width: 150px;
                  height: 150px; 
                  opacity: .5;     
                  font-size: 22.5px;
                  }

                  .voice4Sizing12{
                  width: 145px;
                  height: 145px; 
                  opacity: 0.45;   
                  font-size: 22px;  
                  }

                  .voice4Sizing13{
                  width: 140px;
                  height: 140px;
                  opacity: 0.4;    
                  font-size: 21.5px;  
                  }

                  .voice4Sizing14{
                  width: 135px;
                  height: 135px;
                  opacity: 0.35;   
                  font-size: 21px;   
                  }

                  .voice4Sizing15{
                  width: 130px;
                  height: 130px; 
                  opacity: 0.3;    
                  font-size: 20.5px; 
                  }

                  .voice4Sizing16{
                  width: 125px;
                  height: 125px; 
                  opacity: 0.25;   
                  font-size: 20px;  
                  }

                  .voice4Sizing17{
                  width: 120px;
                  height: 120px; 
                  opacity: 0.2;     
                  font-size: 19.5px;
                  }

                  .voice4Sizing18{
                  width: 115px;
                  height: 115px; 
                  opacity: 0.15;     
                  font-size: 19px;
                  }

                  .voice4Sizing19{
                  width: 110px;
                  height: 110px; 
                  opacity: 0.1;     
                  font-size: 18.5px;
                  }

                  .voice4Sizing20{
                  width: 105px;
                  height: 105px; 
                  opacity: 0.05;     
                  font-size: 18px;
                  }

                  .voice4Draggable.is-dragging { opacity: 1; }

                  .voice4Handle{
                  background: #555;
                  background: white;
                  width: 100px;
                  height: 100px;
                  border-radius: 100px;
                  margin-top: 50px;
                  margin-left: 50px;
                  color: white;
                  }
            /* ABOUT DRAGGIE               */
                  .aboutDraggable{  
                  width: 300px;
                  height: 300px;
                  border-radius: 400px;
                  opacity: 1;
                  color: black;
                  position: absolute;
                  font-size: 50px;
                  background: white;
                  }
                  #createdByHeader{
                  font-size: 26px;
                  margin-top: 30px;
                  font-weight: 600;      
                  }
                  #aboutTextID{
                  font-size: 28px;
                  margin-top: 18px;
                  }
                  #newINC{
                  margin-top: -5px;
                  font-size: 22px;  
                  margin-bottom: -35px;    
                  }
                  .about2Draggable{  
                  width: 400px;
                  height: 400px;
                  border-radius: 400px; 
                  opacity: 1;
                  color: black;
                  position: absolute;
                  font-size: 50px;
                  background: white; 
                  }
                  #about2TextID{
                  font-size: 26px;
                  margin-top: 30px;
                  font-weight: 600; 
                  }
                  #about2TextID1{
                  font-size: 20px;
                  margin-top: 30px;
                  text-align: left;
                  margin-left: 90px;
                  }
                  .about3Draggable{  
                  width: 450px;
                  height: 450px;
                  border-radius: 400px;
                  opacity: 1;
                  color: black;
                  position: absolute;
                  font-size: 50px;
                  background: white;
                  }
                  #about3TextHeader{
                  font-size: 36px;
                  max-width: 255px;
                  margin: auto;
                  margin-top: 30px; 
                  font-weight: 600;       
                  }
                  #about3TextID{
                  max-width: 360px;
                  margin: auto;
                  font-size: 17px;
                  margin-top: 20px;
                  }
                  .about4Draggable{  
                  width: 300px;
                  height: 300px;
                  border-radius: 400px;
                  opacity: 1;
                  color: black;
                  position: absolute;
                  font-size: 50px;
                  background: white;
                  }
            /* PLAY SUN DRAGGIE            */
                  #sunLoadText1{
                  font-size: 30px;
                  margin-top: 80px;
                  font-weight: 700;      
                  }
                  #sunLoadText2{
                  font-size: 20px;
                  margin-top: -12px;
                  font-weight: 700;       
                  }
                  #sunTextID{
                  font-size: 23px;
                  margin-top: 80px;
                  font-weight: 700;
                  }
                  #sunTextID2{
                  font-size: 16px;
                  margin-top: -15px;
                  font-weight: 700;      
                  }
                  #togetherText{
                  font-size: 30px;
                  margin-top: -25px;
                  font-weight: 700;      
                  }
                  .playSunDraggable {
                  width: 200px;
                  height: 200px;
                  border-radius: 200px;
                  opacity: 1;
                  position: absolute;
                  font-size: 50px;
                  color: black;
                  background: var(--main-sun-color);
                  }
                  .playSunDraggable.is-pointer-down {
                  opacity: 1;
                  }
                  .playSunDraggable.is-dragging { 
                  opacity: 1;
                  }
            /* REVERB DRAGGIE              */
                  /*.reverbDraggable{  
                  width: 600px;
                  height: 600px;
                  background: #FFFC21;
                  border-radius: 200px;
                  opacity: 1;
                  color: orange;
                  position: absolute;
                  font-size: 50px;
                  }*/

                  /*.reverbColoring1{
                  background: #D6FFF9
                  }

                  .reverbColoring2{
                  background: #D6FFF9      
                  }

                  .reverbColoring3{
                  background: #D6FFF9      
                  }

                  .reverbColoring4{
                  background: #D6FFF9     
                  }*/

                  .reverbSizing1{
                  background: #000000;
                  width: 100%;
                  height: 100%;
                  }

                  .reverbSizing2{
                  background: #101010;
                  /*opacity: .95; */
                  }

                  .reverbSizing3{
                  background: #202020;
                  /*opacity: 0.9; */
                  }

                  .reverbSizing4{
                  background: #282828;
                  /*opacity: 0.85;  */
                  }

                  .reverbSizing5{
                  background: #303030; 
                  /*opacity: 0.8;  */
                  }

                  .reverbSizing6{
                  background: #383838;
                  /*opacity*/: 0.75; 
                  }

                  .reverbSizing7{
                  background: #484848;
                  /*opacity*/: 0.7; 
                  }

                  .reverbSizing8{
                  background: #585858;
                  /*opacity*/: 0.65; 
                  }

                  .reverbSizing9{
                  background: #696969;
                  /*opacity*/: 0.6;    
                  }

                  .reverbSizing10{
                  background: #808080;
                  /*opacity*/: 0.55; 
                  }  

                  .reverbSizing11{
                  background: #909090; 
                  /*opacity*/: 0.5;   
                  }

                  .reverbSizing12{
                  background: #A0A0A0;
                  /*opacity*/: 0.45; 
                  }

                  .reverbSizing13{
                  background: #A9A9A9;
                  /*opacity*/: 0.4; 
                  }

                  .reverbSizing14{
                  background: #B8B8B8;
                  /*opacity*/: 0.35; 
                  }

                  .reverbSizing15{
                  background: #C0C0C0;
                  /*opacity*/: 0.3; 
                  }

                  .reverbSizing16{
                  background: #D3D3D3;
                  /*opacity: 0.25; */
                  }

                  .reverbSizing17{
                  background: #DCDCDC;
                  /*opacity: 0.2;     */
                  }

                  .reverbSizing18{
                  background: #E8E8E8;
                  /*opacity: 0.15; */
                  }

                  .reverbSizing19{
                  background: #F5F5F5;
                  /*opacity: 0.1; */
                  }

                  .reverbSizing20{
                  background: #FFFFFF;
                 /* opacity: 0.05; */ 
                  }

                  .reverbDraggable.is-pointer-down {
                  background: #D6FFF9;
                  opacity: 0.0;
                  }
                  .reverbDraggable.is-dragging { opacity: 0.3; }

                  .reverbHandle{
                  background: #D6FFF9;
                  width: 100px;
                  height: 100px;
                  border-radius: 100px;
                  margin-top: 50px;
                  margin-left: 50px;
                  color: white;
                  }
            /* MISSON CONTROL              */
                  #playButton{
                  font-size: 40px;
                  border-radius: 8px;
                  padding: 0px 6px;
                  vertical-align: middle;
                  height: 70px;
                  width: 70px;
                  margin-top: -15px;
                  border-width: 5px;
                  background-color:transparent;      
                  }
                  #harmonyInfo{
                  margin-top: 0px;
                  font-size: 30px;
                  font-weight: 200px;       
                  }
                  #masterControlDiv{
                  margin-top: 0px;
                  margin-bottom: 0px;
                  }
                  #masterControlBadges{
                  padding: 8px 8px;
                  font-size: 18px;
                  font-weight: 700;
                  width: 175px;
                  border: 2px solid black;
                  border-radius: 5px;
                  }
                  #masterTimingBadges{
                  padding: 8px 8px;
                  font-size: 18px;
                  font-weight: 700;
                  background-color: var(--main-sun-color);
                  color: black; 
                  width: 175px;
                  border: 2px solid black;
                  border-radius: 5px;
                  }
                  #voice1SliderDiv{
                      
                  }
                  #voice2SliderDiv{

                  }
                  #voice3SliderDiv{
                      
                  }
                  #voice4SliderDiv{
                     
                  }
                  #timingSliderDiv{
                  
                  }
                  #daySliderDiv{

                  }
                  #sliders1{
                  margin-top: 20px;
                  }
                  #sliders2{
                  margin-top: 20px;
                  }
                  #sliders3{
                  margin-top: 20px;
                  }
                  #sliders4{
                  margin-top: 20px;
                  }
                  #sliders5{
                  margin-top: 20px;
                  }
                  #playButtonDiv{
                  margin-top: 20px;       
                  }
                  #slidersTiming{
                  margin-top: 20px;      
                  }
            /* BADGES                      */
                  .voice1Badge{
                  background: var(--main-heading-color);
                  color: black;
                  }
                  .voice2Badge{
                  background: var(--main-heading-color);
                  color: black;   
                  }
                  .voice3Badge{
                  background: var(--main-heading-color);
                  color: black;     
                  }
                  .voice4Badge{
                  background: var(--main-heading-color);
                  color: black; 
                  }
            /* AMBIANCE BUTTONS            */
                  #ambienceBtnLocation{
                  max-width: 1200px;
                  margin: auto;
                  /*margin-top: 120px;*/
                  margin-bottom: 0px;
                  }
                  #ambienceBtns{
                  width: 180px;
                  border-radius: 5px;
                  font-size: 20px;
                  font-weight: 700;      
                  }
                  #ambienceBtn1Div{
                  
                  }
                  #ambienceBtn2Div{
                  
                  }
                  #ambienceBtn3Div{
                  
                  }
                  #ambienceBtn4Div{
                  
                  }
                  #ambienceSlider{
                  margin-top: 20px;
                  marker-left: 20px;
                  }
                  #ambienceBadges{
                  font-size: 22px;
                  background-color:#1ED7FF;
                  color: black; 
                  }
            /* INSTRUMENT 1 RANGER         */
                  input[class="instrument1Ranger"] {
                  -webkit-appearance: none;
                  background: var(--main-heading-color);
                  height: 10px;
                  width: 165px;
                  border-radius: 20px;
                  margin: auto;
                  transform: rotateY(180deg);
                  }
                  input[class="instrument1Ranger"]::-moz-range-track{
                  -webkit-appearance: none;
                  background: var(--main-heading-color);
                  height: 10px;
                  width: 165px;
                  border-radius: 20px;
                  margin: auto;
                  transform: rotateY(180deg);
                  }
                  input[class="instrument1Ranger"]::-webkit-slider-thumb{
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-heading-color);
                  border: 2px solid #00001E;
                  }

                  input[class="instrument1Ranger"]::-moz-range-thumb{
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-heading-color);
                  border: 2px solid #00001E;
                  }
            /* INSTRUMENT 2 RANGER         */
                  input[class="instrument2Ranger"] {
                  -webkit-appearance: none;
                  background: var(--main-heading-color);
                  height: 10px;
                  width: 165px;
                  border-radius: 20px;
                  margin: auto;
                  transform: rotateY(180deg);
                  }
                  input[class="instrument2Ranger"]::-moz-range-track{
                  -webkit-appearance: none;
                  background: var(--main-heading-color);
                  height: 10px;
                  width: 165px;
                  border-radius: 20px;
                  margin: auto;
                  transform: rotateY(180deg);
                  }
                  input[class="instrument2Ranger"]::-webkit-slider-thumb {
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-heading-color);
                  border: 2px solid #00001E;
                  }
                  input[class="instrument2Ranger"]::-moz-range-thumb{
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-heading-color);
                  border: 2px solid #00001E;
                  }
            /* INSTRUMENT 3 RANGER         */
                  input[class="instrument3Ranger"] {
                  -webkit-appearance: none;
                  background: var(--main-heading-color);
                  height: 10px;
                  width: 165px;
                  border-radius: 20px;
                  margin: auto;
                  transform: rotateY(180deg);
                  }
                  input[class="instrument3Ranger"]::-moz-range-track{
                  -webkit-appearance: none;
                  background: var(--main-heading-color);
                  height: 10px;
                  width: 165px;
                  border-radius: 20px;
                  margin: auto;
                  transform: rotateY(180deg);
                  }
                  input[class="instrument3Ranger"]::-webkit-slider-thumb {
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-heading-color);
                  border: 2px solid #00001E;
                  }
                  input[class="instrument3Ranger"]::-moz-range-thumb{
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-heading-color);
                  border: 2px solid #00001E;
                  }
            /* INSTRUMENT 4 RANGER         */
                  input[class="instrument4Ranger"] {
                  -webkit-appearance: none;
                  background: var(--main-heading-color);
                  height: 10px;
                  width: 165px;
                  border-radius: 20px;
                  margin: auto;
                  transform: rotateY(180deg);
                  }
                  input[class="instrument4Ranger"]::-moz-range-track{
                  -webkit-appearance: none;
                  background: var(--main-heading-color);
                  height: 10px;
                  width: 165px;
                  border-radius: 20px;
                  margin: auto;
                  transform: rotateY(180deg);
                  }
                  input[class="instrument4Ranger"]::-webkit-slider-thumb {
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-heading-color);
                  border: 2px solid #00001E;
                  }
                  input[class="instrument4Ranger"]::-moz-range-thumb{
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-heading-color);
                  border: 2px solid #00001E;
                  }
            /* TIMING RANGER               */
                  input[class="timingRanger"] {
                  -webkit-appearance: none;
                  background-color: var(--main-sun-color);
                  height: 10px;
                  width: 165px;
                  border-radius: 20px;
                  margin: auto;
                  }

                  input[class="timingRanger"]::-webkit-slider-thumb {
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-sun-color);
                  border: 2px solid #00001E;
                  }

                  input[class="timingRanger"]::-moz-range-track{
                  -webkit-appearance: none;
                  background-color: var(--main-sun-color);
                  height: 10px;
                  width: 165px;
                  border-radius: 20px;
                  margin: auto;
                  }

                  input[class="timingRanger"]::-moz-range-thumb{
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-sun-color);
                  border: 2px solid #00001E;
                  }
            /* DAY RANGER                  */
                  input[class="dayRanger"] {
                  -webkit-appearance: none;
                  background-color: var(--main-time-color);
                  height: 10px;
                  width: 165px;
                  border-radius: 20px;
                  margin: auto;
                  }

                  input[class="dayRanger"]::-webkit-slider-thumb {
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-time-color);
                  border: 2px solid #00001E;
                  }

                  input[class="dayRanger"]::-moz-range-track{
                  -webkit-appearance: none;
                  background-color: var(--main-time-color);
                  height: 10px;
                  width: 165px;
                  border-radius: 20px;
                  margin: auto;
                  }

                  input[class="dayRanger"]::-moz-range-thumb{
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-time-color);
                  border: 2px solid #00001E;
                  }
            /* AMBIANCE RANGER STOPPED     */
                  input[class="ambianceRangerStop"] {
                  -webkit-appearance: none;
                  background-color: var(--main-stop-color);
                  height: 10px;
                  width: 180px;
                  border-radius: 20px;
                  margin: auto;
                  }

                  input[class="ambianceRangerStop"]::-webkit-slider-thumb {
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-stop-color);
                  border: 2px solid #00001E;
                  }
                  input[class="ambianceRangerStop"]::-moz-range-track{
                  -webkit-appearance: none;
                  background-color: var(--main-stop-color);
                  height: 10px;
                  width: 180px;
                  border-radius: 20px;
                  margin: auto;
                  }
                  input[class="ambianceRangerStop"]::-moz-range-thumb{
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-stop-color);
                  border: 2px solid #00001E;
                  }
            /* AMBIANCE RANGER PLAYING     */
                  input[class="ambianceRangerPlay"] {
                  -webkit-appearance: none;
                  background-color: var(--main-start-color);
                  height: 10px;
                  width: 180px;
                  border-radius: 20px;
                  margin: auto;
                  }

                  input[class="ambianceRangerPlay"]::-webkit-slider-thumb {
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-start-color);
                  border: 2px solid #00001E;
                  }  

                  input[class="ambianceRangerPlay"]::-moz-range-track{
                  -webkit-appearance: none;
                  background-color: var(--main-start-color);
                  height: 10px;
                  width: 180px;
                  border-radius: 20px;
                  margin: auto;
                  }

                  input[class="ambianceRangerPlay"]::-moz-range-thumb{
                  -webkit-appearance: none;
                  position: relative;
                  top: 0px;
                  z-index: 1;
                  width: 40px;
                  height: 40px;
                  cursor: pointer;
                  -webkit-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  -moz-box-shadow: 0px 6px 5px 0px rgba(0, 0, 0, 0.6);
                  box-shadow: 0px 8px 10px 1px rgba(0, 0, 0, 0.6);
                  -webkit-border-radius: 40px;
                  -moz-border-radius: 40px;
                  border-radius: 40px;
                  background: var(--main-start-color);
                  border: 2px solid #00001E;
                  }  
            /* MAILING LIST                */
                  #mailingListText{
                  margin: auto;
                  max-width: 250px;
                  margin-top: 90px;
                  margin-bottom: 0px;
                  font-size: 20px;  
                  font-weight: 600;    
                  }
                  #mc_embed_signup{
                  background:#fff; 
                  font-size:16px; 
                  width:100%;
                  border-color: black;
                  background-color: transparent;
                  }
                  #mce-EMAIL{
                  font-size:16px; 
                  padding: 4px 10px;
                  margin-top: 0px;  
                  font-weight: 800;
                  width: 250px;
                  border-width: 3px;
                  border-radius: 10px;
                  background-color: transparent;
                  border-color: black;
                  }
                  #mc-embedded-subscribe{
                  font-size:16px; 
                  padding: 2px 10px;
                  margin-top: 4px;
                  font-weight: 800;
                  border-width: 3px;
                  border-radius: 10px;
                  background-color: transparent;
                  border-color: black;
                  }    
      }
/** BOOTSTRAP BUTTON COLORS    */
      .btn-danger {
          color: white;
      } 
      /*INFO*/
      .btn-info {
      color: black;
      background-color: var(--main-heading-color);
      border-color:  transparent;
      border-width: 2px;
      }

      .btn-info,
      .btn-info:hover, 
      .btn-info:focus, 
      .btn-info:active, 
      .btn-info.active, 
      .btn-info:active:focus,
      .btn-info:active:hover,
      .open>.dropdown-toggle.btn-info {
      color: black;
      background-color:  var(--main-heading-color);
      border-width: 2px;
      border-color: transparent;
      }

      /*SUCCESS*/
      .btn-success {
      color: #fff;
      background-color: var(--main-start-color);
      border-color: var(--main-start-color);;
      border-width: 2px;
      }
      .btn-success,
      .btn-success:hover, 
      .btn-success:focus, 
      .btn-success:active, 
      .btn-success.active, 
      .btn-success:active:focus
      .open>.dropdown-toggle.btn-success {
      color: black;
      background-color: var(--main-start-color);
      border-color: var(--main-start-color);; 
      border-width: 2px;
      }

      /*WARNING*/
      .btn-warning {
      color: #fff;
      background-color: #FFB817;
      border-color: #FFB817; 
      }
      .btn-warning,
      .btn-warning:hover, 
      .btn-warning:focus, 
      .btn-warning:active, 
      .btn-warning:active:focus
      .btn-warning.active, 
      .open>.dropdown-toggle.btn-warning {
      color: white;
      background-color: #FFB817;
      border-color: #FFB817; 
      }

      /*DANGER*/
      .btn-danger {
      color: #fff;
      background-color: var(--main-stop-color);
      border-color: var(--main-stop-color); 
      border-width: 2px;
      }
      .btn-danger,
      .btn-danger:hover, 
      .btn-danger:focus, 
      .btn-danger:active, 
      .btn-danger.active,
      .btn-danger:active:focus 
      .open>.dropdown-toggle.btn-danger {
      color: white;
      background-color: var(--main-stop-color);
      border-color: var(--main-stop-color); 
      border-width: 2px;
      }

      /*PRIMARY*/
      .btn-primary {
      color: #fff;
      background-color: #9776FF;
      border-color: #9776FF; 
      }
      .btn-primary,
      .btn-primary:hover, 
      .btn-primary:focus, 
      .btn-primary:active, 
      .btn-primary.active, 
      .btn-primary:active:focus
      .open>.dropdown-toggle.btn-primary {
      color: white;
      background-color: #9776FF;
      border-color: #9776FF; 
      }   

      /*ACCENT*/
      .btn-accent {
      color: #fff;
      background-color: #6B8CFF;
      border-color: #6B8CFF; 
      }
      .btn-accent,
      .btn-accent:hover, 
      .btn-accent:focus, 
      .btn-accent:active, 
      .btn-accent.active, 
      .btn-accent:active:focus
      .open>.dropdown-toggle.btn-accent {
      color: white;
      background-color: #6B8CFF;
      border-color: #6B8CFF; 
      }   

      /*BLACK AND WHITE*/
      .btn-blackwhite {
      color: white;
      background-color: black;
      border-color: white; 
      }
      .btn-blackwhite,
      .btn-blackwhite:hover, 
      .btn-blackwhite:focus, 
      .btn-blackwhite:active, 
      .btn-blackwhite.active, 
      .btn-blackwhite:active:focus
      .open>.dropdown-toggle.btn-blackwhite {
      color: white;
      background-color: black;
      border-color: white; 
      }   

      /*BLACK AND WHITE NEGATIVE*/
      .btn-blackwhiteneg {
      color: black;
      background-color: #FFB817;
      border-color: #FFB817; 
      }
      .btn-blackwhiteneg,
      .btn-blackwhiteneg:hover, 
      .btn-blackwhiteneg:focus, 
      .btn-blackwhiteneg:active, 
      .btn-blackwhiteneg.active, 
      .btn-blackwhiteneg:active:focus
      .open>.dropdown-toggle.btn-blackwhiteneg {
      color: black;
      background-color: #FFB817;
      border-color: #FFB817; 
      }   

      /*TRANSPARENT*/
      .btn-transparent {
      color: white;
      background-color: black;
      border-color: white;
      border-width: 2px; 
      }
      .btn-transparent,
      .btn-transparent:hover, 
      .btn-transparent:focus, 
      .btn-transparent:active, 
      .btn-transparent.active, 
      .btn-transparent:active:focus
      .open>.dropdown-toggle.btn-transparent {
      color: white;
      background-color: black;
      border-color: white; 
      border-width: 2px;
      } 

      /*TRANSPARENT*/
      .btn-hornButtonClass {
      color: white;
      background-color: transparent;
      border-color: transparent;
      border-width: 2px; 
      }
      .btn-hornButtonClass,
      .btn-hornButtonClass:hover, 
      .btn-hornButtonClass:focus, 
      .btn-hornButtonClass:active, 
      .btn-hornButtonClass.active, 
      .btn-hornButtonClass:active:focus
      .open>.dropdown-toggle.btn-hornButtonClass {
      color: white;
      background-color: transparent;
      border-color: transparent; 
      border-width: 2px;
      } 

      /*TRANSPARENT*/
      .btn-hornButtonClass2 {
      color: white;
      background-color: transparent;
      border-color: #F0CB50;
      border-width: 2px; 
      }
      .btn-hornButtonClass2,
      .btn-hornButtonClass2:hover, 
      .btn-hornButtonClass2:focus, 
      .btn-hornButtonClass2:active, 
      .btn-hornButtonClass2.active, 
      .btn-hornButtonClass2:active:focus
      .open>.dropdown-toggle.btn-hornButtonClass2 {
      color: white;
      background-color: transparent;
      border-color: #F0CB50; 
      border-width: 2px;
      } 
/** STYLINGS FOR TRANSITIONS */
        .animated.rubberBand {
          -webkit-animation-duration: 1.5s;
             -moz-animation-duration: 1.5s;
              -ms-animation-duration: 1.5s;
               -o-animation-duration: 1.5s;
                  animation-duration: 1.5s;
        }
        .animated.rollOut {
          -webkit-animation-duration: .75s;
             -moz-animation-duration: .75s;
              -ms-animation-duration: .75s;
               -o-animation-duration: .75s;
                  animation-duration: .75s;
        }
        .animated.pulse {
          -webkit-animation-duration: .5s;
             -moz-animation-duration: .5s;
              -ms-animation-duration: .5s;
               -o-animation-duration: .5s;
                  animation-duration: .5s;
        }
        .animated.hinge {
          -webkit-animation-duration: 1.75s;
             -moz-animation-duration: 1.75s;
              -ms-animation-duration: 1.75s;
               -o-animation-duration: 1.75s;
                  animation-duration: 1.75s;
        }
        .animated.fadeOut {
          -webkit-animation-duration: .2s;
             -moz-animation-duration: .2s;
              -ms-animation-duration: .2s;
               -o-animation-duration: .2s;
                  animation-duration: .2s;
        }
        .animated.fadeIn {
          -webkit-animation-duration: 4s;
             -moz-animation-duration: 4s;
              -ms-animation-duration: 4s;
               -o-animation-duration: 4s;
                  animation-duration: 4s;
        }
        

          .fade-enter {
            opacity: 0;
          }

          .fade-enter-active {
            transition: opacity .5s; 
          }

          .fade-leave {
          }

          .fade-leave-active {
            transition: opacity .5s; 
            opacity: 0;
          }
/** COUNTER SPIN FONT AWESOME */
    .slow-spin {
        -webkit-animation: fa-spin 6s infinite linear;
        animation: fa-spin 6s infinite linear;
      }
    .fa-counter-spin {
      -webkit-animation: spin-counter .5s infinite linear;
      -moz-animation: spin-counter .5s infinite linear;
      -o-animation: spin-counter .5s infinite linear;
      animation: spin-counter .5s infinite linear;
    }
    @-moz-keyframes spin-counter {
      0% {
        -moz-transform: rotate(359deg);
      }
      100% {
        -moz-transform: rotate(0deg);
      }
    }
    @-webkit-keyframes spin-counter {
      0% {
        -webkit-transform: rotate(359deg);
      }
      100% {
        -webkit-transform: rotate(0deg);
      }
    }
    @-o-keyframes spin-counter {
      0% {
        -o-transform: rotate(359deg);
      }
      100% {
        -o-transform: rotate(0deg);
      }
    }
    @-ms-keyframes spin-counter {
      0% {
        -ms-transform: rotate(359deg);
      }
      100% {
        -ms-transform: rotate(0deg);
      }
    }
    @keyframes spin-counter {
      0% {
        transform: rotate(359deg);
      }
      100% {
        transform: rotate(0deg);
      }
    }

</style>

<!-- <style lang="scss">
</style> -->





// WEBPACK FOOTER //
// App.vue?83fed90c